import { I18N_KEYS } from './keys';

const EN_TEXT = {
  [I18N_KEYS.COMPOSITOR.IMAGE_FILL.CONVERT_TO_SHAPE]: 'Convert to shape',
  [I18N_KEYS.COMPOSITOR.IMAGE_FILL.PERSPECTIVE]: 'Perspective',

  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.JUST_NOW]: 'Just now',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.GENERATING]: 'Generating outputs',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.FAILED_TITLE]: 'Something went wrong',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.FAILED_MESSAGE]: 'We couldn’t generate this for some reason.',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.DOWNLOAD]: 'Download {{name}}',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.DOWNLOAD_ALL]: 'Download all',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.EXPAND]: 'Expand {{name}}',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.MORE]: 'More options for {{name}}',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.REMOVE]: 'Remove',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.MORE_BATCH]: 'More options for these outputs',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.REMOVE_ALL]: 'Remove all',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.REMOVE_UNAVAILABLE]: 'These outputs cannot be removed.',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.REMOVE_FAILED]: 'Couldn’t remove. Try again.',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.IMAGE]: 'Image',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.VIDEO]: 'Video',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.AUDIO]: 'Audio',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.THREE_D]: '3D model',
  [I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY.TEXT]: 'Text',

  [I18N_KEYS.WORKSHOP_PAGE.TITLE]: 'Welcome to Weavy',
  [I18N_KEYS.WORKSHOP_PAGE.SIGN_IN]: 'Sign in to get started',
  [I18N_KEYS.WORKSHOP_PAGE.SIGN_IN_INTRO]:
    'Let’s create something together. Sign in to your Weavy account to join the workshop.',
  [I18N_KEYS.WORKSHOP_PAGE.INTRO]: 'Let’s create something together. Enter your workshop code to get started.',
  [I18N_KEYS.WORKSHOP_PAGE.JOINING_AS]: 'You’re joining as {{email}}.',
  [I18N_KEYS.WORKSHOP_PAGE.CODE_LABEL]: 'Workshop code',
  [I18N_KEYS.WORKSHOP_PAGE.SUBMIT]: 'Get started',
  [I18N_KEYS.WORKSHOP_PAGE.PENDING]: 'Getting things ready…',
  [I18N_KEYS.WORKSHOP_PAGE.SUCCESS]: 'You’re all set. Thanks for joining us!',
  [I18N_KEYS.WORKSHOP_PAGE.ALREADY_GRANTED]: 'You’ve already received your promo credits.',
  [I18N_KEYS.WORKSHOP_PAGE.START_CREATING]: 'Start creating',
  [I18N_KEYS.WORKSHOP_PAGE.INVALID_CODE]: 'This workshop is closed or the code is incorrect.',
  [I18N_KEYS.WORKSHOP_PAGE.SESSION_EXPIRED]: 'Your session has expired. Please sign in again.',
  [I18N_KEYS.WORKSHOP_PAGE.CLAIM_FAILED]: 'We couldn’t finish getting things ready. Please try again.',

  [I18N_KEYS.COMMON_COMPONENTS.COLOR_PICKER.COLOR_AREA_ARIA]: 'Color area',
  [I18N_KEYS.COMMON_COMPONENTS.COLOR_PICKER.EYEDROPPER_ARIA]: 'Pick a color from the screen',
  [I18N_KEYS.COMMON_COMPONENTS.COLOR_PICKER.HUE_ARIA]: 'Hue',
  [I18N_KEYS.COMMON_COMPONENTS.COLOR_PICKER.OPACITY_ARIA]: 'Opacity',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TOGGLE_BUTTON.ARIA]: 'Billing cycle',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.ARIA]: 'Education content',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TOOLBAR_ARIA]: 'Workflow tools',
  [I18N_KEYS.RECIPE_MAIN.FLOW.EDITOR_MODE_ARIA]: 'Workflow editor mode',
  [I18N_KEYS.RECIPE_MAIN.NODES.MASKS.DISPLAY_ARIA]: 'Mask display',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.HORIZONTAL_TEXT_ALIGNMENT]: 'Horizontal text alignment',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.VERTICAL_TEXT_ALIGNMENT]: 'Vertical text alignment',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.TOOLS_ARIA]: 'Painter tools',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.CANVAS_ARIA]: 'Canvas',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.BRUSH_ARIA]: 'Brush',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.SHAPE_ARIA]: 'Shape',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.ERASER_ARIA]: 'Eraser',
  [I18N_KEYS.DASHBOARD.VIEW_LAYOUT.ARIA]: 'View layout',
  [I18N_KEYS.DASHBOARD.VIEW_LAYOUT.LIST_ARIA]: 'List view',
  [I18N_KEYS.DASHBOARD.VIEW_LAYOUT.GRID_ARIA]: 'Grid view',
  [I18N_KEYS.COMMON_COMPONENTS.PROGRESS.DEFAULT_ARIA]: 'progress',
  [I18N_KEYS.COMMON_COMPONENTS.PROGRESS.UPLOAD_ARIA]: 'Upload progress',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.START]: 'Dictate',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.STOP]: 'Stop and transcribe',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.CANCEL]: 'Cancel',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.TRANSCRIBING]: 'Transcribing…',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.LISTENING]: 'Listening…',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.RECORDING]: 'Recording',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.MIC_BLOCKED]:
    'Microphone access is blocked. Allow it in your browser settings to dictate.',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.MIC_UNAVAILABLE]: 'Couldn’t access a microphone.',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.FAILED]: 'Couldn’t transcribe your recording. Please try again.',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.NO_SPEECH]: 'No speech detected.',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.TOO_SHORT]: 'Recording was too short. Speak for at least a second.',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.PLAN_REQUIRED]: 'Upgrade to Pro to use dictation',
  [I18N_KEYS.COMMON_COMPONENTS.VOICE_DICTATION.RATE_LIMITED]:
    "You've reached the dictation limit for now. Try again in a little while.",
  [I18N_KEYS.FIGMA_EMBED.ANONYMOUS_VIEWER_TOOLTIP]: 'Anonymous',
  [I18N_KEYS.FIGMA_EMBED.ANONYMOUS_VIEWER_SIGN_UP]: 'Sign up',
  [I18N_KEYS.FIGMA_EMBED.BETA_BADGE]: 'Beta',
  [I18N_KEYS.ACTIONS_BAR.NAVIGATE_ARIA]: 'Navigate',
  [I18N_KEYS.ACTIONS_BAR.PAN_ARIA]: 'Pan',
  [I18N_KEYS.ACTIONS_BAR.STICKY_NOTE_ARIA]: 'Sticky note',
  [I18N_KEYS.ACTIONS_BAR.COMMENTS_ARIA]: 'Comments',
  [I18N_KEYS.ACTIONS_BAR.SHAPES_MENU_ARIA]: 'Shapes menu',
  [I18N_KEYS.ACTIONS_BAR.TEXT_ARIA]: 'Add text',
  [I18N_KEYS.ACTIONS_BAR.VECTOR_ARIA]: 'Pen tool',
  [I18N_KEYS.ACTIONS_BAR.PEN_INTRO_TITLE]: 'Introducing the Pen Tool',
  [I18N_KEYS.ACTIONS_BAR.PEN_INTRO_CONTENT]:
    'Create any shape you can imagine. The Pen Tool gives you full control over anchor points and curves.',
  [I18N_KEYS.ACTIONS_BAR.PEN_INTRO_CTA]: 'Try it',
  [I18N_KEYS.ACTIONS_BAR.INSERT_IMAGE_ARIA]: 'Insert image, video or audio',
  [I18N_KEYS.ACTIONS_BAR.INSERT_IMAGE_ONLY_ARIA]: 'Insert image',
  [I18N_KEYS.ACTIONS_BAR.TOOLS_ARIA]: 'Tools',
  [I18N_KEYS.ACTIONS_BAR.ZOOM_MENU_ARIA]: 'Zoom menu',

  [I18N_KEYS.AGENT_CHAT.COMPOSER.INPUT_ARIA]: 'Message',
  [I18N_KEYS.AGENT_CHAT.COMPOSER.PLACEHOLDER_NEW]: 'Describe what you want to create',
  [I18N_KEYS.AGENT_CHAT.COMPOSER.PLACEHOLDER_REPLY]: 'Ask for changes',
  [I18N_KEYS.AGENT_CHAT.COMPOSER.SEND_ARIA]: 'Send message',
  [I18N_KEYS.AGENT_CHAT.COMPOSER.STOP_ARIA]: 'Stop response',
  [I18N_KEYS.AGENT_CHAT.COMPOSER.ATTACH_ARIA]: 'Attach files',
  [I18N_KEYS.AGENT_CHAT.COMPOSER.SELECTION_COUNT]: '{{count}} selected',
  [I18N_KEYS.AGENT_CHAT.COMPOSER.SELECTION_FALLBACK]: 'Node',
  [I18N_KEYS.AGENT_CHAT.COMPOSER.SELECTION_DISMISS_ARIA]: 'Remove selection from context',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.ROW_ARIA]: 'Attachments',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.REMOVE_ARIA]: 'Remove {{name}}',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.DROP_TITLE]: 'Upload attachments',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.DROP_DESCRIPTION]: 'Add visual context, upload images or screenshots to reference',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.TOO_MANY]: 'You can attach up to {{max}} files per message',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.DOCUMENT_TOO_LARGE]:
    '{{name}} is too large. Text files can be up to 10 MB and PDFs up to 20 MB',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.UNSUPPORTED]: '{{name}} isn’t a supported file type',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.TYPE_VIDEO]: 'Video',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.TYPE_AUDIO]: 'Audio',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.TYPE_3D]: '3D',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.TYPE_FILE]: 'File',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.SCROLL_BACK_ARIA]: 'Show previous attachments',
  [I18N_KEYS.AGENT_CHAT.ATTACHMENTS.SCROLL_FORWARD_ARIA]: 'Show more attachments',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.PANEL_ARIA]: 'AI conversation',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.UNTITLED]: 'New chat',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.BACK_ARIA]: 'All chats',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.BETA]: 'Beta',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.NEW_ARIA]: 'New chat',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.WELCOME]: 'What do you want to do today?',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.LOADING]: 'Loading conversation…',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.LOG_ARIA]: 'Conversation messages',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.INTERRUPTED]: 'Run interrupted',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.THINKING]: 'Thinking...',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.RESUME_ERROR]: 'Unable to load this chat. Try again, or start a new chat.',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.REPLY_ERROR]: 'Unable to finish this response. Please try again.',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.COPY_PROMPT_ARIA]: 'Copy prompt',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.ELEMENT_CHIP_DESCRIPTION]: 'Select on canvas',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.PROMPT_COPIED_ARIA]: 'Prompt copied',
  [I18N_KEYS.AGENT_CHAT.CONVERSATION.DRAG_PROMPT_TO_CANVAS]: 'Drag to canvas',
  [`${I18N_KEYS.AGENT_CHAT.RUN_CARD.CREDITS}_one`]: '{{count}} credit',
  [`${I18N_KEYS.AGENT_CHAT.RUN_CARD.CREDITS}_other`]: '{{count}} credits',
  [I18N_KEYS.AGENT_CHAT.RUN_CARD.RUN]: 'Run',
  [I18N_KEYS.AGENT_CHAT.RUN_CARD.STARTED]: 'Started',
  [I18N_KEYS.AGENT_CHAT.RUN_CARD.CANCELED]: 'Canceled',
  [I18N_KEYS.AGENT_CHAT.RUN_CARD.SHOW_NODES_ARIA]: 'Nodes to run',
  [I18N_KEYS.AGENT_CHAT.QUESTION_CARD.OWN_RESPONSE]: 'Add your own response',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.READING_FILE]: 'Reading file',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.SEARCHING_FILES]: 'Searching files',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.EDITING_FILE]: 'Editing file',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.RUNNING_COMMAND]: 'Running command',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.LOADING_SKILL]: 'Loading skill',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.FINDING_MODEL]: 'Finding a model',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.BROWSING_TOOLS]: 'Browsing tools',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.CHECKING_TOOL_INPUTS]: 'Checking tool inputs',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.RUNNING_MODEL]: 'Running model',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.RUNNING_TOOL]: 'Running tool',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.CHECKING_RESULTS]: 'Checking results',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.CANCELLING_RUN]: 'Cancelling run',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.UPLOADING_ASSET]: 'Uploading asset',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.READING_WORKFLOW]: 'Reading workflow',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.BUILDING_WORKFLOW]: 'Building workflow',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.BROWSING_NODES]: 'Browsing nodes',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.CHECKING_PRICE]: 'Checking price',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.WORKING]: 'Working',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.WORKED_FOR]: 'Worked for {{duration}}',
  [I18N_KEYS.AGENT_CHAT.TOOL_CALL.WORKED]: 'Worked',
  [I18N_KEYS.AGENT_CHAT.HISTORY.PANEL_ARIA]: 'Chat history',
  [I18N_KEYS.AGENT_CHAT.HISTORY.TITLE]: 'Chats',
  [I18N_KEYS.AGENT_CHAT.HISTORY.NEW_ARIA]: 'New chat',
  [I18N_KEYS.AGENT_CHAT.HISTORY.SEARCH]: 'Search chat history',
  [I18N_KEYS.AGENT_CHAT.HISTORY.LOAD_ERROR]: 'Unable to load your chats.',
  [I18N_KEYS.AGENT_CHAT.HISTORY.LOADING]: 'Loading conversations…',
  [I18N_KEYS.AGENT_CHAT.HISTORY.EMPTY]: 'No conversations yet',
  [I18N_KEYS.AGENT_CHAT.HISTORY.NO_RESULTS]: 'No conversations found',
  [I18N_KEYS.AGENT_CHAT.HISTORY.NO_RESULTS_ON_PAGE]: 'No matches in your recent chats.',
  [I18N_KEYS.AGENT_CHAT.HISTORY.ROW_MENU_ARIA]: 'More options for {{title}}',
  [I18N_KEYS.AGENT_CHAT.HISTORY.RENAME]: 'Rename chat',
  [I18N_KEYS.AGENT_CHAT.HISTORY.RENAME_ARIA]: 'Rename {{title}}',
  [I18N_KEYS.AGENT_CHAT.HISTORY.DELETE]: 'Delete chat',
  [I18N_KEYS.AGENT_CHAT.HISTORY.GROUP_ALL]: 'Conversations',
  [I18N_KEYS.AGENT_CHAT.HISTORY.GROUP_TODAY]: 'Today',
  [I18N_KEYS.AGENT_CHAT.HISTORY.GROUP_THIS_WEEK]: 'This week',
  [I18N_KEYS.AGENT_CHAT.HISTORY.GROUP_EARLIER]: 'Earlier',
  [I18N_KEYS.AGENT_CHAT.HISTORY.AGE_NOW]: 'Now',
  [I18N_KEYS.AGENT_CHAT.HISTORY.AGE_MINUTES]: '{{count}}m',
  [I18N_KEYS.AGENT_CHAT.HISTORY.AGE_HOURS]: '{{count}}h',
  [I18N_KEYS.AGENT_CHAT.HISTORY.AGE_DAYS]: '{{count}}d',
  [I18N_KEYS.AGENT_CHAT.HISTORY.AGE_WEEKS]: '{{count}}w',
  [I18N_KEYS.AGENT_CHAT.HISTORY.NO_MESSAGES]: 'No messages yet',
  [`${I18N_KEYS.AGENT_CHAT.HISTORY.MESSAGE_COUNT}_one`]: '{{count}} message',
  [`${I18N_KEYS.AGENT_CHAT.HISTORY.MESSAGE_COUNT}_other`]: '{{count}} messages',
  [I18N_KEYS.AGENT_CHAT.RECENT_CHATS.TITLE]: 'Latest chats',
  [I18N_KEYS.AGENT_CHAT.RECENT_CHATS.ALL_ARIA]: 'All chats',
  [I18N_KEYS.AGENT_CHAT.RECENT_CHATS.NEW_ARIA]: 'New chat',
  [I18N_KEYS.AGENT_CHAT.RECENT_CHATS.LOADING]: 'Loading chats…',
  [I18N_KEYS.AGENT_CHAT.RECENT_CHATS.EMPTY]: 'No conversations yet',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.ARIA]: 'Suggested prompts',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CREATE]: 'Create workflow',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CREATE_SOCIAL]: 'Create social content',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CREATE_SOCIAL_PROMPT]:
    'Create a workflow that turns a product brief into on-brand social media images and captions.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CREATE_VIDEO]: 'Make a product video',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CREATE_VIDEO_PROMPT]:
    'Create a workflow for a short product video, starting from a product image and a description.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CREATE_VARIATIONS]: 'Explore visual variations',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CREATE_VARIATIONS_PROMPT]:
    'Create a workflow that generates several visual variations from one reference image and prompt.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.PROMPTS]: 'Enhance my prompts',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.PROMPTS_CLARITY]: 'Make prompts clearer',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.PROMPTS_CLARITY_PROMPT]:
    'Review the prompts in my workflow and make them clearer and more specific while preserving their intent.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.PROMPTS_STYLE]: 'Align the visual style',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.PROMPTS_STYLE_PROMPT]:
    'Improve the prompts in my workflow so they produce a consistent visual style, lighting, and color palette.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.PROMPTS_DETAILS]: 'Add useful details',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.PROMPTS_DETAILS_PROMPT]:
    'Suggest useful details for the prompts in my workflow, including composition, subject, and mood.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CLEANUP]: 'Clean up my canvas',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CLEANUP_NOTES]: 'Add read-me notes',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CLEANUP_NOTES_PROMPT]:
    'Add read-me notes to my workflow explaining what each section does and how to use it.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CLEANUP_SECTIONS]: 'Group and name sections',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CLEANUP_SECTIONS_PROMPT]:
    'Group related nodes into sections and give each section a clear, descriptive name.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CLEANUP_OUTPUTS]: 'Rename and file all outputs',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CLEANUP_OUTPUTS_PROMPT]:
    'Rename the outputs in my workflow with descriptive names and organize them by purpose.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CLEANUP_UNUSED]: 'Delete unused nodes',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.CLEANUP_UNUSED_PROMPT]:
    'Find nodes that are unused in my workflow and remove them while keeping the active workflow intact.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.LEARN]: 'Teach me Weave',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.LEARN_EXPLAIN]: 'Explain this workflow',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.LEARN_EXPLAIN_PROMPT]:
    'Walk me through this workflow, explaining what each section does and how the nodes connect.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.LEARN_CONNECT]: 'Learn how nodes connect',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.LEARN_CONNECT_PROMPT]:
    'Explain how to connect nodes in Weave, with a simple example of passing an image from one node to another.',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.LEARN_MODELS]: 'Help me choose a model',
  [I18N_KEYS.AGENT_CHAT.SUGGESTIONS.LEARN_MODELS_PROMPT]:
    'Explain how to choose a model for an image or video workflow in Weave and which tradeoffs to consider.',
  [I18N_KEYS.COMMON_COMPONENTS.COPYRIGHT]: '© 2026 Figma Weave. All rights reserved.',
  [I18N_KEYS.COMMON_COMPONENTS.COUNTER.DECREMENT_ARIA]: 'Decrement',
  [I18N_KEYS.COMMON_COMPONENTS.COUNTER.INCREMENT_ARIA]: 'Increment',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.CTA]: 'Drag & drop or click to upload',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.UPLOAD_FILE]: 'Upload file',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.NO_PREVIEW]: 'No preview',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.OR]: 'Or',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.PASTE_LINK]: 'Paste a file link',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.REMOVE_FILE]: 'Remove File',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.REPLACE_FILE]: 'Click to replace',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.REPLACE]: 'Replace',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.ADD_FILE]: 'Drop to add',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.UPLOAD_FROM_LINK]: 'Upload from link',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.UNSUPPORTED_VIDEO_FORMAT]:
    'This video format is not supported by your browser.',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.VIDEO_FORMAT_UNSUPPORTED_IN_BROWSER]:
    'Video format {{format}} not supported in this browser',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.UPLOAD_ERROR]: 'Error uploading file',
  [I18N_KEYS.COMMON_COMPONENTS.NODE_IMAGE_LIST.NO_PREVIEW]: 'No Preview Available',
  [I18N_KEYS.COMMON_COMPONENTS.NODE_IMAGE_LIST.RESULT]: 'Result',
  [I18N_KEYS.COMMON_COMPONENTS.THREE_DEE_VIEWER.ERROR]: 'Error in Three.js boundary',
  [I18N_KEYS.COMMON_COMPONENTS.BASE_SELECT.NO_OPTIONS_TEXT]: 'No options available',
  [I18N_KEYS.COMMON_COMPONENTS.EXPENSIVE_RUN_MODAL.TITLE]: 'High cost run',
  [I18N_KEYS.COMMON_COMPONENTS.EXPENSIVE_RUN_MODAL.SUBTITLE]:
    'This run will cost <icon/><b>{{cost}} credits</b>.\nAre you sure you want to continue?',
  [I18N_KEYS.COMMON_COMPONENTS.EXPENSIVE_RUN_MODAL.CHECKBOX_LABEL]: "Don't show this again",
  [I18N_KEYS.COMMON_COMPONENTS.EXPENSIVE_RUN_MODAL.CTA_CONFIRM]: 'Confirm',
  [I18N_KEYS.COMMON_COMPONENTS.EXPENSIVE_RUN_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.TITLE + '_long']: 'Total cost',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.TITLE + '_short']: 'Total',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.CREDITS]: '{{count}} credits',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.CREDITS_PER_SECOND]: '{{count}} / sec',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.FREE_IN_BETA]: 'Free in beta',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.BETA_TOOLTIP_STATIC]:
    'While this feature is still in Beta, requests use 0 AI credits. Post Beta, this would use {{count}} AI credits.',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.BETA_TOOLTIP_DYNAMIC]:
    'While this feature is still in Beta, requests use 0 AI credits. Post Beta, this cost would be decided while the workflow runs.',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.PROMO_TOOLTIP]:
    'Costs {{price}} credits while in promotion. Afterward, will cost {{original}} credits.',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.PROMO_TOOLTIP_UNTIL]:
    'Costs {{price}} credits until {{date}}. Afterward, will cost {{original}} credits.',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.PROMO_BADGE]: '{{percent}}% off',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.PROMO_BADGE_UNTIL]: '{{percent}}% off until {{date}}',

  [I18N_KEYS.COMMON_COMPONENTS.MEDIA_BUFFERING]: 'Buffering',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.INPAINT]: 'Inpaint',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.INPAINT_PROMPT_PLACEHOLDER]: 'Describe what to generate in the masked area',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.BRUSH_SIZE]: 'Brush size',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.MASK_AREA]: 'Mask an area',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.MASK_AREA_AND_ADD_PROMPT]: 'Mask an area and add a prompt',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.ADD_PROMPT]: 'Add a prompt',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.SUBMIT]: 'Submit',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.CLEAR_MASK]: 'Clear mask',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.OUTPAINT]: 'Outpaint',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.OUTPAINT_PROMPT_PLACEHOLDER]:
    'Describe what to generate in the extended area (optional)',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.FIT_TO_IMAGE]: 'Fit to image',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.EXTEND_IMAGE]: 'Extend the image bounds to outpaint. A prompt is optional.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.DECOMPOSE_LAYER]: 'Split to layers',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.TOOLBAR_ARIA]: 'Image layer AI actions',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.NUMBER_OF_LAYERS]: 'Number of layers',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.RUN]: 'Split',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.RUNNING]: 'Decomposing…',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.SUCCESS]: 'Generated image layers added.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.SUCCEEDED]: '{{action}} succeeded',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.GO_TO_LAYER]: 'Go to layer',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.ERROR]: 'Could not complete generation.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.INVALID_COUNT]: 'Choose a valid number of layers.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.ERRORS.WORKFLOW_REQUIRED]: 'Open a saved workflow before generating.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.ERRORS.SOURCE_UNAVAILABLE]: 'The source image could not be resolved or rendered.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.ERRORS.SOURCE_NOT_UPLOADED]:
    'Upload the source image first so the model can access it.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.ERRORS.SOURCE_CHANGED]:
    'The source image changed or was removed. No generated layers were added.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.ERRORS.ALREADY_RUNNING]:
    'This layer already has a generation running. Wait before retrying.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.ERRORS.EMPTY_RESULT]: 'The model returned no image layers.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.ERRORS.INVALID_RESULT]:
    'The model returned an invalid image layer. No layers were added.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.ERRORS.APPLY_FAILED]:
    'Could not add the generated image layers. No layers were added.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.ERRORS.CANCELLATION_FAILED]:
    'Could not confirm cancellation. The job may still be running in the background.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.MODEL_ERRORS.FAILED]: 'Generation failed.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.MODEL_ERRORS.CANCELED]: 'Generation was canceled.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.MODEL_ERRORS.TIMEOUT]:
    'Timed out waiting. The model may still be running and may use credits. Check its status before retrying.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.MODEL_ERRORS.MISSING_PREDICTION]: 'The model did not return a prediction ID.',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.MODEL_ERRORS.PROVIDER]: 'Generation failed: {{message}}',
  [I18N_KEYS.COMPOSITOR.AI_ACTIONS.MODEL_ERRORS.PREDICTION]: '{{message}} (Prediction: {{predictionId}})',
  [I18N_KEYS.COMPOSITOR.LAYER_PANEL.TITLE]: 'Layers',
  [I18N_KEYS.COMPOSITOR.PANEL_SWITCH.LAYERS_ARIA]: 'Layers',
  [I18N_KEYS.COMPOSITOR.PANEL_SWITCH.ASSETS_ARIA]: 'Assets',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.TITLE]: 'Assets',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.SECTION_IMAGE]: 'Images',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.SECTION_VIDEO]: 'Videos',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.SECTION_AUDIO]: 'Audio',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.FILTER_TYPE_ALL]: 'All',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.FILTER_TYPE_IMAGE]: 'Images',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.FILTER_TYPE_VIDEO]: 'Videos',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.FILTER_TYPE_AUDIO]: 'Audio',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.EMPTY_TITLE]: 'Nothing here yet',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.EMPTY_DESCRIPTION]:
    'Drop a file on the canvas, or connect a node, and it shows up here.',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.EMPTY_CONNECTED_TITLE]: 'Nothing connected',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.EMPTY_CONNECTED_DESCRIPTION]:
    'Connect a node to this compositor and what it makes shows up here.',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.EMPTY_UPLOADED_TITLE]: 'Nothing you added',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.EMPTY_UPLOADED_DESCRIPTION]: 'Drop a file on the canvas and it shows up here.',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.EMPTY_TYPE_IMAGE_TITLE]: 'No images',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.EMPTY_TYPE_VIDEO_TITLE]: 'No videos',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.EMPTY_TYPE_AUDIO_TITLE]: 'No audio',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.EMPTY_TYPE_DESCRIPTION]: 'This compositor holds none of this kind yet.',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.FILTER_SOURCE]: 'Source',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.FILTER_SOURCE_CONNECTED]: 'Connected',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.FILTER_SOURCE_UPLOADED]: 'Uploaded',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.FILTER_SOURCE_ALL]: 'All',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.CONNECTED_TOOLTIP]: 'Connected input',
  // all three forms, so it never says "1 layers"
  [`${I18N_KEYS.COMPOSITOR.ASSETS_PANEL.USED_BY_LAYERS_TOOLTIP}_zero`]: 'Not used in any layer',
  [`${I18N_KEYS.COMPOSITOR.ASSETS_PANEL.USED_BY_LAYERS_TOOLTIP}_one`]: 'Used in {{count}} layer',
  [`${I18N_KEYS.COMPOSITOR.ASSETS_PANEL.USED_BY_LAYERS_TOOLTIP}_other`]: 'Used in {{count}} layers',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.DELETE]: 'Delete',
  // the title falls back to these when the content carries no file name
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.UNTITLED_IMAGE]: 'Image',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.UNTITLED_VIDEO]: 'Video',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.UNTITLED_AUDIO]: 'Sound',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.DELETE_DIALOG_TITLE]: 'Delete {{name}}?',
  // no zero form: content nothing uses is deleted without asking
  [`${I18N_KEYS.COMPOSITOR.ASSETS_PANEL.DELETE_DIALOG_MESSAGE}_one`]:
    'The layer using it will be removed from the canvas too.',
  [`${I18N_KEYS.COMPOSITOR.ASSETS_PANEL.DELETE_DIALOG_MESSAGE}_other`]:
    'The {{count}} layers using it will be removed from the canvas too.',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.DELETE_DIALOG_CONFIRM]: 'Delete',
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.DELETE_DIALOG_DONT_SHOW]: "Don't show this again",
  [I18N_KEYS.COMPOSITOR.ASSETS_PANEL.SHOW_ON_CANVAS]: 'Show on canvas',
  [I18N_KEYS.COMPOSITOR.CONTEXT_MENU.GROUP]: 'Group',
  [I18N_KEYS.COMPOSITOR.CONTEXT_MENU.UNGROUP]: 'Ungroup',
  [I18N_KEYS.COMPOSITOR.CONTEXT_MENU.DELETE]: 'Delete',
  [I18N_KEYS.COMPOSITOR.CONTEXT_MENU.DUPLICATE]: 'Duplicate',
  [I18N_KEYS.COMPOSITOR.CONTEXT_MENU.COPY]: 'Copy',
  [I18N_KEYS.COMPOSITOR.CONTEXT_MENU.ADD_FADE]: 'Add fade',
  [I18N_KEYS.COMPOSITOR.LAYER_PANEL_ROW.CANVAS_LAYER_NAME]: 'Canvas',
  [I18N_KEYS.COMPOSITOR.MISSING_URL_TOOLTIP]: 'Connect a valid image to enable this layer.',
  [I18N_KEYS.COMPOSITOR.ADD_CONTENT.UPLOADING_FILE]: 'Uploading {{name}}',
  [I18N_KEYS.COMPOSITOR.ADD_CONTENT.UPLOADING_IMAGE]: 'Uploading image',
  [I18N_KEYS.COMPOSITOR.ADD_CONTENT.UPLOADING_IMAGES]: 'Uploading {{count}} images',
  [I18N_KEYS.COMPOSITOR.ADD_CONTENT.UPLOADING_VIDEOS]: 'Uploading {{count}} videos',
  [I18N_KEYS.COMPOSITOR.ADD_CONTENT.UPLOADING_AUDIO_FILES]: 'Uploading {{count}} audio files',
  [I18N_KEYS.COMPOSITOR.ADD_CONTENT.UPLOADING_FILES]: 'Uploading {{count}} files',
  [I18N_KEYS.COMPOSITOR.ADD_CONTENT.UPLOAD_IN_PROGRESS]: 'An upload is already in progress',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.TITLE]: 'Replace missing fonts',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.DESCRIPTION]:
    'This workflow uses custom fonts that are not available for this recipe. Text may not look correct until those fonts are uploaded to the workspace.',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.CONTINUE]: 'Continue',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.COLUMN_MISSING]: 'Missing font',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.COLUMN_REPLACEMENT]: 'Replacement',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.SELECT_FONT]: 'Select font',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.MIXED_REPLACEMENT_FONT]: 'Mixed',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.SELECT_STYLE]: 'Select style',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.REPLACE]: 'Replace',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.MANAGE_WORKSPACE_FONTS]: 'Manage workspace fonts',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FLIP]: 'Flip',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.OPEN_COLOR_PICKER_ARIA]: 'Open color picker',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGNMENT]: 'Alignment',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.DISTRIBUTION]: 'Distribution',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODE]: 'Blend mode',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.MODE]: 'Mode',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.IMAGE_MODE]: 'Scale',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.IMAGE_MODES.STRETCH]: 'Stretch',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.IMAGE_MODES.FIT]: 'Fit',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.IMAGE_MODES.FILL]: 'Fill',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.CANVAS_LAYER_NAME]: 'Canvas',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.MULTI_SELECTION_HEADER]: '{{count}} layers',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.DIMENSIONS]: 'Dimensions',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.WIDTH_ARIA]: 'Width',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.HEIGHT_ARIA]: 'Height',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.POSITION_X_ARIA]: 'X position',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.POSITION_Y_ARIA]: 'Y position',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.CANVAS_WIDTH_ARIA]: 'Canvas width',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.CANVAS_HEIGHT_ARIA]: 'Canvas height',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BACKGROUND_COLOR]: 'Fill',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ADD_BACKGROUND]: 'Add background',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.REMOVE_BACKGROUND]: 'Remove background',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.TITLE]: 'Fade',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.IN]: 'Fade in',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.OUT]: 'Fade out',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.REMOVE_IN]: 'Remove fade in',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.REMOVE_OUT]: 'Remove fade out',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.HIDE]: 'Hide fade',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.SHOW]: 'Show fade',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.PICTURE]: 'Picture',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.AUDIO]: 'Audio',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.DURATION]: 'Duration',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.EASING]: 'Easing',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.SECONDS_SHORT]: 'Sec',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.DURATION_ARIA]: '{{fade}} duration',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.DURATION_IN_SECONDS_ARIA]: '{{fade}} duration in seconds',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.DURATION_IN_FRAMES_ARIA]: '{{fade}} duration in frames',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.DURATION_UNIT_SECONDS_ARIA]: 'Duration unit, currently seconds',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.DURATION_UNIT_FRAMES_ARIA]: 'Duration unit, currently frames',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.EASING_ARIA]: '{{fade}} easing',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.LINEAR]: 'Linear',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.EASE_IN]: 'Ease in',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.EASE_OUT]: 'Ease out',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FADE.EASE_IN_OUT]: 'Ease in and out',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECTS]: 'Effects',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ADD_EFFECT]: 'Add effect',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.REMOVE_EFFECT]: 'Remove effect',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.SHOW_EFFECT]: 'Show effect',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.HIDE_EFFECT]: 'Hide effect',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_TYPES.BLUR]: 'Blur',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_TYPES.COLOR_CORRECTION]: 'Color correction',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_TYPES.INVERT]: 'Invert',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_TYPES.LEVELS]: 'Levels',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.CLOSE]: 'Close',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.BLUR_TYPE]: 'Type',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.BLUR_SIZE]: 'Size',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.CHANNEL]: 'Channel',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.EXPOSURE]: 'Exposure',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.CONTRAST]: 'Contrast',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.SATURATION]: 'Saturation',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.TEMPERATURE]: 'Temperature',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.TINT]: 'Tint',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.HIGHLIGHTS]: 'Highlights',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.SHADOWS]: 'Shadows',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.INPUT_MIN]: 'Input min',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.INPUT_MAX]: 'Input max',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.GAMMA]: 'Gamma',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.OUTPUT_MIN]: 'Output min',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.EFFECT_OPTIONS.OUTPUT_MAX]: 'Output max',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ADD_FILL]: 'Add fill',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.REMOVE_FILL]: 'Remove fill',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.SHOW_FILL]: 'Show fill',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.HIDE_FILL]: 'Hide fill',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE]: 'Stroke',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ADD_STROKE]: 'Add stroke',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.REMOVE_STROKE]: 'Remove stroke',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.SHOW_STROKE]: 'Show stroke',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.HIDE_STROKE]: 'Hide stroke',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_WEIGHT]: 'Weight',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_POSITION]: 'Position',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_POSITIONS.INSIDE]: 'Inside',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_POSITIONS.CENTER]: 'Center',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_POSITIONS.OUTSIDE]: 'Outside',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_JOIN]: 'Join',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_JOINS.MITER]: 'Miter',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_JOINS.ROUND]: 'Round',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_JOINS.BEVEL]: 'Bevel',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_CAP]: 'End points',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_CAPS.BUTT]: 'None',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_CAPS.SQUARE]: 'Square',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.STROKE_CAPS.ROUND]: 'Round',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.TIMELINE]: 'Timeline mode',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.TIMELINE_INFO]: 'Timeline mode',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.DURATION]: 'Duration',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FIT_TO_CONTENT]: 'Fit to content',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FPS]: 'Frame rate',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FILL]: 'Fill',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT]: 'Font',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_LETTER_SPACING]: 'Letter spacing',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_LINE_HEIGHT]: 'Line height',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_ALIGN]: 'Alignment',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SIZE]: 'Size',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_STYLE]: 'Style',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.OPACITY]: 'Opacity',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.VOLUME]: 'Volume',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.POSITION]: 'Position',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.APPEARANCE]: 'Appearance',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ROTATION]: 'Rotation',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHT]: 'Weight',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.NORMAL]: 'Normal',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.MULTIPLY]: 'Multiply',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.SCREEN]: 'Screen',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.OVERLAY]: 'Overlay',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.DARKEN]: 'Darken',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.LIGHTEN]: 'Lighten',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.COLOR_DODGE]: 'Color Dodge',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.COLOR_BURN]: 'Color Burn',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.HARD_LIGHT]: 'Hard Light',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.SOFT_LIGHT]: 'Soft Light',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.DIFFERENCE]: 'Difference',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.EXCLUSION]: 'Exclusion',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.HUE]: 'Hue',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.SATURATION]: 'Saturation',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.COLOR]: 'Color',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.LUMINOSITY]: 'Luminosity',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.ADD]: 'Add',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.DIVIDE]: 'Divide',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SELECT_INPUT.HELPER_TEXT]:
    'Want to add your own font? Contact us at <supportEmail>support@weavy.ai</supportEmail>',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SELECT_INPUT.HELPER_TEXT_DASHBOARD]:
    'Want to add your own font? <action>Go to the dashboard</action> to add custom fonts.',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SELECT_INPUT.HELPER_TEXT_UPGRADE]:
    'Want to add your own font? <action>Upgrade</action> to add custom fonts.',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SELECT_INPUT.HELPER_TEXT_ASK_ADMIN]:
    'Want to add your own font? Contact your workspace admin.',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SELECT_INPUT.NO_OPTIONS_TEXT]: 'No fonts match this search',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SELECT_INPUT.MENU_TITLE]: 'Fonts',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SELECT_INPUT.SEARCH_PLACEHOLDER]: 'Search fonts',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SELECT_INPUT.MANAGE_WORKSPACE_FONTS]: 'Manage workspace fonts',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_STYLES.NORMAL]: 'Normal',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_STYLES.ITALIC]: 'Italic',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.HAIRLINE]: 'Hairline',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.THIN]: 'Thin',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.EXTRA_LIGHT]: 'Extra Light',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.LIGHT]: 'Light',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.REGULAR]: 'Regular',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.MEDIUM]: 'Medium',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.SEMI_BOLD]: 'Semi Bold',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.BOLD]: 'Bold',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.EXTRA_BOLD]: 'Extra Bold',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.BLACK]: 'Black',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.EXTRA_BLACK]: 'Extra Black',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGN_OPTIONS.TOP]: 'Top',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGN_OPTIONS.CENTER]: 'Center',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGN_OPTIONS.BOTTOM]: 'Bottom',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGN_OPTIONS.LEFT]: 'Left',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGN_OPTIONS.RIGHT]: 'Right',

  [I18N_KEYS.DASHBOARD.DUPLICATE_SUCCESS]: 'Workflow duplicated to "My Files".',
  [I18N_KEYS.DASHBOARD.DUPLICATE_SUCCESS_ACTION]: 'Open "My Files"',
  [I18N_KEYS.DASHBOARD.DUPLICATE_SUCCESS_WORKFLOW]: 'Workflow duplicated to "My workflows".',
  [I18N_KEYS.DASHBOARD.DUPLICATE_ERROR]: 'Failed to duplicate workflow.',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.EMPTY_STATE.TITLE]: 'Nothing here yet!',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.EMPTY_STATE.DESCRIPTION]: 'Start weaving to bring your ideas to life.',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.EMPTY_STATE.ACTION]: 'Create your first file',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.TITLE]: 'My files',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.RECIPE_CARD.SUBTITLE_CREATED]: 'Created {{date}}',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.RECIPE_CARD.SUBTITLE_LAST_EDITED]: 'Last edited {{date}}',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.RECIPE_CARD.OWNED_BY_YOU]: 'Owned by you',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.RECIPE_CARD.OWNED_BY_OTHER]: 'Owned by {{owner}}',

  [I18N_KEYS.DASHBOARD.PAGES.SHARED_WITH_ME.TITLE]: 'Shared with me',
  [I18N_KEYS.DASHBOARD.PAGES.SHARED_WITH_ME.EMPTY_STATE.TITLE]: 'No shared files',
  [I18N_KEYS.DASHBOARD.PAGES.SHARED_WITH_ME.EMPTY_STATE.ACTION]: 'Learn more about shared files',

  [I18N_KEYS.DASHBOARD.PAGES.WORKSPACE_FILES.TITLE]: 'Workspace files',
  [I18N_KEYS.DASHBOARD.PAGES.WORKSPACE_FILES.EMPTY_STATE.TITLE]: 'No workspace files',
  [I18N_KEYS.DASHBOARD.PAGES.WORKSPACE_FILES.EMPTY_STATE.ACTION]: 'Learn more about workspace files',

  [I18N_KEYS.DASHBOARD.PAGES.SHARED_APPS.TITLE]: 'Tools shared with me',
  [I18N_KEYS.DASHBOARD.PAGES.SHARED_APPS.EMPTY_STATE.TITLE]: 'No tools',
  [I18N_KEYS.DASHBOARD.PAGES.SHARED_APPS.EMPTY_STATE.ACTION]: 'Learn more about tools',

  [I18N_KEYS.DASHBOARD.SCOPE.MY_WORKFLOWS]: 'My workflows',
  [I18N_KEYS.DASHBOARD.SCOPE.WORKSPACE_WORKFLOWS]: 'Workspace workflows',
  [I18N_KEYS.DASHBOARD.SCOPE.MY_TOOLS]: 'My tools',
  [I18N_KEYS.DASHBOARD.SCOPE.WORKSPACE_TOOLS]: 'Workspace tools',
  [I18N_KEYS.DASHBOARD.SCOPE.SHARED_WITH_ME]: 'Shared with me',
  [I18N_KEYS.DASHBOARD.PAGES.WORKFLOWS.TITLE]: 'Workflows',
  [I18N_KEYS.DASHBOARD.PAGES.WORKFLOWS.EMPTY_STATE.SHARED]: 'No shared workflows',
  [I18N_KEYS.DASHBOARD.PAGES.WORKFLOWS.EMPTY_STATE.WORKSPACE]: 'No workspace workflows',
  [I18N_KEYS.DASHBOARD.PAGES.WORKFLOWS.EMPTY_STATE.WORKSPACE_DESCRIPTION]:
    'Workflows added here are shared with everyone in the workspace',
  [I18N_KEYS.DASHBOARD.PAGES.TOOLS.TITLE]: 'Tools',
  [I18N_KEYS.DASHBOARD.PAGES.TOOLS.EMPTY_STATE.TITLE]: 'No tools yet',
  [I18N_KEYS.DASHBOARD.PAGES.TOOLS.EMPTY_STATE.SHARED]: 'No shared tools',
  [I18N_KEYS.DASHBOARD.PAGES.TOOLS.EMPTY_STATE.WORKSPACE]: 'No workspace tools',
  [I18N_KEYS.DASHBOARD.PAGES.TOOLS.EMPTY_STATE.WORKSPACE_DESCRIPTION]:
    'Tools added here are shared with everyone in the workspace',

  [I18N_KEYS.NAVIGATION_DRAWER.ARCHIVE]: 'Trash',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.TITLE]: 'Trash',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.SUBTITLE]: 'Files and folders moved here are permanently deleted after 30 days.',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.RESTORE]: 'Restore',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.RESTORE_ERROR]: 'Failed to restore item',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.RESTORE_WORKFLOW_SUCCESS]: 'Workflow restored successfully',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.RESTORE_FOLDER_SUCCESS]: 'Folder restored successfully',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.DELETED_AT]: 'Trashed {{date}}',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.DELETED_AT_HEADER]: 'Deleted at',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.EMPTY_STATE.DESCRIPTION]: 'You don’t have any trashed files.',

  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.TITLE]: 'My Models',
  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.SUBTITLE]:
    'Library of your favorite models. These models will appear under "My Models" menu in your files. Right-click to edit or delete',
  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.EMPTY_STATE.TITLE]: 'No models saved yet',
  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.EMPTY_STATE.DESCRIPTION]:
    'You can import your own models for personal use, or to share with others',
  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.EMPTY_STATE.ACTION]: 'How to import a model',
  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.DELETE_DIALOG_TITLE]: 'Are you sure you want to delete this model?',

  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.TITLE]: 'Public Models',
  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.SUBTITLE]:
    'Find awesome models that can be used in your files. Right-click to add to your models library',
  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.MODEL_SAVED]: 'Model saved to your library',
  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.MODEL_CARD.BASED_ON]: 'Based on:',
  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.MODEL_CARD.CREATOR]: 'Created by:',
  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.CONTEXT_MENU.SAVE_TO_MY_MODELS]: 'Save to My Models',

  [I18N_KEYS.ERROR_PAGE.TITLE]: 'Oops! Something went wrong',
  [I18N_KEYS.ERROR_PAGE.DESCRIPTION]: 'Try to refresh or contact us at <supportEmail>support@weavy.ai</supportEmail>',
  [I18N_KEYS.ERROR_PAGE.RETRY_ACTION]: 'Try again',

  [I18N_KEYS.NO_ACCESS_PAGE.TITLE]: 'No access to this page',
  [I18N_KEYS.NO_ACCESS_PAGE.DESCRIPTION]: 'Please ask the owner to share the page with you.',
  [I18N_KEYS.NO_ACCESS_PAGE.ACTION]: 'Back to dashboard',

  [I18N_KEYS.FLOW_WARNINGS.FAILED_DESERIALIZE_3D_MODEL]: 'Failed to deserialize a 3D model',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DESERIALIZE_FONT]: 'Failed to deserialize a font',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DESERIALIZE_IMAGE]: 'Failed to deserialize an image',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DESERIALIZE_VIDEO]: 'Failed to deserialize a video',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DOWNLOAD_IMAGE]: 'Failed to download an image',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DOWNLOAD_VIDEO]: 'Failed to download a video',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DOWNLOAD_AUDIO]: 'Failed to download an audio file',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DOWNLOAD_FONT]:
    'The workflow consists of fonts which are not available in your workspace. Please replace them with available fonts.',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DOWNLOAD_3D_MODEL]: 'Failed to download a 3D model',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_LOAD_WORKSPACE_CUSTOM_FONTS]:
    'Could not load workspace custom fonts. Workflow text may look wrong.',

  [I18N_KEYS.WEBGL_NOT_SUPPORTED_PAGE.TITLE]: "Looks like your browser doesn't support WebGL 2.0",
  [I18N_KEYS.WEBGL_NOT_SUPPORTED_PAGE.DESCRIPTION]: 'Please make sure WebGL 2.0 is supported by your browser.',

  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.TITLE]: 'GPU driver error',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.DESCRIPTION]: 'Try the steps below to resolve the issue –',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_REFRESH_TITLE]: 'Refresh the page',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_REFRESH_DESCRIPTION]: 'This often resolves the issue immediately.',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_HARDWARE_ACCELERATION_TITLE]: 'Check hardware acceleration',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_HARDWARE_ACCELERATION_DESCRIPTION]:
    'It may be disabled or misconfigured in your browser settings. <learnHow>Learn how</learnHow>',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_RESTART_TITLE]: 'Restart your computer',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_RESTART_DESCRIPTION]:
    'Clears deeper system-level conflicts that may cause errors.',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_CONTACT_SUPPORT_TITLE]: 'Contact support',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_CONTACT_SUPPORT_DESCRIPTION]:
    'If the problem persists, contact our support team at <supportEmail>support@weavy.ai</supportEmail>.',

  [I18N_KEYS.FIGMA_COMPOSITOR.LOAD_IMAGE_ERROR]: 'Cannot load Figma image preview',
  [I18N_KEYS.FIGMA_COMPOSITOR.ALREADY_CONNECTED_ERROR]: 'Node is already connected to a different Figma compositor.',
  [I18N_KEYS.FIGMA_COMPOSITOR.OPEN_IN_FIGMA]: 'Open in Figma',
  [I18N_KEYS.FIGMA_COMPOSITOR.REFRESH]: 'Refresh',
  [I18N_KEYS.FIGMA_COMPOSITOR.LAYERS]: 'Layers',

  [I18N_KEYS.FLOW_NAVBAR.SHARED_DESIGN_APP_BUTTON]: 'Share Design Tool',
  [I18N_KEYS.FLOW_NAVBAR.GET_MORE_CREDITS]: 'Get more',
  [I18N_KEYS.FLOW_NAVBAR.GET_MORE_CREDITS_V2]: 'Get more credits',
  [I18N_KEYS.FLOW_NAVBAR.LOW_CREDITS_LABEL]: 'Low credits',

  [I18N_KEYS.GENERAL.CANCEL]: 'Cancel',
  [I18N_KEYS.GENERAL.CLEAR]: 'Clear',
  [I18N_KEYS.GENERAL.CLOSE]: 'Close',
  [I18N_KEYS.GENERAL.CONFIRM]: 'Confirm',
  [I18N_KEYS.GENERAL.COPIED]: 'Copied!',
  [I18N_KEYS.GENERAL.COPY_LINK]: 'Copy link',
  [I18N_KEYS.GENERAL.COPY]: 'Copy',
  [I18N_KEYS.GENERAL.CREDITS]: 'Credits',
  [I18N_KEYS.GENERAL.CREDITS_DISPLAY]: '{{credits}} credits',
  [I18N_KEYS.GENERAL.CREDITS_DISPLAY_PER_SECOND]: '{{credits}} / sec',
  [I18N_KEYS.GENERAL.CREDIT]: 'Credit',
  [I18N_KEYS.GENERAL.DONE]: 'Done',
  [I18N_KEYS.GENERAL.DOWNLOAD]: 'Download',
  [I18N_KEYS.GENERAL.DOWNLOADING]: 'Downloading',
  [I18N_KEYS.GENERAL.ERROR]: 'An error occurred',
  [I18N_KEYS.GENERAL.FILE]: 'File',
  [I18N_KEYS.GENERAL.FILES]: 'Files',
  [I18N_KEYS.GENERAL.FROM]: 'From',
  [I18N_KEYS.GENERAL.IMAGE]: 'Image',
  [I18N_KEYS.GENERAL.INPUT]: 'Input',
  [I18N_KEYS.GENERAL.INVALID_URL]: 'Invalid URL',
  [I18N_KEYS.GENERAL.MONTH]: 'Month',
  [I18N_KEYS.GENERAL.NAME]: 'Name',
  [I18N_KEYS.GENERAL.DESCRIPTION]: 'Description',
  [I18N_KEYS.GENERAL.THUMBNAIL]: 'Thumbnail',
  [I18N_KEYS.GENERAL.UPLOAD]: 'Upload',
  [I18N_KEYS.GENERAL.UPLOAD_INVALID_IMAGE]: 'Only image files are supported.',
  [I18N_KEYS.GENERAL.SELECT_IMAGE]: 'Select image',
  [I18N_KEYS.GENERAL.SELECT_FROM_WORKFLOW]: 'Select from workflow',
  [I18N_KEYS.GENERAL.SCOPE_IN_GROUP]: 'In group',
  [I18N_KEYS.GENERAL.SCOPE_IN_WORKFLOW]: 'In workflow',
  [I18N_KEYS.GENERAL.GROUP_GALLERY_EMPTY]: 'This group has no images to choose from.',
  [I18N_KEYS.GENERAL.WORKFLOW_GALLERY_EMPTY]: 'This workflow has no images to choose from.',
  [I18N_KEYS.GENERAL.OUTPUT]: 'Output',
  [I18N_KEYS.GENERAL.RENAME]: 'Rename',
  [I18N_KEYS.GENERAL.SAVE]: 'Save',
  [I18N_KEYS.GENERAL.SAVING]: 'Saving...',
  [I18N_KEYS.GENERAL.SEARCH]: 'Search',
  [I18N_KEYS.GENERAL.SELECT_AN_OPTION]: 'Select an option',
  [I18N_KEYS.GENERAL.TO]: 'to',
  [I18N_KEYS.GENERAL.UNKNOWN]: 'Unknown',
  [I18N_KEYS.GENERAL.UNKNOWN_ERROR]: 'Something went wrong',
  [I18N_KEYS.GENERAL.REQUIRED_FIELDS]: 'Please fill in all required fields',
  [I18N_KEYS.GENERAL.UNVERIFIED_MODEL_ERROR]: 'Unverified model run error',
  [I18N_KEYS.GENERAL.UPLOAD_ERROR]: 'Could not upload the file. Please try again.',
  [I18N_KEYS.GENERAL.TOTAL]: 'Total',
  [I18N_KEYS.GENERAL.URL]: 'URL',
  [I18N_KEYS.GENERAL.USER]: 'User',
  [I18N_KEYS.GENERAL.YEAR]: 'Year',
  [I18N_KEYS.GENERAL.LORA_WEIGHT]: 'Weight',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.MULTI_LORA.NONE]: 'None',
  [I18N_KEYS.GENERAL.YOU]: 'You',
  [I18N_KEYS.GENERAL.YOU_PARENS]: '(you)',
  [I18N_KEYS.GENERAL.ERROR]: 'Error',
  [I18N_KEYS.GENERAL.RELOAD_ALERT_TITLE]: 'A new version of Figma Weave is available',
  [I18N_KEYS.GENERAL.RELOAD_ALERT_CTA]: 'Refresh',
  [I18N_KEYS.GENERAL.PAGE_TITLE]: 'Figma Weave',
  [I18N_KEYS.GENERAL.YES]: 'Yes',
  [I18N_KEYS.GENERAL.NO]: 'No',
  [I18N_KEYS.GENERAL.FILTER]: 'Filter',
  [I18N_KEYS.GENERAL.FILTERS]: 'Filters',
  [I18N_KEYS.GENERAL.RUNNING]: 'Running',
  [I18N_KEYS.GENERAL.COMPLETED]: 'Completed',
  [I18N_KEYS.GENERAL.TYPE]: 'Type',
  [I18N_KEYS.GENERAL.EMAIL]: 'Email',
  [I18N_KEYS.GENERAL.ROLE]: 'Role',
  [I18N_KEYS.GENERAL.COLOR]: 'Color',
  [I18N_KEYS.GENERAL.APPROVE]: 'Approve',
  [I18N_KEYS.GENERAL.ACCEPT]: 'Accept',
  [I18N_KEYS.GENERAL.DELETE]: 'Delete',
  [I18N_KEYS.GENERAL.WIDTH]: 'Width',
  [I18N_KEYS.GENERAL.HEIGHT]: 'Height',
  [I18N_KEYS.GENERAL.CHECKBOX]: 'Checkbox',
  [I18N_KEYS.GENERAL.ROTATE_90_CLOCKWISE]: 'Rotate 90° clockwise',
  [I18N_KEYS.GENERAL.FLIP_HORIZONTAL]: 'Flip horizontal',
  [I18N_KEYS.GENERAL.FLIP_VERTICAL]: 'Flip vertical',
  [I18N_KEYS.GENERAL.ARIA.SCALE]: 'Scale',
  [I18N_KEYS.GENERAL.ARIA.MINUTES]: 'Minutes',
  [I18N_KEYS.GENERAL.ARIA.SECONDS]: 'Seconds',
  [I18N_KEYS.GENERAL.ARIA.FRAMES]: 'Frames',
  [I18N_KEYS.GENERAL.ARIA.BREAK_MASKED_TARGET_CONNECTIONS]: 'Remove all masks from this layer',
  [I18N_KEYS.GENERAL.ARIA.COLLAPSE_PARAMETER]: 'Collapse parameter',
  [I18N_KEYS.GENERAL.ARIA.FILTER_BY_INPUT_TYPE]: 'Filter by input type',
  [I18N_KEYS.GENERAL.ARIA.FILTER_BY_OUTPUT_TYPE]: 'Filter by output type',
  [I18N_KEYS.GENERAL.ARIA.COPY_DEBUG_VALUE]: 'Copy debug value',
  [I18N_KEYS.GENERAL.ARIA.COPY_JSON]: 'Copy JSON',
  [I18N_KEYS.GENERAL.ARIA.CREATE_LAYER_MASK]: 'Drag to mask another layer',
  [I18N_KEYS.GENERAL.ARIA.EDIT_NAMED_ITEM]: 'Edit {{name}}',
  [I18N_KEYS.GENERAL.ARIA.DELETE_NAMED_ITEM]: 'Delete {{name}}',
  [I18N_KEYS.GENERAL.ARIA.EXPOSE_PARAMETER]: 'Expose parameter',
  [I18N_KEYS.GENERAL.ARIA.GO_TO_HOME]: 'Go to home',
  [I18N_KEYS.GENERAL.ARIA.HIDE_COMPARISON]: 'Hide comparison',
  [I18N_KEYS.GENERAL.ARIA.HIDE_LAYER]: 'Hide layer',
  [I18N_KEYS.GENERAL.ARIA.LOCK_LAYER]: 'Lock layer',
  [I18N_KEYS.GENERAL.ARIA.LOCKED_NODE]: 'Locked node',
  [I18N_KEYS.GENERAL.ARIA.MUTE]: 'Mute',
  [I18N_KEYS.GENERAL.ARIA.MUTE_LAYER]: 'Mute layer',
  [I18N_KEYS.GENERAL.ARIA.NEXT_BATCH]: 'Next batch',
  [I18N_KEYS.GENERAL.ARIA.NEXT_FRAME]: 'Next frame',
  [I18N_KEYS.GENERAL.ARIA.NEXT_ITEM]: 'Next item',
  [I18N_KEYS.GENERAL.ARIA.NEXT_MODEL_REQUEST]: 'Next model request',
  [I18N_KEYS.GENERAL.ARIA.OPEN_FIGMA_FILE_MENU]: 'Open Figma file menu',
  [I18N_KEYS.GENERAL.ARIA.OPEN_FILE_MENU]: 'Open file menu',
  [I18N_KEYS.GENERAL.ARIA.OPEN_FILTERS_MENU]: 'Open filters menu',
  [I18N_KEYS.GENERAL.ARIA.OPEN_HELP]: 'Open help',
  [I18N_KEYS.GENERAL.ARIA.OPEN_INPUT_SETTINGS]: 'Open input settings',
  [I18N_KEYS.GENERAL.ARIA.OPEN_ITEM_MENU]: 'Open item menu',
  [I18N_KEYS.GENERAL.ARIA.OPEN_NAMED_ITEM]: 'Open {{name}}',
  [I18N_KEYS.GENERAL.ARIA.OPEN_NODE_MENU]: 'Open node menu',
  [I18N_KEYS.GENERAL.ARIA.OPEN_PUBLISHED_WORKFLOW_MENU]: 'Open published workflow menu',
  [I18N_KEYS.GENERAL.ARIA.OPEN_WORKSPACE_FILE_MENU]: 'Open workspace file menu',
  [I18N_KEYS.GENERAL.ARIA.PAUSE]: 'Pause',
  [I18N_KEYS.GENERAL.ARIA.PLAY]: 'Play',
  [I18N_KEYS.GENERAL.ARIA.PREVIOUS_BATCH]: 'Previous batch',
  [I18N_KEYS.GENERAL.ARIA.PREVIOUS_FRAME]: 'Previous frame',
  [I18N_KEYS.GENERAL.ARIA.PREVIOUS_ITEM]: 'Previous item',
  [I18N_KEYS.GENERAL.ARIA.PREVIOUS_MODEL_REQUEST]: 'Previous model request',
  [I18N_KEYS.GENERAL.ARIA.REDO]: 'Redo',
  [I18N_KEYS.GENERAL.ARIA.REMOVE_IMAGE]: 'Remove image',
  [I18N_KEYS.GENERAL.ARIA.REMOVE_ITEM]: 'Remove item',
  [I18N_KEYS.GENERAL.ARIA.REMOVE_NAMED_ITEM]: 'Remove {{name}}',
  [I18N_KEYS.GENERAL.ARIA.REMOVE_NAMED_ITEM_KEYBOARD]: 'Press Delete or Backspace to remove {{name}}',
  [I18N_KEYS.GENERAL.ARIA.REVEAL_COMPARISON]: 'Reveal comparison',
  [I18N_KEYS.GENERAL.ARIA.SCROLL_LEFT]: 'Scroll left',
  [I18N_KEYS.GENERAL.ARIA.SCROLL_RIGHT]: 'Scroll right',
  [I18N_KEYS.GENERAL.ARIA.SHOW_LAYER]: 'Show layer',
  [I18N_KEYS.GENERAL.ARIA.UNDO]: 'Undo',
  [I18N_KEYS.GENERAL.ARIA.UNLOCK_GROUP]: 'Unlock group',
  [I18N_KEYS.GENERAL.ARIA.UNLOCK_LAYER]: 'Unlock layer',
  [I18N_KEYS.GENERAL.ARIA.UNMUTE]: 'Unmute',
  [I18N_KEYS.GENERAL.ARIA.UNMUTE_LAYER]: 'Unmute layer',
  [I18N_KEYS.GENERAL.FILE_TYPES.IMAGE + '_one']: 'Image',
  [I18N_KEYS.GENERAL.FILE_TYPES.IMAGE + '_other']: 'Images',
  [I18N_KEYS.GENERAL.FILE_TYPES.IMAGE + '_lower_one']: 'image',
  [I18N_KEYS.GENERAL.FILE_TYPES.IMAGE + '_lower_other']: 'images',
  [I18N_KEYS.GENERAL.FILE_TYPES.VIDEO + '_one']: 'Video',
  [I18N_KEYS.GENERAL.FILE_TYPES.VIDEO + '_other']: 'Videos',
  [I18N_KEYS.GENERAL.FILE_TYPES.VIDEO + '_lower_one']: 'video',
  [I18N_KEYS.GENERAL.FILE_TYPES.VIDEO + '_lower_other']: 'videos',
  [I18N_KEYS.GENERAL.FILE_TYPES.AUDIO + '_one']: 'Audio file',
  [I18N_KEYS.GENERAL.FILE_TYPES.AUDIO + '_other']: 'Audio files',
  [I18N_KEYS.GENERAL.FILE_TYPES.AUDIO + '_lower_one']: 'audio file',
  [I18N_KEYS.GENERAL.FILE_TYPES.AUDIO + '_lower_other']: 'audio files',
  [I18N_KEYS.GENERAL.FILE_TYPES.THREE_D + '_one']: '3D file',
  [I18N_KEYS.GENERAL.FILE_TYPES.THREE_D + '_other']: '3D files',
  [I18N_KEYS.GENERAL.FILE_TYPES.THREE_D + '_lower_one']: '3D file',
  [I18N_KEYS.GENERAL.FILE_TYPES.THREE_D + '_lower_other']: '3D files',

  [I18N_KEYS.GENERAL.HANDLE_TYPES.IMAGE + '_lower_one']: 'image',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.IMAGE + '_lower_other']: 'images',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.VIDEO + '_lower_one']: 'video',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.VIDEO + '_lower_other']: 'videos',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.AUDIO + '_lower_one']: 'audio',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.AUDIO + '_lower_other']: 'audio',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.THREE_D + '_lower_one']: '3D file',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.THREE_D + '_lower_other']: '3D files',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.TEXT + '_lower_one']: 'text',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.TEXT + '_lower_other']: 'texts',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.SEED + '_lower_one']: 'seed',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.SEED + '_lower_other']: 'seeds',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.MASK + '_lower_one']: 'mask',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.MASK + '_lower_other']: 'masks',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.LORA + '_lower_one']: 'LoRA',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.LORA + '_lower_other']: 'LoRAs',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.NUMBER + '_lower_one']: 'number',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.NUMBER + '_lower_other']: 'numbers',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.BOOLEAN + '_lower_one']: 'toggle',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.BOOLEAN + '_lower_other']: 'toggles',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.ARRAY + '_lower_one']: 'list',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.ARRAY + '_lower_other']: 'lists',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.KLING_ELEMENT + '_lower_one']: 'element',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.KLING_ELEMENT + '_lower_other']: 'elements',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.KEYFRAME + '_lower_one']: 'keyframe',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.KEYFRAME + '_lower_other']: 'keyframes',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.ANY + '_lower_one']: 'input',
  [I18N_KEYS.GENERAL.HANDLE_TYPES.ANY + '_lower_other']: 'inputs',

  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.EDIT]: 'Edit',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.MOVE_TO_TRASH]: 'Move to trash',
  [I18N_KEYS.MAIN_DASHBOARD.BREADCRUMB_ARIA]: 'Breadcrumb',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.DUPLICATE]: 'Duplicate',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.DUPLICATE_WORKFLOW]: 'Duplicate workflow',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.OPEN]: 'Open',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.OPEN_NEW_TAB]: 'Open in a new tab',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.RENAME]: 'Rename',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.MOVE]: 'Move',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.CHANGE_OWNER]: 'Change owner',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.EXPORT_AUDIT_TRAIL]: 'Export audit trail',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.CREATE_FOLDER]: 'New Folder',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.CREATE_FILE]: 'New File',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.CREATE_WORKFLOW]: 'New workflow',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_NEW_FILE]: 'Create New File',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_NEW_WORKFLOW]: 'Create new workflow',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.TITLE]: 'Create folder',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.NAME_LABEL]: 'Name',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.CANCEL]: 'Cancel',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.CREATE]: 'Create',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.SUCCESS]: 'Folder created successfully',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.ERROR_PREFIX]: 'Operation failed:',
  [I18N_KEYS.MAIN_DASHBOARD.FOLDER_CARD.FILE_COUNT_SINGULAR]: '{{count}} file',
  [I18N_KEYS.MAIN_DASHBOARD.FOLDER_CARD.FILE_COUNT_PLURAL]: '{{count}} files',
  [I18N_KEYS.MAIN_DASHBOARD.FOLDER_CARD.WORKFLOW_COUNT_SINGULAR]: '{{count}} workflow',
  [I18N_KEYS.MAIN_DASHBOARD.FOLDER_CARD.WORKFLOW_COUNT_PLURAL]: '{{count}} workflows',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.TITLE]: 'Move file "{{name}}"',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.TITLE_WORKFLOW]: 'Move workflow "{{name}}"',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.TITLE_TOOL]: 'Move tool "{{name}}"',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.TITLE_FOLDER]: 'Move folder "{{name}}"',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.CURRENT_LOCATION]: 'Current location',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.CURRENT]: 'Current',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.BACK_ARIA]: 'Back',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.CANCEL]: 'Cancel',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.MOVE]: 'Move',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.SUCCESS_FILE]: 'File moved successfully',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.SUCCESS_WORKFLOW]: 'Workflow moved successfully',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.SUCCESS_TOOL]: 'Tool moved successfully',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.SUCCESS_FOLDER]: 'Folder moved successfully',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.ERROR_PREFIX]: 'Operation failed:',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.NOT_OWNER_FOLDER]:
    'You can only move a folder to My Files if you own everything in it. Ask teammates to move their files out first.',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.NOT_OWNER_FILE]: 'You can only move your own files to My Files.',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_DIALOG.CONFIRMATION_DELETE_APP]: 'Delete this tool?',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_DIALOG.MSG_DELETE_APP]: 'This tool will be permanently deleted.',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_DIALOG.CONFIRM_DELETE]: 'Delete',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_DIALOG.TITLE]: 'Move to trash',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_DIALOG.MSG]:
    `You're about to move the {{item_type}} <bold>{{item_name}}</bold> to trash.\nAnyone with access can restore it from the <bold>Trash</bold> section within 30 days.`,
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_DIALOG.CONFIRM]: 'Move to trash',
  // Dismissing a share deletes the caller's `user_shared_recipes` row and nothing else, so this says
  // neither "delete" nor "trash": the workflow stays where it is and the owner still has it.
  [I18N_KEYS.MAIN_DASHBOARD.DISMISS_SHARE_DIALOG.TITLE]: 'Remove from Shared with me',
  [I18N_KEYS.MAIN_DASHBOARD.DISMISS_SHARE_DIALOG.MSG]:
    `<bold>{{item_name}}</bold> won't appear in your workflows anymore.\nThe workflow isn't deleted, and its owner can share it with you again.`,
  [I18N_KEYS.MAIN_DASHBOARD.DISMISS_SHARE_DIALOG.CONFIRM]: 'Remove',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_TOOL_DIALOG.MSG]:
    `<bold>{{item_name}}</bold> will be permanently deleted and removed from Figma Community.\nIts workflow is left as it is.`,

  [I18N_KEYS.MAIN_DASHBOARD.DELETE_FOLDER_SUCCESS]: 'Folder deleted successfully',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_FOLDER_ERROR]: 'Failed to delete folder',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_WORKFLOW_SUCCESS]: 'Workflow deleted successfully',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_WORKFLOW_ERROR]: 'Failed to delete workflow',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_TOOL_SUCCESS]: 'Tool deleted successfully',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_TOOL_ERROR]: 'Failed to delete tool',
  [I18N_KEYS.MAIN_DASHBOARD.RENAME_FOLDER_ERROR]: 'Failed to rename folder',
  [I18N_KEYS.MAIN_DASHBOARD.SEARCH_NO_RESULTS.TITLE]: 'No results for: "{{searchTerm}}"',
  [I18N_KEYS.MAIN_DASHBOARD.SEARCH_NO_RESULTS.DESCRIPTION]: 'Try searching for something else',
  [I18N_KEYS.MAIN_DASHBOARD.FOLDER_EMPTY.TITLE]: 'This folder is empty',
  [I18N_KEYS.MAIN_DASHBOARD.FOLDER_EMPTY.DESCRIPTION]: 'Create new files or move files here from other folders',
  [I18N_KEYS.MAIN_DASHBOARD.FOLDER_EMPTY.DESCRIPTION_WORKFLOWS]:
    'Create a workflow or move workflows here from other folders',

  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.WORKFLOWS]: 'Workflow library',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIALS]: 'Tutorials',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.COMMUNITY]: 'Browse on Figma Community',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.INTRO]: 'Intro to Figma Weave',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.WEAVE_101]: 'Figma Weave 101',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.FIRST_WORKFLOW]: 'Build Your First AI Workflow',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.COMPOSITOR]: 'The Compositor',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.THREE_D_MODELS]: 'Using 3D Models',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.WORKFLOW_TO_TOOL]: 'From Workflow to Tool',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.EXPORT_IMPORT]: 'Export and Import',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.GENERATIVE_MODELS]: 'Master Generative Models',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.ITERATORS]: 'Using Iterators',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.IMPORT_LORA]: 'Import LoRA Models',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.TEXT_PROMPTS]: 'Mastering Text Prompts',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.EXTERNAL_MODELS]: 'Bring External Models',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIAL_NAMES.CONTROLNET]: 'ControlNet',
  [I18N_KEYS.MAIN_DASHBOARD.ERROR_LOADING_WORKFLOWS.TITLE]: 'Oops! Something went wrong',
  [I18N_KEYS.MAIN_DASHBOARD.ERROR_LOADING_WORKFLOWS.ACTION]: 'Reload Page',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.PLAN]: 'Plan',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.CREDITS]: 'Credits',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.TEAM_CREDITS]: 'Workspace Credits',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.CTA_CREDITS]: 'Get more',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.CTA_CREDITS_FREE]: 'Upgrade for more',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.CTA_PLAN]: 'Upgrade',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.TEAM_HINT_CREDITS_EMPTY]:
    'Not enough credits to run models. Contact your workspace admin.',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.MENU_ITEM_SETTINGS]: 'Settings & Billing',
  [I18N_KEYS.MAIN_DASHBOARD.WORKSPACES_MENU.TITLE]: 'Switch workspace',

  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.TITLE]: 'Change ownership',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.SUBTITLE]: 'Assign a new owner to this file to allow them to edit it.',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.SELECT_OWNER]: 'Select owner',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.SELECT_OWNER_PLACEHOLDER]: 'Username',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.CANCEL]: 'Cancel',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.CONFIRM]: 'Change owner',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.SUCCESS_SNACKBAR]: 'Owner changed successfully',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.WARNING]: 'You will no longer be able to edit this file.',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.ERROR_SNACKBAR]: 'Failed changing owner.',

  [I18N_KEYS.MOBILE_UNSUPPORTED_PAGE.DISCORD_BUTTON]: 'Join our community on Discord',
  [I18N_KEYS.MOBILE_UNSUPPORTED_PAGE.FOOTER_TEXT]: 'In the meantime...',
  [I18N_KEYS.MOBILE_UNSUPPORTED_PAGE.SUBTITLE]:
    'Open <url>Figma Weave</url> on desktop to start building your design machine.',
  [I18N_KEYS.MOBILE_UNSUPPORTED_PAGE.TITLE]: 'Your \nmasterpiece \nneeds a bigger \ncanvas',
  [I18N_KEYS.MOBILE_UNSUPPORTED_PAGE.YOUTUBE_INTRO_BUTTON]: 'Watch a 2-minute intro on YouTube',

  [I18N_KEYS.MOBILE_SIGNUP_HANDOFF_PAGE.ACTIVATION_ERROR]:
    "We couldn't start your first workflow. Refresh this page to try again.",
  [I18N_KEYS.MOBILE_SIGNUP_HANDOFF_PAGE.COPY_ERROR]:
    "Couldn't copy the link. Open app.weavy.ai on your computer to continue.",
  [I18N_KEYS.MOBILE_SIGNUP_HANDOFF_PAGE.COPY_LINK_BUTTON]: 'Copy link',
  [I18N_KEYS.MOBILE_SIGNUP_HANDOFF_PAGE.COPY_SUCCESS]: 'Link copied. Open it on your computer to continue.',
  [I18N_KEYS.MOBILE_SIGNUP_HANDOFF_PAGE.DISCORD_BUTTON]: 'Join our Discord community',
  [I18N_KEYS.MOBILE_SIGNUP_HANDOFF_PAGE.POST_SIGNUP_SUBTITLE]:
    "Continue on desktop—we'll walk you through your first workflow.",
  [I18N_KEYS.MOBILE_SIGNUP_HANDOFF_PAGE.POST_SIGNUP_TITLE]: 'You’re in. Keep your momentum going.',
  [I18N_KEYS.MOBILE_SIGNUP_HANDOFF_PAGE.SHARE_LINK_BUTTON]: 'Send link to desktop',
  [I18N_KEYS.MOBILE_SIGNUP_HANDOFF_PAGE.SHARE_SUCCESS]: 'Link shared. Open it on your computer to continue.',
  [I18N_KEYS.MOBILE_SIGNUP_HANDOFF_PAGE.SHARE_TITLE]: 'Continue with Figma Weave on desktop',

  [I18N_KEYS.NAVIGATION_DRAWER.DASHBOARD_NAVIGATION_ARIA]: 'dashboard navigation',
  [I18N_KEYS.NAVIGATION_DRAWER.CREATE_MENU_ARIA]: 'Create new file or folder',
  [I18N_KEYS.NAVIGATION_DRAWER.CREATE_MENU_ARIA_WORKFLOW]: 'Create new workflow or folder',
  [I18N_KEYS.NAVIGATION_DRAWER.BUY_MORE]: 'Buy More',
  [I18N_KEYS.NAVIGATION_DRAWER.NEW_FILE]: 'New File',
  [I18N_KEYS.NAVIGATION_DRAWER.NEW_WORKFLOW]: 'New workflow',
  [I18N_KEYS.NAVIGATION_DRAWER.NEW_FOLDER]: 'New Folder',
  [I18N_KEYS.NAVIGATION_DRAWER.CREATE_NEW_FILE]: 'Create New File',
  [I18N_KEYS.NAVIGATION_DRAWER.CREATE_NEW_WORKFLOW]: 'Create new workflow',
  [I18N_KEYS.NAVIGATION_DRAWER.MY_FILES]: 'My Files',
  [I18N_KEYS.NAVIGATION_DRAWER.FAVORITES]: 'Favorites',
  [I18N_KEYS.NAVIGATION_DRAWER.SHARED_WITH_ME]: 'Shared with me',
  [I18N_KEYS.NAVIGATION_DRAWER.WORKSPACE_FILES]: 'Workspace Files',
  [I18N_KEYS.NAVIGATION_DRAWER.APPS]: 'Tools',
  [I18N_KEYS.NAVIGATION_DRAWER.WORKFLOWS]: 'Workflows',
  [I18N_KEYS.NAVIGATION_DRAWER.TOOLS]: 'Tools',
  [I18N_KEYS.NAVIGATION_DRAWER.TOOLKIT]: 'Explore',
  [I18N_KEYS.NAVIGATION_DRAWER.MODELS_SECTION]: 'Models',
  [I18N_KEYS.NAVIGATION_DRAWER.MODELS]: 'My Models',
  [I18N_KEYS.NAVIGATION_DRAWER.COMMUNITY]: 'Community',
  [I18N_KEYS.NAVIGATION_DRAWER.SUPPORT]: 'Support',
  [I18N_KEYS.NAVIGATION_DRAWER.DISCORD_TITLE]: 'Join our Discord',
  [I18N_KEYS.NAVIGATION_DRAWER.DISCORD_CTA]: 'Discord',
  [I18N_KEYS.NAVIGATION_DRAWER.UNIVERSAL_UPGRADE_BADGE.TITLE]: 'Ready to go beyond free plan?',
  [I18N_KEYS.NAVIGATION_DRAWER.UNIVERSAL_UPGRADE_BADGE.DESCRIPTION]:
    'Unlock more credits, unlimited workflows, and video models',
  [I18N_KEYS.NAVIGATION_DRAWER.UNIVERSAL_UPGRADE_BADGE.CTA]: 'Upgrade',
  [I18N_KEYS.NAVIGATION_DRAWER.ENTERPRISE_UPGRADE_BADGE.TITLE]: 'Upgrade to an Enterprise plan',
  [I18N_KEYS.NAVIGATION_DRAWER.ENTERPRISE_UPGRADE_BADGE.DESCRIPTION]:
    'Includes custom credit allocation, team training, and premium customer support.',
  [I18N_KEYS.NAVIGATION_DRAWER.ENTERPRISE_UPGRADE_BADGE.CTA]: 'Contact sales',
  [I18N_KEYS.NAVIGATION_DRAWER.ENTERPRISE_UPGRADE_BADGE.DISMISS]: 'Dismiss Enterprise upgrade suggestion',
  [I18N_KEYS.NAVIGATION_DRAWER.ENTERPRISE_UPGRADE_BADGE.VIEW_PLANS]: 'Or <viewPlansLink>view plans</viewPlansLink>',

  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.LOCK]: 'Lock View',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.UNLOCK]: 'Unlock View',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.LOCK_ASPECT_RATIO]: 'Lock aspect ratio',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.UNLOCK_ASPECT_RATIO]: 'Unlock aspect ratio',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.ORBIT_MODE]: 'Orbit',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.FLY_MODE]: 'Fly (WASD)',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.FLY_MODE_ARIA]: 'Fly mode. Use Q, W, E, A, S, D to navigate',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.FLY_MODE_TOOLTIP_TITLE]: 'Fly mode',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.FLY_MODE_TOOLTIP_DESCRIPTION]: 'Use keys to navigate',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.MODE]: 'Camera Mode',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.SHOW_GRID]: 'Show Grid',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.HIDE_GRID]: 'Hide Grid',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.FIELD_OF_VIEW]: 'Field of View',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.DIMENSIONS]: 'Dimensions',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.RESET]: 'Reset',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.DOWNLOAD]: 'Download',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.DOWNLOAD_ALL]: 'Download all',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.DOWNLOAD_IMAGE]: 'Download image',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.DOWNLOAD_MODEL]: 'Download 3D model',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.CURRENT]: 'Current',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.ALL]: 'All',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.SET_AS_COVER]: 'Set as cover',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.COPY_IMAGE]: 'Copy image',
  [I18N_KEYS.NODE_IMAGE_LIST.DELETE_ALL]: 'Delete all',
  [I18N_KEYS.NODE_IMAGE_LIST.DELETE_ALL_OTHERS]: 'Delete all others',
  [I18N_KEYS.NODE_IMAGE_LIST.DELETE_CURRENT]: 'Delete current',
  [I18N_KEYS.NODE_HISTORY.TITLE]: '{{nodeLabel}} version history',
  [I18N_KEYS.NODE_HISTORY.TITLE_SUFFIX]: 'version history',
  [I18N_KEYS.NODE_HISTORY.CLEAR]: 'Clear',
  [I18N_KEYS.NODE_HISTORY.CLEAR_ARIA]: 'Clear version history',
  [I18N_KEYS.NODE_HISTORY.CLEAR_CONFIRM_TITLE]: 'Clear prompt history',
  [I18N_KEYS.NODE_HISTORY.CLEAR_CONFIRM_MESSAGE]: "This will delete this prompt node history. You can't undo this.",
  [I18N_KEYS.NODE_HISTORY.CLEAR_CONFIRM_DONT_SHOW]: "Don't show this again",
  // Figma 54673:32108 / 54673:32353 — single-line empty copy (no subtitle).
  [I18N_KEYS.NODE_HISTORY.EMPTY_TITLE]: 'No versions history',
  [I18N_KEYS.NODE_HISTORY.ERROR_TITLE]: "Couldn't load version history",
  [I18N_KEYS.NODE_HISTORY.ERROR_SUBTITLE]: 'Press Escape or click away, then reopen to try again.',
  [I18N_KEYS.NODE_HISTORY.LOAD_MORE]: 'Load more',
  [I18N_KEYS.NODE_HISTORY.LOAD_MORE_RETRY]: 'Retry',
  [I18N_KEYS.NODE_HISTORY.LOADING]: 'Loading…',
  [I18N_KEYS.NODE_HISTORY.RESTORE]: 'Restore',
  [I18N_KEYS.NODE_HISTORY.RESTORE_TEXT_ONLY]: 'Text only',
  [I18N_KEYS.NODE_HISTORY.RESTORE_TEXT_AND_VARIABLES]: 'Text and variables',
  [I18N_KEYS.NODE_HISTORY.COPY]: 'Copy',
  [I18N_KEYS.NODE_HISTORY.COPIED]: 'Copied',
  [I18N_KEYS.NODE_HISTORY.RUNS + '_one']: '{{count}} run',
  [I18N_KEYS.NODE_HISTORY.RUNS + '_other']: '{{count}} runs',
  [I18N_KEYS.NODE_HISTORY.ITERATIONS + '_one']: '{{count}} iteration',
  [I18N_KEYS.NODE_HISTORY.ITERATIONS + '_other']: '{{count}} iterations',
  [I18N_KEYS.NODE_HISTORY.WITH_ITERATIONS]: '{{runs}} · {{iterations}}',
  [I18N_KEYS.NODE_HISTORY.WITH_ITERATIONS_EACH]: '{{runs}} · {{iterations}} each',
  [I18N_KEYS.NODE_HISTORY.ITERATIONS_VARY]: '{{runs}} · iterations vary',
  [I18N_KEYS.PAYMENTS.CREDITS_SUCCESS_MESSAGE]: '<amount/> Credits added successfully!',
  [I18N_KEYS.PAYMENTS.UPGRADE_SUCCESS_MESSAGE]: 'Your plan has been upgraded to <plan/> successfully!',
  [I18N_KEYS.PAYMENTS.DOWNGRADE_SUCCESS_MESSAGE]: 'Your plan has been updated to <plan/> successfully.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_INFO_VIDEO_MINUTES]:
    '= ~{{numMinutes, number}} min of video or {{numImages, number}} images',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.NO_VIDEO_MODELS]: 'No access to video AI models',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.NO_WORKFLOW_HISTORY]: 'No workflow history',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.ALL_MODELS]: 'Full access to all AI models, including video generation',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.ADVANCED_ADMIN]: 'Advanced admin tooling for team and credit management',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.PROFESSIONAL_GRADE_EDITING_TOOLS]: 'Professional-grade editing tools',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.FIVE_WORKFLOWS]: '5 workflows',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.ALL_IMAGE_MODELS]: 'Full access to all AI image models',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.UNLIMITED_WORKFLOWS]: 'Unlimited workflows',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.CREDIT_TOP_UP]:
    'Top up at ${{price, number}} / {{credits, number}} credits',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.THREE_MONTH_CREDIT_ROLLOVER]: '3-month credit rollover',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.FOUR_MONTH_CREDIT_ROLLOVER]: '4-month credit rollover',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.WORKSPACE_FILE_SHARING]: 'Workspace file sharing',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.SHARED_CREDIT_POOL]: 'Shared credit pool for maximal efficiency',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.UNIFIED_BILLING]: 'Unified billing',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.TEAM_MEMBERS_ADMINISTRATION]: 'Team members administration',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.TEAM_CREDITS_MANAGEMENT]: 'Team credits management',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.WORKFLOW_COLLABORATION]: 'Workflow collaboration feature',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TITLE]: 'Choose the best plan for you',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.SUBTITLE.ALL_PACKAGES_INCLUDE]: 'All plans will provide you with',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.SUBTITLE.INCLUDED_FEATURE_01]: 'Full access to all AI models',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.SUBTITLE.INCLUDED_FEATURE_02]: 'Professional editing tools',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.SUBTITLE.INCLUDED_FEATURE_03]: 'Commercial license',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TEMP_TITLE]: 'Flexible pricing for your needs',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TOGGLE_BUTTON.MONTHLY]: 'Monthly',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TOGGLE_BUTTON.YEARLY]: 'Annually',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TOGGLE_BUTTON.YEARLY_FIXED_DISCOUNT]: '-{{discountPercent}}%',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TOGGLE_BUTTON.YEARLY_SAVE_DISCOUNT]: 'Save {{discountPercent}}%',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.ANNUAL_DISCOUNT_BANNER]: 'New: Annual plans are now 30% off',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TOGGLE_BUTTON.YEARLY_UP_TO_DISCOUNT]: 'Save up to 30%',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CURRENT_PLAN_CTA]: 'Current Plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.PRICE_SUFFIX_MONTH]: '/ month',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.PRICE_SUFFIX_USER_MONTH]: '/ user / month',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.UPGRADE_CTA]: 'Upgrade',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CHANGE_PLAN_CTA]: 'Change Plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.MONTHLY_CREDITS]: '{{monthlyCredits, number}} monthly credits',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.MONTHLY_CREDITS_PER_USER]: '{{monthlyCredits, number}} monthly credits / user',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_INFO_IMAGES]: '= {{numImages, number}} images',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_INFO_IMAGES_VIDEOS]:
    '= {{numImages, number}} images or {{numSeconds, number}} sec video',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURES_TITLE]: 'Everything in {{planType}}, plus -',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FREE_PLAN.NAME]: 'Free',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.STARTER_PLAN.NAME]: 'Starter',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.PRO_PLAN.NAME]: 'Pro',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.MAX_PLAN.NAME]: 'Max',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TEAM_PLAN.NAME]: 'Team',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FREE_PLAN.DESCRIPTION]: "Explore Figma Weave's possibilities",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.STARTER_PLAN.DESCRIPTION]: 'For occasional creative projects',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.PRO_PLAN.DESCRIPTION]: 'For professionals creating regularly',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.MAX_PLAN.DESCRIPTION]: 'For professionals creating at scale',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.INDIVIDUALS]: 'Individuals',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TEAMS]: 'Teams',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FOR_TEAMS]: 'For teams',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.AUDIENCE]: 'Plan audience',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.BEST_VALUE]: 'Best value',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FEATURE.LOWEST_COST_PER_CREDIT]: 'Lowest cost per credit of any plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.MAX_LAUNCH_PROMOTION]:
    '{{discountPercent}}% off {{model}} through year end. Annual plans only, sign up before {{signupDeadline}}.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TEAM_PLAN.DESCRIPTION]: 'For larger teams working collaboratively',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FREE_PLAN_CTA]: 'Start Free',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.PAID_PLAN_CTA]: 'Get This Plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.PAID_ANNUAL_PLAN_CTA]: 'Get Annual Plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.DOWNGRADE_DATE_PREFIX]: 'Starting on',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.RESTORE_PLAN]: 'Restore current plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.RESTORE_CONFIRMATION_TITLE]: 'Restore your plan?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.RESTORE_CONFIRMATION_MESSAGE]: 'Your plan will be restored to its previous state.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.RESTORE_CONFIRMATION_CONFIRM_TEXT]: 'Restore',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_TABLE_TITLE]:
    "See exactly what you can produce with each plan's monthly credits",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_TABLE.ARIA_LABEL]: 'Model usage by plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_TABLE.CATEGORY]: 'Category',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_TABLE.MODEL]: 'Model',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_TABLE.IMAGE]: 'Image',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_TABLE.VIDEO]: 'Video',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_TABLE.THREE_D]: '3D',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_TABLE.AUDIO]: 'Audio',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_TABLE.MONTHLY_CREDITS]: 'Credits/mo',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.PARTNERS_TITLE]: 'Empowering production grade creative work at',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQ_TITLE]: 'Frequently Asked Questions',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.COMING_SOON]: 'Coming soon',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.MOST_POPULAR]: 'Most popular',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.RECOMMENDED]: 'Recommended',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.BILLED_ANNUALLY]: 'billed annually as {{price}}',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.GAIN_20_PERCENT]: 'Gain +20%',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.DISCOUNT.BANNER]: 'Up to 50% off your first month*',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.DISCOUNT.FIRST_MONTH]: 'First month is only {{discounted}}, then {{full}} / month',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.DISCOUNT.FIRST_YEAR]: 'First year is only {{discounted}}, then {{full}} / year',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.DISCOUNT.FOOTNOTE]:
    '*New users only. One redemption per customer only. Enterprise plans, subscriptions purchased prior to {{goLiveDate}}, and downgrades excluded.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_1.QUESTION]: 'How do Figma Weave credits work?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_1.ANSWER]:
    'Figma Weave credits are your currency for AI generation. Each plan includes a monthly credit allocation that you spend when creating content with different AI models. Different models require different amounts of credits per generation - for example, running Flux costs fewer credits than using Veo. See the full list <link/>.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_2.QUESTION]: 'What happens if I use all my monthly credits?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_2.ANSWER]:
    "For paid plans (Starter, Professional, and Team), you can purchase additional credits at $10 per 1,000 credits (Starter) or $10 per 1,200 credits (Professional and Team). These topped-up credits roll over for 12 months, giving you flexibility beyond your monthly allocation. The Free plan doesn't offer credit top-ups.",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_2.ANSWER_MAX]:
    "For paid plans (Starter, Professional, Max, and Team), you can purchase additional credits at $10 per 1,000 credits (Starter) or $10 per 1,200 credits (Professional, Max, and Team). These topped-up credits roll over for 12 months, giving you flexibility beyond your monthly allocation. The Free plan doesn't offer credit top-ups.",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_3.QUESTION]: 'Do unused credits roll over to the next month?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_3.ANSWER]:
    'If you’re on a Professional or Team plan, your base monthly credits roll over to the next month - as long as your subscription stays active. You can accumulate up to 3x your monthly credit amount. After that, any unused credits above the limit will expire. Starter and Free plans don’t include rollover. Any additional credits purchased through top-ups continue to roll over for 12 months from the purchase date.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_3.ANSWER_MAX]:
    '<p>If you’re on a Professional, Max, or Team plan, unused base monthly credits roll over to the next month as long as your subscription stays active. You can accumulate:</p><ul><li><strong>Professional and Team:</strong> Up to 3× your monthly credit amount.</li><li><strong>Max:</strong> Up to 4× your monthly credit amount.</li></ul><p>After that, any unused credits above the limit will expire.</p><p>Starter and Free plans don’t include rollover. Any additional credits purchased through top-ups continue to roll over for 12 months from the purchase date.</p>',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_4.QUESTION]:
    'Can I use Figma Weave creations for client work and commercial projects?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_4.ANSWER]:
    "Absolutely! We offer one of the most advanced commercial rights policies in the industry. Figma Weave as a platform provides full commercial rights and we never train on your work. Most models available through our platform are cleared for commercial use and don't train on customer data.\nAs an open platform, we also give you access to cutting-edge models that may have different terms. We negotiate the best legal and commercial terms available with all providers for your benefit. For complete transparency, check our <link/> in our Trust Center to see commercial rights status for each model.",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_5.QUESTION]: 'How does Figma Weave handle my data and creations?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_5.ANSWER]:
    "Your creative work stays yours. We don't use your images or prompts to train our platform. We implement strict data standards and security measures to protect your content. We only collect essential data to provide our services and anonymous metadata about workflows to improve recommendations.",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_6.QUESTION]: "What is Figma Weave's refund and cancellation policy?",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_6.ANSWER]:
    "You can cancel your subscription at any time through your account settings or by contacting our support team. Your subscription will remain active until the end of your current billing period. We don't provide prorated refunds for partial months of service.\nIf you're not satisfied with your subscription within the first 7 days after signing up, contact our support team for a refund evaluation.",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_7.QUESTION]: 'Does Figma Weave provide workshops and training?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_7.ANSWER]:
    'Yes! We provide free office hours, a comprehensive VOD library of educational content, and a template library filled with incredible workflows to jumpstart your creative process. Enterprise clients get team training sessions. Contact us directly if you have a specific training or educational need.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_8.QUESTION]: 'Can I control how my team uses credits?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_8.ANSWER]:
    'Yes! With the Team plan, you get access to our Credits Management system. Set a monthly default or custom allocation per user, track usage in real time, and stay in control.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_9.QUESTION]: 'Still have questions?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_9.ANSWER]:
    "We're here to help! Reach out to us at <link/> and our team will get back to you promptly.",
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.TITLE]: 'Confirm upgrade',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.PROCESSING]: 'Processing',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.PLAN_DESCRIPTION]: 'Figma Weave <plan/> subscription',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.PRICE_PER_MONTH]: '{{price}}/mo',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.PRICE_PER_YEAR]: '{{price}}/yr',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.PAYMENT_METHOD_LABEL]: 'Payment method',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.CHANGE_PAYMENT_METHOD]: 'Change',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.ERROR_MESSAGE]:
    'Something went wrong. Please try again. If the problem continues, <link/>',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.ERROR_MESSAGE_LINK]: 'contact our support team',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.BILLING_CYCLE_INFO]: 'Billed <billingCycle/>, starting today',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.CTA_CONFIRM]: 'Pay now',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.TITLE]: 'Confirm plan change',
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.INDIVIDUAL_PLAN_TITLE]: 'Downgrade to Individual Plan',
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.INDIVIDUAL_PLAN_CHANGE_MESSAGE]:
    "You're about to downgrade to <plan/>, a plan for individuals. Your current plan will remain active until the end of your billing period.",
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.MEMBER_ACCESS_WARNING]:
    'On downgrade, other members will lose access to this team, and their files will be transferred to the team owner.',
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.PLAN_CHANGE_MESSAGE]:
    "You're about to downgrade to the <plan/> plan. Your current plan will remain active until the end of your billing period.",
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.MONTHLY_PLAN_CHANGE_MESSAGE]:
    "You're about to downgrade to the <plan/> plan, billed monthly. Your current plan will remain active until the end of your billing period.",
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.CTA_CONFIRM]: 'Downgrade',
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.TITLE]: 'Purchase additional credits',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.CTA_CONFIRM]: 'Purchase',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.EQUALS]: 'Equals to',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.MIN_PRICE_ERROR]: 'Minimum price is ${{minPrice}}',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.AMOUNT_LABEL]: 'Amount',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.CREDITS_AMOUNT]: '{{credits}} credits',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.GENERATIONS_ESTIMATE]:
    '~ {{images}} images or {{videoSeconds}} seconds of video',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.TITLE]: 'Get more credits',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.SUBTITLE]: 'Choose one of the following options -',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_CREDITS.TITLE]: 'Buy more credits',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_CREDITS.SUBTITLE]: 'Purchase additional credits for immediate use',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_PRICING.TITLE]: 'Upgrade your plan',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_PRICING.SUBTITLE]: 'Get more credits monthly',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_CONFIRM]: 'Continue',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.PAYMENTS.TEAM_SIZE_MODAL.TITLE]: 'How many people are on your team?',
  [I18N_KEYS.PAYMENTS.TEAM_SIZE_MODAL.SUBTITLE]:
    'Select the number of people on your team. Each seat costs {{pricePerSeat}} / {{billingCycle}}.',
  [I18N_KEYS.PAYMENTS.TEAM_SIZE_MODAL.CTA_CONFIRM]: 'Continue',
  [I18N_KEYS.PAYMENTS.TEAM_SIZE_MODAL.DISCOUNT_DISCLAIMER]: '* Your first-month discount will be applied at checkout',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TEAM_DESCRIPTION_MAX]: 'For in-house and agency visual teams',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.MAX_LAYOUT_DESCRIPTION]: 'For large teams with complex workflows',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.PLAN_NAME]: 'Enterprise',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.PRICE]: 'Custom',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.TITLE]: 'Looking for an enterprise solution?',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.SUBTITLE]: 'Our Enterprise plan contains everything in Team, plus:',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.CTA]: 'Contact Sales',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_CUSTOM_CREDITS]: 'Custom credit allocation',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_TEAM_TRAINING]: 'Team training',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_PREMIUM_SUPPORT]: 'Premium customer support on Slack',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_OWN_API_KEYS]: 'Your own API keys',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_API_WORKFLOWS]: 'Run workflows through API',

  [I18N_KEYS.PAYWALLS.FREE_PLAN_PAYWALL.DESCRIPTION]: 'Upgrade to {{targetPlan}} for {{features}}, and more.',
  [I18N_KEYS.PAYWALLS.VOICE_INPUT_PAYWALL.TITLE]: 'Want to dictate your prompts?',
  [I18N_KEYS.PAYWALLS.VOICE_INPUT_PAYWALL.DESCRIPTION]:
    "The {{currentPlan}} plan doesn't include voice dictation. Upgrade to {{targetPlan}} to speak your prompts instead of typing them.",
  [I18N_KEYS.PAYWALLS.VOICE_INPUT_PAYWALL.FEATURES.VOICE_DICTATION]: 'Voice dictation in prompts',
  [I18N_KEYS.PAYWALLS.VIDEO_MODEL_PAYWALL.TITLE]: 'Need video models?',
  [I18N_KEYS.PAYWALLS.VIDEO_MODEL_PAYWALL.FULL_PRICING_DESCRIPTION]:
    'Upgrade to unlock video generation, unlimited workflows, and more.',
  [I18N_KEYS.PAYWALLS.CUSTOM_FONTS_PAYWALL.TITLE]: 'Want to use your own fonts?',
  [I18N_KEYS.PAYWALLS.CUSTOM_FONTS_PAYWALL.DESCRIPTION]:
    "The {{currentPlan}} plan doesn't include custom fonts. Upgrade to {{targetPlan}} to upload your brand fonts and use them in your designs.",
  [I18N_KEYS.PAYWALLS.CUSTOM_FONTS_PAYWALL.FEATURES.CUSTOM_FONTS]: 'Custom workspace fonts',

  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.ADD_NODES_CONTENT]:
    'Drag and drop the "Flux Fast" node from the menu to your canvas.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.ADD_NODES_TITLE]: 'Add a model',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CHOOSE_PREFERENCE_CONTENT]:
    "We'll tailor our instructions to work best with your device.",
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CHOOSE_PREFERENCE_CTA_MOUSE]: 'Mouse',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CHOOSE_PREFERENCE_CTA_TRACKPAD]: 'Trackpad',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CHOOSE_PREFERENCE_TITLE]: 'What are you using?',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CONNECT_NODES_CONTENT]:
    'Click and drag from the output handle of the Prompt node, to the input handle of the "Flux Fast" node.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CONNECT_NODES_TITLE]: 'Connect the nodes',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.DROP_NODE_HERE]: 'Drop here',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.FINISH_TOUR_CONTENT]:
    "You've just created your first image with Figma Weave. Ready to explore more?",
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.FINISH_TOUR_CTA_CONTINUE]: 'Continue to the next tutorial',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.FINISH_TOUR_CTA_STOP]: 'Start working on this workflow',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.FINISH_TOUR_TITLE]: 'Amazing work!',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.PAN_CONTENT + '_mouse']:
    'Hold Spacebar and left click and drag to pan.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.PAN_CONTENT + '_trackpad']: 'Use two fingers to pan.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.PAN_TITLE]: 'Move to center the white circles',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.RUN_MODEL_CONTENT]:
    'Click the "Run Model" button to execute your workflow.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.RUN_MODEL_TITLE]: 'Generate your first image',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.SHOW_NODE_CONTENT]:
    'This is a Prompt node. It holds the text prompt that guides your AI image generation.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.SHOW_NODE_TITLE]: 'Meet your first node',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.WELCOME_CONTENT]:
    "You're about to learn how to create your first workflow - a simple text to image generation.",
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.WELCOME_TITLE]: 'Welcome to the Figma Weave Editor',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.ZOOM_CONTENT + '_mouse']:
    'Hold cmd/ctrl and scroll mouse wheel to zoom.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.ZOOM_CONTENT + '_trackpad']: 'Pinch two fingers to zoom.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.ZOOM_TITLE]: 'Zoom in to fit the node into the box',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.SAVE_NODES_TOUR.SAVE_CTA_TITLE]: "Save what's working",
  [I18N_KEYS.PRODUCT_TOURS.FLOW.SAVE_NODES_TOUR.SAVE_CTA_CONTENT]:
    'Save your customized nodes, models and workflows to use in other places.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.SAVE_NODES_TOUR.SAVE_CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.SAVE_NODES_TOUR.SAVE_CTA_NEXT]: 'Next',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.SAVE_NODES_TOUR.VIEW_SAVED_ITEMS_TITLE]: 'Click. Drag. Repeat.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.SAVE_NODES_TOUR.VIEW_SAVED_ITEMS_CONTENT]:
    "To reuse something you've saved, drag it right onto your canvas.",
  [I18N_KEYS.PRODUCT_TOURS.FLOW.SAVE_NODES_TOUR.VIEW_SAVED_ITEMS_CTA_GOT_IT]: 'Got it',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.INTRO_TITLE]: 'Turn your workflow into a reusable tool',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.INTRO_CONTENT]:
    'Got a great workflow? Package it into a tool so others can run it in a few clicks. They just add inputs and get results, easy as that.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.INTRO_CTA_LEARN_MORE]: 'Learn more',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.INTRO_CTA_GET_STARTED]: 'Get started',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.CTA_GOT_IT]: 'Got it',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.OUTPUT_TITLE]: "Choose your tool's outputs",
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.OUTPUT_CONTENT]:
    'Outputs are the results someone gets when they run your tool. Select one or more nodes to set as outputs.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.INPUTS_TITLE]: 'Configure your inputs',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.INPUTS_CONTENT]:
    'Choose which inputs end users can see, then add descriptions, set defaults, and mark which are required.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.DETAILS_TITLE]: 'Add tool details',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.DETAILS_CONTENT]:
    'Set a name, thumbnail, and description so your users know what your tool does.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.PREVIEW_TITLE]: 'Preview your tool',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.PREVIEW_CONTENT]:
    "Go on, kick the tires. Run it with different inputs, check the results, and make sure it's in tip-top shape.",
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.PREVIEW_CTA]: 'Preview tool',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.TOGGLE_MOVED_TITLE]: 'Tool creation got an update',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.TOGGLE_MOVED_CONTENT]:
    'Output node is no longer needed. Use this toggle to switch between workflow building and tool configuration.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.TOOL_BUILDER_TOUR.TOGGLE_MOVED_CTA]: 'Show me',
  [I18N_KEYS.PRODUCT_TOURS.NEXT_STEP]: 'Next',
  [I18N_KEYS.PRODUCT_TOURS.PREVIOUS_STEP]: 'Back',
  [I18N_KEYS.PRODUCT_TOURS.QUIT_TOUR_CONFIRMATION_CANCEL]: 'Cancel',
  [I18N_KEYS.PRODUCT_TOURS.QUIT_TOUR_CONFIRMATION_CTA]: 'Quit',
  [I18N_KEYS.PRODUCT_TOURS.QUIT_TOUR_CONFIRMATION_MESSAGE]: "Your progress in this tutorial won't be saved.",
  [I18N_KEYS.PRODUCT_TOURS.QUIT_TOUR_CONFIRMATION_TITLE]: 'Quit tutorial?',
  [I18N_KEYS.PRODUCT_TOURS.START_OF_TOUR.SKIP]: 'Skip for Now',
  [I18N_KEYS.PRODUCT_TOURS.START_OF_TOUR.START_NOW]: 'Start Tutorial',
  [I18N_KEYS.PRODUCT_TOURS.TOUR_STEP_INDICATION]: '{{step}} of {{total}}',
  [I18N_KEYS.PRODUCT_TOURS.WELCOME_TEMPLATE_GALLERY.TITLE]: 'Welcome to Figma Weave',
  [I18N_KEYS.PRODUCT_TOURS.WELCOME_TEMPLATE_GALLERY.CONTENT]:
    'Create AI workflows out of models, images and more, turning your best ideas into repeatable systems.',
  [I18N_KEYS.PRODUCT_TOURS.WELCOME_TEMPLATE_GALLERY.GET_STARTED]: 'Get started',
  [I18N_KEYS.PRODUCT_TOURS.NUX_EMPTY_CANVAS_TOUR.WRITE_PROMPT.TITLE]: 'Write your first prompt',
  [I18N_KEYS.PRODUCT_TOURS.NUX_EMPTY_CANVAS_TOUR.WRITE_PROMPT.CONTENT]:
    'Describe what you want to create and how you want it to look or feel.',
  [I18N_KEYS.PRODUCT_TOURS.NUX_EMPTY_CANVAS_TOUR.CONNECT_NODE.TITLE]: 'Connect another node',
  [I18N_KEYS.PRODUCT_TOURS.NUX_EMPTY_CANVAS_TOUR.CONNECT_NODE.CONTENT]:
    'Drag an edge from the highlighted handle, then drop it on the canvas to choose a compatible node.',
  [I18N_KEYS.PRODUCT_TOURS.NUX_EMPTY_CANVAS_TOUR.ADD_MODEL.TITLE]: 'Add a model',
  [I18N_KEYS.PRODUCT_TOURS.NUX_EMPTY_CANVAS_TOUR.ADD_MODEL.CONTENT]:
    'Choose one of the model options from the menu—such as ChatGPT Images 2.0—to add it to your canvas.',
  [I18N_KEYS.PRODUCT_TOURS.NUX_EMPTY_CANVAS_TOUR.RUN_MODEL.TITLE]: 'Generate your image',
  [I18N_KEYS.PRODUCT_TOURS.NUX_EMPTY_CANVAS_TOUR.RUN_MODEL.CONTENT]:
    'Select Run model to create an image from your prompt. Generation usually takes 1–2 minutes.',
  [I18N_KEYS.PRODUCT_TOURS.NUX_EMPTY_CANVAS_TOUR.MAKE_IT_YOUR_OWN.TITLE]: 'Make it your own',
  [I18N_KEYS.PRODUCT_TOURS.NUX_EMPTY_CANVAS_TOUR.MAKE_IT_YOUR_OWN.CONTENT]:
    'Use editing tools to crop, resize, and adjust your image’s colors.',
  [I18N_KEYS.PRODUCT_TOURS.NUX_EMPTY_CANVAS_TOUR.MAKE_IT_YOUR_OWN.ENDING]: 'Got it',

  [I18N_KEYS.RECIPE_MAIN.ERRORS.DOWNLOAD_FAILED]: 'Download failed',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.EXPORT_AUDIT_TRAIL_FAILED]: 'Could not export the audit trail',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.DOWNLOAD_FAILED_MULTIPLE]: 'Download failed for multiple files',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.DOWNLOAD_SIZE_EXCEEDED]: 'Selected files are {{size}}, exceeding the {{limit}} limit',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.CLEAR_CONTENT_FAILED]: 'Failed to clear content. Please try again.',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.PASTE_NODES_FAILED]: 'Failed to paste nodes. Please try again.',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.INSERT_NODES_FAILED]: 'Failed to add nodes. Please try again.',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.COMMENTS.POST_FAILED]: "Couldn't post your comment. Please try again.",
  [I18N_KEYS.RECIPE_MAIN.ERRORS.COMMENTS.EDIT_FAILED]: "Couldn't save your edit. Please try again.",
  [I18N_KEYS.RECIPE_MAIN.ERRORS.COMMENTS.RESOLVE_FAILED]: "Couldn't resolve the thread. Please try again.",
  [I18N_KEYS.RECIPE_MAIN.ERRORS.COMMENTS.REOPEN_FAILED]: "Couldn't reopen the thread. Please try again.",
  [I18N_KEYS.RECIPE_MAIN.ERRORS.COMMENTS.DELETE_FAILED]: "Couldn't delete the comment. Please try again.",
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.COMPOSER_INPUT_ARIA]: 'Comment',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.COMPOSER_PLACEHOLDER]: 'Add a comment',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.POST_ARIA]: 'Post comment',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.POSTING]: 'Posting comment',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.PIN_ARIA]: 'Comment by {{name}}',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.DELETED_USER]: 'Deleted user',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.JUST_NOW]: 'Just now',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.THREAD_TITLE]: 'Comment',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.RESOLVE]: 'Mark as resolved',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.REOPEN]: 'Reopen',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.CLOSE_THREAD]: 'Close',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.REPLY_PLACEHOLDER]: 'Reply',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.POST_REPLY_ARIA]: 'Post reply',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.EDITED]: '(edited)',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.MORE_ARIA]: 'More actions',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.EDIT]: 'Edit',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.DELETE]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.EDIT_ARIA]: 'Edit comment',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.SAVE_ARIA]: 'Save',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.DELETE_THREAD_TITLE]: 'Delete this thread?',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.DELETE_THREAD_MESSAGE]:
    'The comment and all its replies will be deleted for everyone.',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.DELETE_REPLY_TITLE]: 'Delete this reply?',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.DELETE_REPLY_MESSAGE]: 'The reply will be deleted for everyone.',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.PANEL_TITLE]: 'Comments',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.PANEL_EMPTY]:
    'Give feedback, ask a question, or just leave a note of appreciation. Click anywhere in the file to leave a comment.',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.FILTER_ARIA]: 'Filter comments',
  [I18N_KEYS.RECIPE_MAIN.COMMENTS.SHOW_RESOLVED]: 'Show resolved comments',
  [`${I18N_KEYS.RECIPE_MAIN.COMMENTS.REPLIES}_one`]: '{{count}} reply',
  [`${I18N_KEYS.RECIPE_MAIN.COMMENTS.REPLIES}_other`]: '{{count}} replies',
  [I18N_KEYS.RECIPE_MAIN.DOWNLOAD_PREPARING]: 'Preparing download... {{percent}}%',
  [`${I18N_KEYS.RECIPE_MAIN.NODE_EXPORT_DOWNLOADING}_one`]: 'Downloading {{nodeName}}',
  [`${I18N_KEYS.RECIPE_MAIN.NODE_EXPORT_DOWNLOADING}_other`]: 'Downloading {{count}} videos',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.GENERAL.MESSAGE]: 'An error occurred while saving.',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.GENERAL.ACTION]: 'Try again',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.CONFLICT.MESSAGE]:
    "Editing is paused — you're on an older version of this workflow. Refresh to load the latest version and keep editing.",
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.CONFLICT.ACTION]: 'Refresh',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.MULTI_TAB.MESSAGE]:
    'This workflow is open in another tab. Refresh here to continue.',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.MULTI_TAB.ACTION]: 'Refresh',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.CONNECTION.MESSAGE]:
    'Connection lost. Check your network and refresh. If the problem continues, <support>contact support</support>.',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.CONNECTION.ACTION]: 'Refresh',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CANNOT_DELETE_GROUP_WITH_LOCKED_NODES]:
    'Cannot delete group because it contains locked nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CANNOT_ADD_NODES_IN_TOOL_TAB]: 'Switch to Canvas to add nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CANNOT_EDIT_IN_TOOL_TAB]: 'Switch to Canvas to edit nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.OUTPUTS]: 'Outputs',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.INPUTS]: 'Inputs',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.INPUTS_DESCRIPTION]:
    "Set each input's visibility, description, default value, and requirement.",
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.TOOL_DETAILS]: 'Tool details',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.FILL_IN_TOOL_DETAILS]: 'Fill in tool details',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.THUMBNAIL_LABEL]: 'Thumbnail',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.NAME_REQUIRED]: 'Name *',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.TOOL_DESCRIPTION_PLACEHOLDER]: 'What does this tool do?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.SHOW_WORKFLOW_TO_VIEWERS]:
    'Show the underlying workflow to viewers',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.REMOVE_THUMBNAIL_ARIA]: 'Remove thumbnail',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.THUMBNAIL_SCOPE_IN_OUTPUTS]: 'In outputs',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.THUMBNAIL_OUTPUTS_GALLERY_EMPTY]:
    'No JPEG or PNG images in the outputs yet. Run the workflow, or pick one from the whole workflow.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.THUMBNAIL_WORKFLOW_GALLERY_EMPTY]:
    'This workflow has no JPEG or PNG images to choose from.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.TOOL_VERSION_AVAILABLE]: 'Tool version available',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.GO_TO_TOOL]: 'Go to tool',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EDIT_TOOL_DETAILS_ARIA]: 'Edit tool details',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.ADD_OUTPUT]: 'Add output',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.COLLAPSE_SECTION_ARIA]: 'Collapse {{section}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EXPAND_SECTION_ARIA]: 'Expand {{section}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.PREVIEW_AND_FINALIZE]: 'Preview and finalize',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.TOOL_NAME_MISSING]: 'Tool name missing',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.SHOW_WORKFLOW_TO_VIEWERS_HELPER]:
    'Anyone who can see this tool can also view and copy its workflow.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.THUMBNAIL_TYPE_INVALID]: 'Use a JPEG or PNG image.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.SELECT_OUTPUT]: 'Select output',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.NO_ELIGIBLE_OUTPUTS]: 'No nodes can be an output yet.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EMPTY_NO_OUTPUTS_LINE_1]: 'No outputs added yet.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EMPTY_NO_OUTPUTS_LINE_2]:
    'Click the plus button to add your first output.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EDIT_DATA_TITLE]: 'Edit {{nodeName}} data',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.DESCRIPTION]: 'Description',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.DESCRIPTION_PLACEHOLDER]: 'How to use this input',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.DEFAULT_CONTENT]: 'Default value',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.DEFAULT_VALUE_PLACEHOLDER]: 'Add default value',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.USE_NODE_VALUE]: 'Use node value',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.ADD_NEW_CONTENT]: 'Use new content',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.ADD_NEW_CONTENT_UNSUPPORTED]: 'Only node value is supported.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.IMAGE_DEFAULT]: 'Image default',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.UPLOADING]: 'Uploading image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.REMOVE_IMAGE]: 'Remove image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.MANDATORY]: 'Mandatory',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.MANDATORY_FORCED_TOOLTIP]:
    "Can't set as optional as used as mandatory input",
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EXAMPLE_CONTENT]: '{{nodeName}} examples',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EXAMPLE_CONTENT_DESCRIPTION]:
    'Select examples from the node to be visible in the tool empty state.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EXAMPLE_EMPTY_DESCRIPTION]:
    'Upload examples from to be visible in the tool empty state.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EXAMPLE_TILE_ARIA]: 'Example {{index}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.UPLOADED_EXAMPLE_TILE_ARIA]: 'Uploaded example {{index}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.UPLOAD_EXAMPLE]: 'Upload example',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.UPLOADED_EXAMPLES]: 'Uploaded examples',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EXAMPLES_LIMIT_REACHED]:
    'An output can have up to {{count}} examples',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.UPLOADS_LIMIT_REACHED]:
    'An output can keep up to {{count}} uploads. Delete one with its X to make room.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.REMOVE_EXAMPLE]: 'Remove example {{index}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.UPLOADING_EXAMPLE]: 'Uploading example',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EDIT_EXAMPLE_ARIA]: 'Edit examples',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.SET_AS_OUTPUT]: 'Set as output',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.CANNOT_SET_AS_OUTPUT]: 'Can’t set as output',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.OUTPUT_BADGE]: 'Output',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.INPUT_BADGE]: 'Input',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.HIDDEN_INPUT_BADGE]: 'Hidden',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.REMOVE_OUTPUT_ARIA]: 'Remove output',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.EXPOSE_INPUT_ARIA]: 'Expose input',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.HIDE_INPUT_ARIA]: 'Hide input',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.REORDER_INPUT_ARIA]: 'Drag to reorder',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.REORDER_OUTPUT_ARIA]: 'Drag to reorder',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.PICK_OUTPUT_PROMPT]: 'Click on a node to select it as a tool output',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.EDIT_INPUT_DETAILS_ARIA]: 'Edit input details',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.DELETE_TOOL_OUTPUT_TITLE]: 'Delete tool output node?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.DELETE_TOOL_OUTPUT_MESSAGE]:
    "This node is set as this tool's output. Deleting it will remove it from the tool's current draft version - any created or published versions of the tool won't be affected.",
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.DELETE_TOOL_OUTPUT_CONFIRM]: 'Delete node',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.DISCONNECT_TOOL_OUTPUT_TITLE]: 'Disconnect this tool output?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.DISCONNECT_TOOL_OUTPUT_MESSAGE]:
    "This is the last connection into a node set as this tool's output. Removing it also removes that output from the current draft. Published versions are unchanged.",
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_CANVAS.DISCONNECT_TOOL_OUTPUT_CONFIRM]: 'Disconnect',
  [I18N_KEYS.RECIPE_MAIN.FLOW.FLOW_NAVBAR.READ_ONLY]: 'Read Only',
  [I18N_KEYS.RECIPE_MAIN.FLOW.FLOW_NAVBAR.SAVING]: 'Saving',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DELETE_ALL_GENERATIONS]: 'Remove all generations',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DELETE_ALL_OTHERS_GENERATIONS]: 'Remove all other generations',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DELETE_CURRENT_GENERATION]: 'Remove current generation',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DOWNLOAD_CURRENT]: 'Download current',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DOWNLOAD_SELECTED]: 'Download selected',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DOWNLOAD_ALL]: 'Download all',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DOWNLOAD_BATCH]: 'Download batch',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.FULL_SCREEN]: 'Full screen',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.SET_AS_COVER]: 'Set as cover image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.HIDE_INFO]: 'Hide Info',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.NEGATIVE_PROMPT]: 'Negative Prompt',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.PARAMETERS]: 'Parameters',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.MODEL]: 'Model',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.PROMPT]: 'Prompt',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.NO_PREVIEW]: 'No preview available',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.SHOW_INFO]: 'Show Info',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.SHOW_MORE]: 'Show more',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.SHOW_LESS]: 'Show less',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.REFERENCE_IMAGE + '_one']: 'Reference Image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.REFERENCE_IMAGE + '_other']: 'Reference Images',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.CTA_EDITOR]: 'Back to latest version',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.CTA_READER]: 'Duplicate to My Files',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.CTA_GUEST]: 'Sign in',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.CTA_LIVE_DRAFT]: 'See latest draft',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.TITLE_SINGLE]: 'Delete group',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.TITLE_PLURAL]: 'Delete groups',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.MESSAGE_SINGLE]:
    'Are you sure you want to delete {{groupName}}?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.MESSAGE_PLURAL]:
    'Are you sure you want to delete these {{count}} groups?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.CTA_CONFIRM]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.CHECKBOX_LABEL]: "Don't show this again",
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_ALL_CONTENT_CONFIRMATION.TITLE]: 'Clear all content?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_ALL_CONTENT_CONFIRMATION.MESSAGE]:
    'This will remove all content from selected nodes.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_ALL_CONTENT_CONFIRMATION.CHECKBOX_LABEL]: "Don't show this again",
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_OTHER_CONTENT_CONFIRMATION.TITLE]: 'Clear other content?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_OTHER_CONTENT_CONFIRMATION.MESSAGE]:
    'This will keep only the selected content in each node and remove the rest.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_OTHER_CONTENT_CONFIRMATION.CHECKBOX_LABEL]: "Don't show this again",

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.BACK_TO_DASHBOARD]: 'Back to files',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.CREATE_NEW_FILE]: 'New file',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.OPEN_RECENT]: 'Open recent',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.DUPLICATE_FILE]: 'Duplicate',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.USE_WHEEL_TO_ZOOM]: 'Use scroll wheel zoom',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.RIGHT_CLICK_TO_OPEN_MENU]: 'Right-click to open menu',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.REQUIRE_ALT_KEY_FOR_SUGGESTIONS]:
    '{{key}}+drag for node suggestions',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.SHARE_WORKFLOW]: 'Share',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.VERSION_HISTORY]: 'Version history',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.VERSION_HISTORY_RUN_IN_PROGRESS]:
    'Version history isn’t available while a run is in progress',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.RENAME_WORKFLOW]: 'Rename',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EXPORT_LINEAGE]: 'Export audit trail',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.KEYBOARD_SHORTCUTS]: 'Keyboard shortcuts',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.PREFERENCES]: 'Preferences',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.SNAP_TO_GRID]: 'Snap to grid',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.SNAP_TO_NODES]: 'Snap to nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.LIGHT_MODE]: 'Light mode',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.THEME]: 'Theme',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.THEME_DARK]: 'Dark',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.THEME_LIGHT]: 'Light',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.THEME_SYSTEM]: 'System',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE]: 'Wire style',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE_BEZIER]: 'Bezier',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE_STEP]: 'Elbow',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE_LINE]: 'Line',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_FILE]: 'File',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_NEW_WEAVE]: 'New Weave',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_MAKE_A_COPY]: 'Make a copy…',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_AI_BALANCE]: 'AI balance',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_AI_BALANCE_LOADING_ARIA]: 'Loading AI balance',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_HELP_AND_ACCOUNT]: 'Help and account',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_LEGAL_SUMMARY]: 'Legal summary',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_ACCOUNT_SETTINGS]: 'Account settings',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_LOG_OUT]: 'Log out',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_GO_TO_PROJECT]: 'Go to project',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_MOVE_FILE]: 'Move file…',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_MOVE_TO_TRASH]: 'Move to trash',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_PIN_TO_WORKSPACE]: 'Pin to workspace',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_RENAME]: 'Rename',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_ADD_TO_SIDEBAR]: 'Add to sidebar',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_SIDEBAR_PREFIX]: 'Sidebar',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_REMOVE_FROM_SIDEBAR]: 'Remove from sidebar',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.FIGMA_EMBED_STARRED]: 'Starred',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.TITLE_EDITOR]:
    "You're viewing a previous version of this workflow",
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.TITLE_READER]:
    "You're viewing a read-only version of this workflow",
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.TITLE_TOOL_VERSION]:
    "You're viewing the read-only version of this tool's workflow",
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.NO_MEDIA]: 'No media found. Yet...',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.EMPTY_TITLE]: 'No assets yet',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.EMPTY_DESCRIPTION]: 'Generations and uploads will show up here.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.NO_MATCH]: 'No assets match.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.NO_MATCH_HINT]:
    'Search looks at node names, file names and prompts.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.SHOW_ALL]: 'Show all assets',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.FILTER_GENERATIONS]: 'Generations',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.FILTER_UPLOADS]: 'Uploads',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.DOWNLOAD_SELECTED]: 'Download {{count}} files',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.GO_TO_NODE]: 'Go to node',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.IN_NODES]: 'Used in {{count}} nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MODELS.COMMUNITY_MODELS]: 'Community models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MODELS.MY_MODELS]: 'My models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.TOOLBOX.MOST_USED]: 'Most used',

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.TITLE]: 'Saved',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.MODELS]: 'Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.NODES]: 'Nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.GROUPS]: 'Groups',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.NODES_EMPTY]:
    "Save nodes to reuse them across workflows. Select 'Save node' from the node's context menu.",
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.MODELS_EMPTY]:
    "Save models to reuse them across workflows. Select 'Save model' from the model's context menu.",
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.GROUPS_EMPTY]:
    "Save groups to reuse them across workflows. Right-click a multi-selection and select 'Save'.",
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EDIT_TOOLTIP]: 'Edit',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DONE]: 'Done',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EDIT_DIALOG_TITLE]: 'Edit {{name}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EDIT_SAVE]: 'Save',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EDIT_SUCCESS]: '{{type}} updated successfully',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EDIT_ERROR]: 'Failed to update {{type}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_TITLE]: 'Delete {{name}}?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_MESSAGE]: 'This cannot be undone.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_CONFIRM]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_DONT_SHOW]: "Don't show this again",
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_MODEL_SUCCESS]: 'Model deleted successfully',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_NODE_SUCCESS]: 'Node deleted successfully',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_GROUP_SUCCESS]: 'Group deleted successfully',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_MODEL_ERROR]: 'Failed to delete model',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_NODE_ERROR]: 'Failed to delete node',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_GROUP_ERROR]: 'Failed to delete group',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.GROUP_NODE_COUNT]: '{{count}} nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.NOT_OWNER_TOOLTIP]: 'Owned by another user',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.MODELS_EMPTY_ME]: 'No models saved by you yet.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.NODES_EMPTY_ME]: 'No nodes saved by you yet.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.GROUPS_EMPTY_ME]: 'No groups saved by you yet.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EMPTY_STATE_TITLE]: 'Your shared library',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EMPTY_STATE_DESCRIPTION]:
    'To start, save a model, node or group from its menu. Shared across your workspace.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EMPTY_STATE_ME_TITLE]: 'Nothing saved by you yet',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EMPTY_STATE_ME_DESCRIPTION]:
    'Switch to All members to see your team’s library.',
  // Embed has no shared workspace library, so this variant drops the sharing claim.
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EMPTY_STATE_EMBED_TITLE]: 'Your library',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EMPTY_STATE_EMBED_DESCRIPTION]:
    'To start, save a model, node or group from its menu.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EMPTY_STATE_LEARN_MORE]: 'Learn more',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.CREATED_BY.LABEL]: 'Created by',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.CREATED_BY.ALL_WORKSPACE]: 'All members',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.CREATED_BY.ME]: 'Me',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.CREATED_BY.TRIGGER_ALL]: 'All',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.CREATED_BY.TRIGGER_ME]: 'Me',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.SEARCH.EMPTY]: 'No results match this search',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NEW_INDICATOR]: 'New',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.PROMO_INDICATOR]: '{{percent}}% off',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.VERIFIED_BY_FIGMA]: 'Verified by Figma',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.VERIFIED]: 'Verified',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.UNVERIFIED_DISCLAIMER_WITH_ADDITIONAL_TERMS]:
    'This model is unverified. Your use of this model is subject to its <additionalTermsLink>API Service Terms</additionalTermsLink>, <termsLink>Terms</termsLink> and <privacyLink>Privacy Policy</privacyLink>.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.UNVERIFIED_DISCLAIMER]:
    'This model is unverified. Your use of this model is subject to its <termsLink>Terms</termsLink> and <privacyLink>Privacy Policy</privacyLink>.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.BASED_ON]: 'Based on {{name}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.CREATED_BY]: 'Created by {{name}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.CREATED_BY_ME]: 'Created by me',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.RECENT]: 'Recent',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.TOOLS]: 'Tools',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.IMAGE_MODELS]: 'Image models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.VIDEO_MODELS]: 'Video models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.THREE_D_MODELS]: '3D models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.AUDIO_MODELS]: 'Audio models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.CUSTOM_MODELS]: 'Custom models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.FREQUENTLY_USED]: 'Frequently used',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.DATA_TYPES]: 'Datatypes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.NON_MODEL_EDIT]: 'Editing',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.MATTING]: 'Matte',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.LIP_SYNC]: 'Lip sync',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.ITERATORS]: 'Iterators',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.TEXT_TOOLS]: 'Text tools',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.TEXT_ITERATOR.DISPLAY_NAME]: 'Text Iterator',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.TEXT_ITERATOR.DESCRIPTION]:
    'Iterate over a list of text values',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.IMAGE_ITERATOR.DISPLAY_NAME]: 'Image Iterator',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.IMAGE_ITERATOR.DESCRIPTION]:
    'Iterate over a list of images',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.VIDEO_ITERATOR.DISPLAY_NAME]: 'Video Iterator',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.VIDEO_ITERATOR.DESCRIPTION]:
    'Iterate over a list of videos',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.BLEND.DESCRIPTION]:
    'Composites two layers together using a blend mode of your choice. It takes two inputs — Front and Back — and once both are connected, applies the selected blend mode to combine them into a single output.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.SAVED]: 'Saved',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.SAVED_MODELS]: 'Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.SAVED_NODES]: 'Nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.SAVED_GROUPS]: 'Groups',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.HELPERS]: 'Helpers',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_IMAGE_FROM_TEXT]: 'Generate from text',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_VECTOR_FROM_TEXT]: 'Generate vector graphics',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.EDIT_IMAGE]: 'Edit images',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_IMAGE_FROM_IMAGE]: 'Generate from image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.ENHANCE_IMAGE]: 'Enhance images',

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_VIDEO_FROM_TEXT_OR_IMAGE]: 'Generate from text or image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_VIDEO_FROM_VIDEO]: 'Generate from video',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.EXTEND_VIDEO]: 'Extend videos',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.ENHANCE_VIDEO]: 'Enhance videos',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_3D_FROM_TEXT_OR_IMAGE]: 'Generate from text or image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_TEXTURES]: 'Generate textures',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.MUSIC]: 'Music',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.VOICEOVER]: 'Voiceover',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.SOUND_EFFECTS]: 'Sound effects',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.VOICE_CLONING]: 'Voice cloning',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.TRANSCRIPTION]: 'Transcription',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.USER_MODELS]: 'My models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.COMMUNITY_MODELS]: 'Community models',

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.ORDERBY.LABEL]: 'Order',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.ORDERBY.FEATURED]: 'Featured',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.ORDERBY.PRICE_ASC]: 'Price: low to high',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.ORDERBY.PRICE_DESC]: 'Price: high to low',

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.MODE_TOGGLE.ALL]: 'All',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.MODE_TOGGLE.TOOLS]: 'Tools',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.MODE_TOGGLE.MODELS]: 'Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.MODE_TOGGLE.GROUPS]: 'Groups',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.MODE_TOGGLE.VERIFIED]: 'Verified',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.MODE_TOGGLE.UNVERIFIED]: 'Unverified',

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.CREATED_BY.LABEL]: 'Created by',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.CREATED_BY.WEAVE]: 'Weave',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.CREATED_BY.WORKSPACE]: 'Workspace members',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.CREATED_BY.ME]: 'Me',

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.RECENT]: 'Quick access',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.TOOLBOX]: 'Toolbox',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.IMAGE]: 'Image Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.VIDEO]: 'Video Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.THREEDEE]: '3D Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.AUDIO]: 'Audio Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.MY_MODELS]: 'My Models and Community Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.COMMUNITY_MODELS]: 'Community Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.MEDIA]: 'Assets',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.AI_CHAT]: 'AI Weaver',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.RAIL.ARIA_LABEL]: 'Canvas tools',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.RAIL.RECENTS]: 'Recents',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.RAIL.SAVED]: 'Saved',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.RAIL.TOOLS]: 'Tools',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.RAIL.IMAGE]: 'Image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.RAIL.VIDEO]: 'Video',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.RAIL.THREE_D]: '3D',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.RAIL.AUDIO]: 'Audio',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.RAIL.MODELS]: 'Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.RAIL.IMAGES]: 'Images',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.RAIL.ASSETS]: 'Assets',

  [I18N_KEYS.RECIPE_MAIN.FLOW.WORKFLOW]: 'Canvas',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DESIGN_APP]: 'Tool',

  [I18N_KEYS.RECIPE_MAIN.FLOW.CREDITS_INFO_CREDITS]: '{{credits}} credits',
  [I18N_KEYS.RECIPE_MAIN.FLOW.SHARE]: 'Share',

  [I18N_KEYS.RECIPE_MAIN.FLOW.ACTIONS.ZOOM_IN]: 'Zoom in',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ACTIONS.ZOOM_OUT]: 'Zoom out',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ACTIONS.ZOOM_TO_HUNDRED]: 'Zoom to 100%',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ACTIONS.ZOOM_TO_FIT]: 'Zoom to fit',

  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.BYOK_LABEL]: 'API key',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.BYOK_TOOLTIP]: 'Runs using your workspace API key',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.NUM_OF_MODELS]: '{{count}} Nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.SET_AS_INPUT]: 'Set as input',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.SET_AS_PARAMETER]: 'Set as parameter',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.SPEAKER_NAME_PLACEHOLDER]: 'Name',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.ADD_LIST_ITEM]: 'Add another',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.LIST_ITEM_PLACEHOLDER]: 'List item',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.TITLE]: 'Run selected nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.RUNS]: 'Runs',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.CTA]: 'Run selected',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.UNSUPPORTED_NODES_INFO + '_one']:
    'Running a {{nodes}} node is not supported',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.UNSUPPORTED_NODES_INFO + '_other']:
    'Running {{nodes}} nodes is not supported',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.ALREADY_RUNNING_INFO]:
    'Cannot run selected nodes as some are already running',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.NOT_ENOUGH_CREDITS]:
    'Not enough credits to run the selected models.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.NOT_ENOUGH_CREDITS_TEAM]:
    'Not enough credits to run the selected models. Please contact your account admin',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.NOT_ENOUGH_CREDITS_INDIVIDUAL]:
    'Not enough credits to run the selected models. Buy more credits',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.OUT_OF_CREDITS_BETA]:
    "Not enough {{window}} credits included in Figma Weave's beta to run. Credits reset {{date}}.",
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.REQUEST_TOO_LARGE]:
    'Request is too big. Try using lower-resolution images.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.ITERATORS_INFO.TITLE]: 'Iterators',
  [I18N_KEYS.RECIPE_MAIN.FLOW.SUGGESTION_MENU.DROP_INDICATION]: '+ Drop to add node',
  [I18N_KEYS.RECIPE_MAIN.FLOW.MULTI_CONNECT.INCOMPATIBLE_TARGET]: 'Could not connect — incompatible target',
  [I18N_KEYS.RECIPE_MAIN.FLOW.MULTI_CONNECT.PARTIAL_SUCCESS]:
    'Connected {{connected}} of {{total}} — {{skipped}} skipped',
  [I18N_KEYS.RECIPE_MAIN.FLOW.MULTI_CONNECT.NO_COMPATIBLE_NODE_FOR_TYPES]:
    'No nodes accept all selected types — narrow your selection.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.TITLE]: 'High cost model',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.SUBTITLE]:
    'You are about to run <b>{{displayName}}</b> that costs <icon/><b>{{modelPrice}} credits</b> per run. Are you sure you want to continue?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.CHECKBOX_LABEL]: 'Don’t show again for this model',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.MODEL_NAME_PLACEHOLDER]: 'a model',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.CTA_CONFIRM]: 'Run anyway',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNKNOWN_COST.DIALOG.TITLE]: 'Unable to calculate cost',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNKNOWN_COST.DIALOG.MSG]:
    "Part of this workflow's cost is decided while it runs, so it cannot be calculated up front.\n\nDo you want to run it anyway?",
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNKNOWN_COST.DIALOG.CONFIRM_BTN_TEXT]: 'Run anyway',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNKNOWN_COST.PRICE_TEXT]: 'Unknown',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNKNOWN_COST.PRICE_LOAD_ERROR]: 'Couldn’t load price',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNKNOWN_COST.TOOLTIP]:
    "Part of this workflow's cost is decided while it runs, so it cannot be calculated up front.",
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.ITERATION_MODE_TITLE]: 'Iteration mode',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.ITERATION_MODE_PARALLEL_SHORT]: 'Parallel',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.ITERATION_MODE_PARALLEL_TITLE]: 'Parallel iteration',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.ITERATION_MODE_PARALLEL_DESCRIPTION]:
    'Runs simultaneously on all iterators.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.ITERATION_MODE_PARALLEL_FOOTNOTE]:
    '*If the iterators have unequal number of values, use the smaller one.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.ITERATION_MODE_MATRIX_SHORT]: 'Matrix',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.ITERATION_MODE_MATRIX_TITLE]: 'Matrix iteration',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.ITERATION_MODE_MATRIX_DESCRIPTION]:
    'Creates all possible combinations.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.ITERATION_MODE_TOTAL_RUNS]: 'Total runs',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.VALUES + '_one']: '{{count}} value',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.VALUES + '_other']: '{{count}} values',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNVERIFIED_MODEL_RUN.DIALOG.TITLE]: "Model provider's terms notice",
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNVERIFIED_MODEL_RUN.DIALOG_IMPORTED_MODEL.TITLE]: 'Import model notice',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNVERIFIED_MODEL_RUN.DIALOG.TEXT]:
    `{{modelsList}} is an independent third-party model, not controlled by Figma Weave. This unverified model is governed by its own terms and policies, which cover things like how your data is used and protected.\n\nBy clicking "Accept", you accept the model provider's <termsUrl>Terms</termsUrl> and <privacyPolicyUrl>Privacy Policy</privacyPolicyUrl> enabling the use of this and any additional models governed by these same terms`,
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNVERIFIED_MODEL_RUN.DIALOG.TEXT + '_additionalTermsLink']:
    `{{modelsList}} is an independent third-party model, not controlled by Figma Weave. This unverified model is governed by its own terms and policies, which cover things like how your data is used and protected.\n\nBy clicking "Run model", you accept the model provider's <termsUrl>Terms</termsUrl>, <additionalTermsLink>API Terms</additionalTermsLink> and <privacyPolicyUrl>Privacy Policy</privacyPolicyUrl> enabling the use of this and any additional models governed by these same terms`,
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNVERIFIED_MODEL_RUN.DIALOG.TEXT + '_noterms']:
    `Heads up — you imported {{modelsList}} from outside Figma Weave.\n\nBy continuing and clicking "Accept," you take full responsibility for your use of it, including that you are allowed to use it and that it fits your needs.`,

  [I18N_KEYS.RECIPE_MAIN.FLOW.EMPTY_CANVAS_OVERLAY.START_FROM_TEMPLATE]: 'Start from a template',
  [I18N_KEYS.RECIPE_MAIN.FLOW.EMPTY_CANVAS_OVERLAY.DIVIDER]: 'or',
  [I18N_KEYS.RECIPE_MAIN.FLOW.EMPTY_CANVAS_OVERLAY.BUTTON.START_FROM_PROMPT]: 'Start from a prompt',
  [I18N_KEYS.RECIPE_MAIN.FLOW.EMPTY_CANVAS_OVERLAY.BUTTON.PROMPT]: 'Start with a prompt',
  [I18N_KEYS.RECIPE_MAIN.FLOW.EMPTY_CANVAS_OVERLAY.TEMPLATE_PICKER.TITLE]: 'Templates',
  [I18N_KEYS.RECIPE_MAIN.FLOW.EMPTY_CANVAS_OVERLAY.TEMPLATE_PICKER.FIGMA_COMMUNITY]: 'Browse on Figma Community',
  [I18N_KEYS.RECIPE_MAIN.FLOW.EMPTY_CANVAS_OVERLAY.TEMPLATE_PICKER.USE_IN_FILE]: 'Use in file',
  [I18N_KEYS.RECIPE_MAIN.FLOW.EMPTY_CANVAS_OVERLAY.TEMPLATE_PICKER.START_HERE]: 'Start here',

  [I18N_KEYS.RECIPE_MAIN.NODES.DEPRECATED.GENERAL]: 'Deprecated',
  [I18N_KEYS.RECIPE_MAIN.NODES.DEPRECATED.OUTPUT_BANNER]: 'This node is deprecated',
  [I18N_KEYS.RECIPE_MAIN.NODES.DEPRECATED.OUTPUT]:
    'Tools now set their outputs in the Tool tab. Switch to Tool and pick Set as output on any node.',
  [I18N_KEYS.RECIPE_MAIN.NODES.DEPRECATED.EDIT]: 'The Photopea editor is no longer supported.',
  [I18N_KEYS.RECIPE_MAIN.NODES.DEPRECATED.COMPV2]:
    'This version of the Compositor node is no longer supported. Please use the new Compositor node instead.',
  [I18N_KEYS.RECIPE_MAIN.NODES.SHARED.NODE_DETAILS_ACCORDION.TITLE]: 'Tool Details',
  [I18N_KEYS.RECIPE_MAIN.NODES.SHARED.SHOW_MORE_CHIP.SHOW_MORE]: 'Show more',
  [I18N_KEYS.RECIPE_MAIN.NODES.SHARED.SHOW_MORE_CHIP.SHOW_LESS]: 'Show less',
  [I18N_KEYS.RECIPE_MAIN.NODES.EXPORT.EXPORT_CTA]: 'Export',
  [I18N_KEYS.RECIPE_MAIN.NODES.EXPORT.EXPORT_CTA_RENDERING]: 'Rendering',
  [I18N_KEYS.RECIPE_MAIN.NODES.EXPORT.FORMAT_LABEL]: 'Format',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PLACEHOLDER]: 'Figma Node',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.FRAME_FALLBACK]: 'Frame',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.ADD_INPUT]: 'Add input',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.ADD_INPUT_OPTION_TEXT]: 'Text',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.ADD_INPUT_OPTION_IMAGE]: 'Image',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.INITIALIZE_ERROR_NO_ACCESS]:
    "Couldn't import this Figma frame — your linked Figma account can't access the source file.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.INITIALIZE_ERROR_NOT_CONNECTED]: 'Link your Figma account to paste frames',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.INITIALIZE_ERROR_GENERIC]: "Couldn't import the Figma frame. Try again.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PASTE_ERROR_UNSUPPORTED_SELECTION]:
    'Only Figma frames and text can be pasted into Weave. Select a frame or text layer and try again.',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PASTE_ERROR_WRONG_ENVIRONMENT]:
    'This frame was copied from {{sourceHost}}. Open the file on {{expectedHost}}, copy it, and paste again.',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PASTE_LINK_ACCOUNT_ACTION]: 'Link account',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.LINK_ACCOUNT]: 'Link account',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.EDIT_ERROR_NOT_CONNECTED]: 'Link your Figma account to edit',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.DUPLICATE_ERROR_NOT_CONNECTED]:
    'Link your Figma account to duplicate this workflow',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_INPUTS_TITLE]: 'Inputs',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_NO_INPUTS]: 'No Figma inputs yet.',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_TYPE_TEXT]: 'Text variable',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_TYPE_IMAGE]: 'Image variable',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_TYPE_UNKNOWN]: 'Variable',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_LAYERS_TITLE]: 'Layers',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_LAYERS_LOADING]: 'Loading layers...',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_LAYERS_ERROR]: "Couldn't load layers.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_LAYERS_EMPTY]: 'No layers found.',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_CONNECT]: 'Connect',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_CONNECT_IMAGE_FROM_WEAVE]: 'Connect image from Weave',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_CONNECT_TEXT_FROM_WEAVE]: 'Connect text from Weave',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_REMOVE_INPUT]: 'Remove',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_DISCONNECT_LAYER]: 'Disconnect',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_CONNECT_TO_LAYER]: 'Connect to layer',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_LAYER_PICKER_TITLE]: 'Connect to',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_LAYER_PICKER_CLOSE]: 'Close',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_IMAGE_FILL]: 'Image fill {{index}}',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_NO_COMPATIBLE_LAYERS]: 'No layers to connect',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_LAYER_MISSING_FONT]:
    "This text layer can't be connected because its font is missing. Replace the font to continue.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_BIND_LAYER_ERROR_GENERIC]: "Couldn't connect that layer.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_DISCONNECT_LAYER_ERROR_GENERIC]: "Couldn't disconnect that layer.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_REMOVE_INPUT_ERROR_GENERIC]: "Couldn't remove that input.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_BIND_LAYER_ERROR_NOT_CONNECTED]:
    'Connect your Figma account before connecting a layer.',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.EDIT]: 'Edit',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.CONNECT]: 'Connect',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.CONNECT_TO_EDIT]: 'Connect to edit',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.UPDATE]: 'Update',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.UPDATE_IN_PROGRESS]: 'A Figma update is in progress.',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.CONNECT_LOADING_DISABLED]: 'Can’t connect while loading',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.EDIT_LOADING_DISABLED]: 'Can’t edit while loading',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.UPDATE_ERROR]: "Couldn't update from Figma. Please try again.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.CONNECT_DEST_ORIGINAL_SOURCE]: 'Source file',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.CONNECT_DEST_NEW_DRAFTS]: 'New file',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.CONNECT_DEST_SLIDES_UNSUPPORTED]:
    "Weave can't update frames in Figma Slides files yet. Connect to a new file instead.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.CONNECT_ERROR]: "Couldn't connect the Figma frame. Try again.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.CONNECT_ERROR_SNAPSHOT_NOT_FOUND]:
    'This copy of the Figma frame is no longer available. Copy the current frame from Figma and paste it into Weave again.',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.COPY_ERROR]: "Couldn't finish copying the Figma frame.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.COPY_RETRY]: 'Retry',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_EDIT_IN_FIGMA]: 'Edit in Figma Design',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_OPEN_IN_FIGMA]: 'Open in Figma Design',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.PROPERTIES_CONNECTED_FILE_FALLBACK]: 'Figma file',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.OPENING_IN_FIGMA]: 'Opening "{{fileName}}" in Figma',
  // Fallback when the node has no title; Pixie names the new file "Untitled" in that case.
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.DRAFT_NAME_UNTITLED]: 'Untitled',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.DISCONNECT]: 'Disconnect',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.DISCONNECT_ERROR]: "Couldn't disconnect the Figma frame. Try again.",
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.FILE_DISCONNECTED_MODAL_TITLE]: 'File not found',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.FILE_DISCONNECTED_MODAL_BODY]:
    'The Figma file this node was connected to no longer exists or is corrupted.',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.FILE_DISCONNECTED_MODAL_CONNECT]: 'Connect to new file',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.FILE_NO_EDIT_ACCESS_MODAL_TITLE]: 'Can’t edit source file',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.FILE_NO_EDIT_ACCESS_MODAL_BODY]:
    'You don’t have edit access to this file. Connect the Figma node to a new file instead.',
  [I18N_KEYS.RECIPE_MAIN.NODES.FIGMA_NODE.FILE_NO_EDIT_ACCESS_MODAL_CONNECT]: 'Connect to new file',
  [I18N_KEYS.RECIPE_MAIN.NODES.FILE_VIEWER.SHOW_ORIGINAL]: 'Show original',
  [I18N_KEYS.RECIPE_MAIN.NODES.FILE_VIEWER.SHOW_RESULT]: 'Show result',
  [I18N_KEYS.RECIPE_MAIN.NODES.LOCKED.CLICK_TO_UNLOCK]: 'Click to unlock',
  [I18N_KEYS.RECIPE_MAIN.NODES.LOCKED.CLICK_TO_UNLOCK_GROUP]: 'Click to unlock group',
  [I18N_KEYS.RECIPE_MAIN.NODES.LOCKED.THIS_NODE_IS_LOCKED]: 'This node is locked',
  [I18N_KEYS.RECIPE_MAIN.NODES.LOCKED.THIS_NODE_IS_LOCKED_GROUP]: 'This node is in a locked group',
  [I18N_KEYS.RECIPE_MAIN.NODES.MULTI_LORA.ADD_LORA]: '+ Add another LoRA',
  [I18N_KEYS.RECIPE_MAIN.NODES.MULTI_LORA.LORAS]: 'LoRAs List',
  [I18N_KEYS.RECIPE_MAIN.NODES.MULTI_LORA.SELECT_LORA]: 'Select a LoRA',
  [I18N_KEYS.RECIPE_MAIN.NODES.MULTI_LORA.NO_OPTIONS]: 'No LoRAs',

  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DOWNLOAD_IMAGE_PREVIEW]: 'Download {{name}}',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.COPY_IMAGE_PREVIEW]: 'Copy {{name}}',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DELETE]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DELETE_ALL_UPLOADS]: 'Remove all',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DELETE_ALL_OTHERS_UPLOADS]: 'Remove all but current',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DELETE_CURRENT_UPLOAD]: 'Remove current',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DOWNLOAD]: 'Download',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.AUDIT_TRAIL]: 'Audit trail',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.EXPORT_CURRENT]: 'Export current',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.EXPORT_ALL]: 'Export all',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CLEAR]: 'Clear',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CLEAR_CURRENT]: 'Clear current',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CLEAR_ALL_BUT_CURRENT]: 'Clear all but current',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CLEAR_ALL]: 'Clear all',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DUPLICATE]: 'Duplicate',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CUT]: 'Cut',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.LOCK]: 'Lock',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.RENAME]: 'Rename',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.UNLOCK]: 'Unlock',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.UNLOCK_GROUP_FIRST]: 'Group is locked',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.VIEW_MODE]: 'View',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.REMOVE_FROM_GROUP]: 'Remove from group',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.VIEW_MODE_SINGLE]: 'Single',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.VIEW_MODE_BATCH]: 'Batch',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.VIEW_MODE_ALL]: 'All',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_NODE]: 'Save node',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_NODE_SUCCESS]: 'Node saved successfully',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_NODE_ERROR]: 'Failed to save node',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_MODEL]: 'Save model',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_MODEL_SUCCESS]: 'Model saved successfully',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_MODEL_ERROR]: 'Failed to save model',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_GROUP]: 'Save',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_GROUP_TITLE]: 'Save to use again',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_GROUP_SUCCESS]: 'Saved as {{name}}',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_GROUP_ERROR]: 'Failed to save group',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.UNPACK]: 'Unpack',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CREATE_ITERATOR]: 'Create iterator',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CREATE_IMAGE_ITERATOR]: 'Create image iterator',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CREATE_VIDEO_ITERATOR]: 'Create video iterator',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CREATE_TEXT_ITERATOR]: 'Create text iterator',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SHOW_VERSION_HISTORY]: 'Show version history',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SHOW_VERSION_HISTORY_DISABLED_TOOLTIP]:
    'No history yet. Versions will be tracked from the next use.',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.HANDLES]: 'Handles',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.COLLAPSE_HANDLES_BY_TYPE]: 'Collapse handles by type',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.COLLAPSE_HANDLES_NO_INPUTS]: 'Add at least two inputs to collapse handles',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU_CONFIRMATION_DIALOG.CANCEL_TEXT]: 'Cancel',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU_CONFIRMATION_DIALOG.CONFIRM_TEXT]: 'Yes, Remove',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU_CONFIRMATION_DIALOG.TITLE]: 'Clear all generations?',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU_CONFIRMATION_DIALOG.MESSAGE]: 'All generations will be deleted.',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU_CONFIRMATION_DIALOG.DELETE_ALL_UPLOADS_MESSAGE]: 'Clear all uploads?',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU_CONFIRMATION_DIALOG.DELETE_ALL_UPLOADS_BODY]:
    'All uploaded files will be deleted.',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU_CONFIRMATION_DIALOG.DELETE_ALL_UPLOADS_CONFIRM_TEXT]: 'Clear',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_CONCAT.PLACEHOLDER]: 'Connect multiple prompts to one output prompt.',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_CONCAT.ADDITIONAL_TEXT_PLACEHOLDER]: 'Write additional text',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_CONCAT.ADD_ANOTHER_TEXT_INPUT]: 'Add text input',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_CONCAT.COMBINED_LABEL]: 'Combined prompt',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_CONCAT.ADDITIONAL_TEXT_LABEL]: 'Your text',
  [I18N_KEYS.RECIPE_MAIN.NODES.STRING_NODE.ARIA_LABEL]: 'Text',
  [I18N_KEYS.RECIPE_MAIN.NODES.TEXT_VIEWER.ARIA_LABEL]: 'Generated text',
  [I18N_KEYS.RECIPE_MAIN.NODES.VIDEO_CONCATENATOR.ADD_VIDEO]: 'Add video',
  [I18N_KEYS.RECIPE_MAIN.NODES.VIDEO_CONCATENATOR.SCALE]: 'Scale',
  [I18N_KEYS.RECIPE_MAIN.NODES.VIDEO_CONCATENATOR.SCALE_MODES.STRETCH]: 'Stretch',
  [I18N_KEYS.RECIPE_MAIN.NODES.VIDEO_CONCATENATOR.SCALE_MODES.FIT]: 'Fit',
  [I18N_KEYS.RECIPE_MAIN.NODES.VIDEO_CONCATENATOR.SCALE_MODES.FILL]: 'Fill',
  // Per WEA-5417 the unconnected default is the image prompt, so this must stay in sync with
  // `PLACEHOLDER_IMAGE` below. It is kept as its own key so design can differentiate the
  // no-target case later without reintroducing one.
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.PLACEHOLDER]:
    'Hipster Sisyphus in light yellow jumpsuit and orange beanie pushing a giant orange icosahedron up a concrete ramp cropped by the frame. cloudless blue sky, negative space.',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.PLACEHOLDER_IMAGE]:
    'Hipster Sisyphus in light yellow jumpsuit and orange beanie pushing a giant orange icosahedron up a concrete ramp cropped by the frame. cloudless blue sky, negative space.',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.PLACEHOLDER_VIDEO]:
    'Hipster Sisyphus in light yellow jumpsuit and orange beanie, slowly pushing chrome wheelbarrow carrying giant orange icosahedron up cropped concrete ramp, blue sky, negative space.',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.PLACEHOLDER_AUDIO]:
    'Hipster Sisyphus loop, a lo-fi minimal deadpan indie electronic instrumental at 90 BPM, slow plodding four-on-the-floor, dry looping synth arpeggios, drum machine, no build.',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.PLACEHOLDER_3D]:
    '3D render, minimalist: matte half translucent orange faceted polyhedron, on a triangular concrete ramp, black background, centered.',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.PLACEHOLDER_TEXT]:
    'Generate 3 variations of Hipster Sisyphus, separated by asterisks, - a modern minimalist take on the myth, absurd. Output nothing but the prompts.',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.PLACEHOLDER_APPLY_HINT]: 'Tab',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.TRUNCATED_WARNING]:
    'Prompt is too long. Truncated to {{max}} characters.',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.ADD_VARIABLE]: 'Add variable',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.CREATE_VARIABLE]: 'Create variable',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.DISPLAY_MODE]: 'Display',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.DISPLAY_SOURCE_VALUE]: 'Source + Value',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.DISPLAY_VALUE]: 'Value',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.DISPLAY_SOURCE]: 'Source',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.TAG_CONTEXT_MENU.DUPLICATE]: 'Duplicate',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.TAG_CONTEXT_MENU.DELETE]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.EDITOR_CONTEXT_MENU.PASTE]: 'Paste here',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V2.PROMPT_LABEL]: 'Prompt',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V2.NEGATIVE_PROMPT_LABEL]: 'Negative Prompt',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V2.NEGATIVE_PROMPT_PLACEHOLDER]: 'Your negative prompt goes here...',
  [I18N_KEYS.RECIPE_MAIN.NODES.STICKY_NOTE.PLACEHOLDER]: 'Type...',
  [I18N_KEYS.RECIPE_MAIN.NODES.STICKY_NOTE.CONTEXT_MENU.FONT_SIZE]: 'Font Size',
  [I18N_KEYS.RECIPE_MAIN.NODES.STICKY_NOTE.CONTEXT_MENU.FONT_SIZE_OPTIONS.SMALL]: 'Small',
  [I18N_KEYS.RECIPE_MAIN.NODES.STICKY_NOTE.CONTEXT_MENU.FONT_SIZE_OPTIONS.MEDIUM]: 'Medium',
  [I18N_KEYS.RECIPE_MAIN.NODES.STICKY_NOTE.CONTEXT_MENU.FONT_SIZE_OPTIONS.LARGE]: 'Large',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.PLACEHOLDER]: 'Paste replicate.com, fal.ai, or civitai.com URL',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.INPUT_ERROR]: 'Could not find model',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_CTA]: 'Save model to my library',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.ADDED_TO_MY_LIBRARY]: 'Added to your library',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.TITLE]: 'Save model to my library',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.SUBTITLE]: 'Give your model a name and description',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.NAME_LABEL]: 'Model name*',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.NAME_PLACEHOLDER]: 'Meaningful name',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.DESCRIPTION_LABEL]: 'Description*',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.DESCRIPTION_PLACEHOLDER]: 'Clear description',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.CTA_SAVE]: 'Save model',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPOSITOR.EDIT_CTA]: 'Edit',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPOSITOR.ADD_ANOTHER_LAYER_CTA]: 'Add layer',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.BACKGROUND_COLOR_LABEL]: 'Background color',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.BRUSH_SIZE_LABEL]: 'Size',
  [I18N_KEYS.RECIPE_MAIN.NODES.COLOR_PALETTE.ADD_ANOTHER]: '+ Add another color',
  [I18N_KEYS.RECIPE_MAIN.NODES.COLOR_PALETTE.EDIT_ARIA]: 'Edit color {{hex}}',
  [I18N_KEYS.RECIPE_MAIN.NODES.COLOR_PALETTE.REORDER_ARIA]: 'Drag to reorder',
  [I18N_KEYS.RECIPE_MAIN.NODES.COLOR_PALETTE.REMOVE_ARIA]: 'Remove color {{hex}}',
  [I18N_KEYS.RECIPE_MAIN.NODES.COLOR_PALETTE.SELECT_COLOR]: 'Select color',
  [I18N_KEYS.RECIPE_MAIN.NODES.COLOR_PALETTE.PALETTE_LABEL]: 'Color palette',
  [I18N_KEYS.RECIPE_MAIN.NODES.COLOR_PALETTE.ADD_COLOR]: 'Add color',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.HARDNESS_LABEL]: 'Hardness',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.OPACITY_LABEL]: 'Opacity',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.COLOR_LABEL]: 'Color',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.RESET]: 'Reset',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.DIMENSIONS_SET_BY_INPUT_IMAGE]: 'Dimensions set by input image',

  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.LOCK_ASPECT_RATIO]: 'Lock aspect ratio',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.RESET]: 'Reset',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.DIMENSIONS]: 'Dimensions',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.ASPECT_RATIO]: 'Aspect ratio',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.CUSTOM_ASPECT_RATIO]: 'Custom',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.WIDTH_LETTER]: 'W',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.HEIGHT_LETTER]: 'H',

  [I18N_KEYS.RECIPE_MAIN.NODES.RESIZE.UNSUPPORTED_FILE]: 'Unsupported file',
  [I18N_KEYS.RECIPE_MAIN.NODES.TRIM.START_LABEL]: 'Start',
  [I18N_KEYS.RECIPE_MAIN.NODES.TRIM.END_LABEL]: 'End',
  [I18N_KEYS.RECIPE_MAIN.NODES.TRIM.FILMSTRIP_ARIA]: 'Trim timeline',
  [I18N_KEYS.RECIPE_MAIN.NODES.TRIM.START_HANDLE_ARIA]: 'Trim start',
  [I18N_KEYS.RECIPE_MAIN.NODES.TRIM.END_HANDLE_ARIA]: 'Trim end',
  [I18N_KEYS.RECIPE_MAIN.NODES.TRIM.PLAYHEAD_ARIA]: 'Playhead',
  [I18N_KEYS.RECIPE_MAIN.NODES.NUMBER.IS_FLOAT]: 'Use decimals (float)',
  [I18N_KEYS.RECIPE_MAIN.NODES.NUMBER.MIN]: 'Min',
  [I18N_KEYS.RECIPE_MAIN.NODES.NUMBER.MAX]: 'Max',
  [I18N_KEYS.RECIPE_MAIN.NODES.POINT_CLOUD_FROM_DEPTH.SCALE]: 'Scale',
  [I18N_KEYS.RECIPE_MAIN.NODES.POINT_CLOUD_FROM_DEPTH.LEVELS]: 'Levels',
  [I18N_KEYS.RECIPE_MAIN.NODES.POINT_CLOUD_FROM_DEPTH.MIN_DEPTH]: 'Minimum depth',
  [I18N_KEYS.RECIPE_MAIN.NODES.POINT_CLOUD_FROM_DEPTH.GAMMA]: 'Depth gamma',
  [I18N_KEYS.RECIPE_MAIN.NODES.POINT_CLOUD_FROM_DEPTH.MAX_DEPTH]: 'Maximum depth',
  [I18N_KEYS.RECIPE_MAIN.NODES.ARRAY.ADD_ITEM]: 'Add item',
  [I18N_KEYS.RECIPE_MAIN.NODES.ARRAY.SPLIT_TEXT_BY]: 'Split text by:',
  [I18N_KEYS.RECIPE_MAIN.NODES.ARRAY.PLACEHOLDER]: 'Array item',
  [I18N_KEYS.RECIPE_MAIN.NODES.ARRAY.ITEMS_COUNT + '_one']: '{{count}} item',
  [I18N_KEYS.RECIPE_MAIN.NODES.ARRAY.ITEMS_COUNT + '_other']: '{{count}} items',
  [I18N_KEYS.RECIPE_MAIN.NODES.TOGGLE.TRUE]: 'True',
  [I18N_KEYS.RECIPE_MAIN.NODES.TOGGLE.FALSE]: 'False',
  [I18N_KEYS.RECIPE_MAIN.NODES.TOGGLE.ARIA]: 'Toggle value',
  [I18N_KEYS.RECIPE_MAIN.NODES.CHANNEL.RED]: 'Red',
  [I18N_KEYS.RECIPE_MAIN.NODES.CHANNEL.GREEN]: 'Green',
  [I18N_KEYS.RECIPE_MAIN.NODES.CHANNEL.BLUE]: 'Blue',
  [I18N_KEYS.RECIPE_MAIN.NODES.CHANNEL.ALPHA]: 'Alpha',
  [I18N_KEYS.RECIPE_MAIN.NODES.MASKS.IMAGE]: 'Image',
  [I18N_KEYS.RECIPE_MAIN.NODES.MASKS.MASK]: 'Mask',
  [I18N_KEYS.RECIPE_MAIN.NODES.MASKS.ERROR]:
    'Error analyzing masks. Please check inputs or contact us if the problem persists.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MASKS.RECALCULATE_MASK]: 'Recalculate mask',
  [I18N_KEYS.RECIPE_MAIN.NODES.BLUR.SIZE]: 'Size',
  [I18N_KEYS.RECIPE_MAIN.NODES.BLUR.TYPE]: 'Type',
  [I18N_KEYS.RECIPE_MAIN.NODES.BLUR.BOX]: 'Box',
  [I18N_KEYS.RECIPE_MAIN.NODES.BLUR.GAUSSIAN]: 'Gaussian',
  [I18N_KEYS.RECIPE_MAIN.NODES.EXTRACT_VIDEO_FRAME.TIMECODE]: 'Timecode',
  [I18N_KEYS.RECIPE_MAIN.NODES.EXTRACT_VIDEO_FRAME.FRAME]: 'Frame',
  [I18N_KEYS.RECIPE_MAIN.NODES.KEYFRAME.MODE]: 'Mode',
  [I18N_KEYS.RECIPE_MAIN.NODES.KEYFRAME.MODE_TIME]: 'Time',
  [I18N_KEYS.RECIPE_MAIN.NODES.KEYFRAME.MODE_FRAMES]: 'Frames',
  [I18N_KEYS.RECIPE_MAIN.NODES.KEYFRAME.TIMESTAMP]: 'Timestamp',
  [I18N_KEYS.RECIPE_MAIN.NODES.KEYFRAME.FRAME_NUMBER]: 'Frame number',
  [I18N_KEYS.RECIPE_MAIN.NODES.KEYFRAME.FPS_BASE_HINT]: '24 fps base',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.SELECT_AN_OPTION]: 'Select an option',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.ADD_OPTIONS_VIA_PROPERTIES_PANEL]: 'No options available',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.ITERATOR.PLACEHOLDER]: 'Item {{index}}',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.ITERATOR.ADD_ITEM]: 'Add another item',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.ITERATOR.ITEMS_COUNT]: '{{count}} items',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.OPTIONS_LABEL]: 'Options',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.OPTIONS_TOOLTIP]: 'Array of options to choose from',
  [I18N_KEYS.RECIPE_MAIN.NODES.PREVIEW_NODE.SET_AS_COVER]: 'Set as cover',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.PROMPT_LABEL]: 'Custom Effect prompt',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.PROMPT_PANEL_LABEL]: 'Edit effect',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.PROMPT_PLACEHOLDER]: 'Describe the effect you would like to generate',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.GENERATE]: 'Generate effect',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.REGENERATE]: 'Regenerate effect',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.EDIT_PROMPT]: 'Edit prompt',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.GENERATING]: 'Generating',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.REGENERATING]: 'Regenerating',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.GENERATE_ERROR]: 'Could not generate this effect. Try rephrasing.',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.PAID_PLAN_GENERATE_ERROR]:
    'Creating effects is only available on paid plans.',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.IMAGE_REFERENCES]: 'Image references',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.IMAGE_REFERENCES_COUNT]: 'Image references ({{current}}/{{max}})',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.UPLOAD_IMAGE]: 'Upload image',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.REFERENCE_IMAGE_REJECTED]:
    'Reference images must be JPEG, PNG, or WebP and under 10 MB.',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.PROMPT_TOO_LONG]:
    'Your prompt is too long. Please keep it under {{max}} characters.',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.CANCEL]: 'Cancel',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.PAID_PLAN_DISCLAIMER]:
    'Generative Effects require a paid plan. <upgrade>Upgrade</upgrade> to generate your own.',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.PAID_PLAN_UPGRADE_CTA]: 'Upgrade',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.READY_SNACKBAR]: '{{name}} Effect is ready to use',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.READY_SNACKBAR_VIEW]: 'View',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.DURATION_LABEL]: 'Duration',
  [I18N_KEYS.RECIPE_MAIN.NODES.CUSTOM_GLSL.BACKGROUND_COLOR]: 'Background color',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.CHANNEL]: 'Channel',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.RESET]: 'Reset',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.INPUTS]: 'Inputs',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.OUTPUTS]: 'Outputs',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.HISTOGRAM]: 'Histogram',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.RED]: 'R',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.GREEN]: 'G',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.BLUE]: 'B',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.RGB]: 'RGB',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.NO_HISTOGRAM_DATA]: 'No data',
  [I18N_KEYS.RECIPE_MAIN.NODES.DILATION_EROSION.SIZE]: 'Size',

  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.LEARN_MORE_ABOUT_THIS_MODEL]: 'Learn more about this model',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.LLM_EDITED]: 'edited',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.TOOLTIP]:
    'Render this draft at 1080p. Drafts can be rendered in high res for seven days.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.TOOLTIP_WITH_CREDITS]:
    'Render this draft at 1080p for {{credits}} credits. Drafts can be rendered in high res for seven days.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.DRAFT_MODE]: 'Draft mode',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.DRAFT_MODE_TOOLTIP]:
    'Draft mode previews a Seedance 2.5 clip at 480p and renders the 1080p final from the same draft.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.DRAFT_BADGE]: 'Draft',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.GENERATE_HIGH_RES]: 'Generate high res',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.GENERATING_HIGH_RES]: 'Generating…',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.DRAFTS_ONLY_TOOLTIP]: 'Available for drafts only',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.ITERATORS_TOOLTIP]:
    'Not available when iterators feed this node',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.UNAVAILABLE_TOOLTIP]:
    "This draft can't be rendered in high res. Drafts can be rendered for seven days, and only in the workspace that made them.",
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.RUN_DRAFT]: 'Run draft',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.SEEDANCE_ENHANCE.MODEL_DESCRIPTION]:
    'Draft mode previews a clip at 480p and renders the 1080p final from the same draft.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.IMPORT_APPROVAL.DISCLAIMER]:
    'This is an imported model and requires admin approval before you can run it.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.IMPORT_APPROVAL.REQUEST_APPROVAL_CTA]: 'Request approval',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.IMPORT_APPROVAL.REQUEST_SENT_CTA]: 'Request sent',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.IMPORT_APPROVAL.REQUEST_DENIED_CTA]: 'Request denied',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.IMPORT_APPROVAL.PENDING_TOOLTIP]:
    'Waiting for a {{workspaceName}} admin to review your request to use this model.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.IMPORT_APPROVAL.DENIED_TOOLTIP]:
    'Your {{workspaceName}} admin denied the request to use this model.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.IMPORT_APPROVAL.PANEL_CANNOT_RUN_NOT_REQUESTED]:
    'Cannot run - imported models require admin approval to run',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.IMPORT_APPROVAL.PANEL_CANNOT_RUN_PENDING]:
    'Cannot run - some models are awaiting admin approval',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.IMPORT_APPROVAL.PANEL_CANNOT_RUN_REJECTED]:
    'Cannot run - access to some models was denied by a {{workspaceName}} admin',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.OVERLAY.BATCH]: 'Batch',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ERROR_REQUIRED]: 'Missing inputs: ',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADVANCED_OPTIONS]: 'Advanced options',

  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.LOW_CREDITS_MESSAGE]:
    'You’ve reached your AI credit limit. Your credits will reset on {{date}}.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.LOW_CREDITS_MESSAGE_SHORT]:
    'Not enough credits.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.LOW_CREDITS_MESSAGE_PART_2_FREE]:
    'Upgrade to get more credits.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.LOW_CREDITS_MESSAGE_PART_2_MEMBER]:
    'Contact the workspace admin.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE
    .LOW_CREDITS_MESSAGE_PART_2_GET_MORE_CREDITS_CTA]: 'Get more credits',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.LOW_CREDITS_MESSAGE_OR]: 'or',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE
    .LOW_CREDITS_MESSAGE_PART_3_UPGRADE_CTA]: 'Upgrade.',

  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.FREE_TIER_MESSAGE]:
    '<link>Upgrade plan</link> to get more credits.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.STARTER_PRO_MESSAGE]:
    '<link>Get more credits</link>.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.TEAM_ENTERPRISE_MEMBER_MESSAGE]:
    'Please contact your workspace admin to get more.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.TEAM_ENTERPRISE_ADMIN_MESSAGE]:
    '<link>Get more credits</link>.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.MODEL_NOT_SUPPORTED]:
    'The model type {{modelType}} is not yet supported.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ERROR_MODEL_RUN]: 'Something went wrong. Check inputs',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.NANO_BANANA_PRO_INTERMITTENT_ISSUES]:
    "Google's Nano Banana Pro service is experiencing intermittent issues. We recommend trying an alternative such as Seedream V5, Flux 2 Max, or GPT Image Edit 1.5",
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.IMPORTED_MODEL_PAID_PLAN]:
    'This is an imported model. Upgrade to a paid plan to run imported models.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.IMPORTED_MODEL_PAID_PLAN_UPGRADE_CTA]: 'Upgrade',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.VIDEO_MODEL_PAID_PLAN]:
    'Video models are only available on paid plans.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.EMPTY_ITERATOR]:
    'A connected iterator has no values. Add values, or run the nodes that feed it first.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.BLOCKED_MODEL_PAID_PLAN]:
    'This model is only available on paid plans.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.OUT_OF_CREDITS_BETA]:
    'Not enough Figma Weave beta credits to run. {{window}} credits reset {{date}}.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.TEXT_MODEL.EMPTY_STATE_PLACEHOLDER]:
    'The generated text will appear here',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ANOTHER_IMAGE_INPUT]: 'Add another image input',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ANOTHER_INPUT]: 'Add another input',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT]: 'Add input',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_OPTION_IMAGE]: 'Image',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_OPTION_REFERENCE]: 'Reference',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_OPTION_ELEMENT]: 'Element',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_OPTION_KEYFRAME]: 'Keyframe',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ANOTHER_VIDEO_INPUT]: 'Add another video input',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ANOTHER_IMAGE_INPUT_DISABLED]:
    'This model supports up to {{maxInputs}} {{inputType}}',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_ELEMENT + '_one']: 'element',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_ELEMENT + '_other']: 'elements',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_KEYFRAME + '_one']: 'keyframe',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_KEYFRAME + '_other']: 'keyframes',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_REFERENCE_IMAGE + '_one']:
    'reference image',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_REFERENCE_IMAGE + '_other']:
    'reference images',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_INPUT + '_one']: 'input',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_INPUT + '_other']: 'inputs',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ANOTHER_LORA]: 'Add another LoRA',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ANOTHER_PROMPT]: 'Add another prompt',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ELEMENT]: 'Add element',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_KEYFRAME]: 'Add keyframe',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.RUN]: 'Run Model',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.RUNNING]: 'Running',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.CANCEL_RUN]: 'Cancel Run',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.CANCELLING]: 'Cancelling...',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.INITIALIZING]: 'Starting',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.UPLOADING]: 'Uploading',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.RUNS_TOOLTIP.RUN_LABEL]: 'Run {{index}}',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.RUNS_TOOLTIP.WAITING]: 'Waiting...',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.RUNS_TOOLTIP.DONE]: 'Done',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.RUNS_TOOLTIP.FAILED]: 'Failed',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.RUNS_TOOLTIP.FAILED_REFUNDED]: 'Failed - refunded',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.RUNS_TOOLTIP.CANCELLED]: 'Cancelled',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.RUNS_TOOLTIP.PROGRESS]: '{{percent}}%',

  [I18N_KEYS.RECIPE_MAIN.NODES.SEED.RANDOM]: 'Random',
  [I18N_KEYS.RECIPE_MAIN.NODES.SEED.REFRESH]: 'Generate random seed',
  [I18N_KEYS.RECIPE_MAIN.NODES.SLIDER_WITH_AUTO.AUTO]: 'Auto',
  [I18N_KEYS.RECIPE_MAIN.NODES.SLIDER_WITH_AUTO.AUTO_DURATION]: 'Auto duration',
  [I18N_KEYS.RECIPE_MAIN.NODES.SLIDER_WITH_AUTO.DURATION_DESCRIPTION]:
    'Duration of the video in seconds. Supports {{min}} to {{max}} seconds.',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_HANDLES.ILLEGAL_TYPE_CONNECTION]: 'Wrong input type',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_HANDLES.REQUIRED_VALIDATION_ERROR]: 'Required input',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_HANDLES.CYCLIC_CONNECTION]: 'Circular connections are not allowed',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_HANDLES.EMPTY_REQUIRED_VALIDATION_ERROR]: 'Required input is empty',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_HANDLES.GROUP_OPEN_TOOLTIP]: 'Click to open group',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_HANDLES.GROUP_CLOSE_TOOLTIP]: 'Click to close group',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.UPLOAD_ERROR_INVALID_FILE_TYPE + '_one']:
    '{{count}} file was not added. Only {{fileType}} are allowed in this node.',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.UPLOAD_ERROR_INVALID_FILE_TYPE + '_other']:
    '{{count}} files were not added. Only {{fileType}} are allowed in this node.',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.UPLOAD_ERROR_INVALID_FILE_TYPE_GENERIC + '_one']:
    '{{count}} file was not added due to an invalid file type.',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.UPLOAD_ERROR_INVALID_FILE_TYPE_GENERIC + '_other']:
    '{{count}} files were not added due to invalid file types.',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.ADD_MORE_IMAGES]: 'Add more images',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.ADD_MORE_VIDEOS]: 'Add more videos',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.ADD_MORE_AUDIO]: 'Add more audio files',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.ADD_MORE_3D_FILES]: 'Add more 3D files',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.ADD_MORE_FILES]: 'Add more files',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.IMAGES]: 'images',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.VIDEOS]: 'videos',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.AUDIO]: 'audio files',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.TEXT]: 'texts',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.THREE_D_FILES]: '3D models',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.SORT_ORDER_BY]: 'Order by',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.SORT_DATE_ADDED]: 'Date added',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.SORT_NAME]: 'Name',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.LOADING_3D_MODEL]: 'Loading 3D model',

  [I18N_KEYS.RECIPE_MAIN.NODES.COMPARISON.MODE]: 'Mode',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPARISON.RESET]: 'Reset',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPARISON.TOGGLE]: 'Toggle',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPARISON.SLIDER]: 'Slider',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPARISON.IMAGE]: 'Image',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPARISON.VIDEO]: 'Video',

  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.NEW_NODE]: 'New node',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.DOWNLOAD_ALL]: 'Download all',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.CLEAR_ALL_ASSETS]: 'Clear all',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.GROUP_ACTIONS]: 'Group',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.DUPLICATE]: 'Duplicate',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.LABEL_SIZE]: 'Label size',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.LABEL_SIZE_OPTIONS.SMALL]: 'Small',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.LABEL_SIZE_OPTIONS.MEDIUM]: 'Medium',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.LABEL_SIZE_OPTIONS.LARGE]: 'Large',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.LOCK]: 'Lock',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.UNLOCK]: 'Unlock',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.UNGROUP]: 'Ungroup',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.DELETE]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.RESIZE_TO_FIT]: 'Resize to fit',

  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.DELETE_ALL]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CLEAR]: 'Clear',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CLEAR_ALL_ASSETS]: 'Clear all',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CLEAR_ALL_BUT_SELECTED]: 'Clear all but selected',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.DOWNLOAD_ALL]: 'Download all',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.DUPLICATE]: 'Duplicate',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CUT]: 'Cut',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.GROUP_SELECTION]: 'Group selection',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CREATE_IMAGE_ITERATOR]: 'Create image iterator',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CREATE_VIDEO_ITERATOR]: 'Create video iterator',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CONCAT_VIDEOS]: 'Concat videos',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CREATE_TEXT_ITERATOR]: 'Create text iterator',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.LOCK_ALL]: 'Lock',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.UNLOCK_ALL]: 'Unlock',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.ALIGN]: 'Align',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.ALIGN_AUTO]: 'Auto',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.ALIGN_LEFT]: 'Left',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.ALIGN_CENTER_HORIZONTAL]: 'Center',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.ALIGN_RIGHT]: 'Right',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.ALIGN_TOP]: 'Top',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.ALIGN_CENTER_VERTICAL]: 'Center',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.ALIGN_BOTTOM]: 'Bottom',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.DISTRIBUTE_VERTICAL_SPACING]: 'Distribute vertical spacing',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.DISTRIBUTE_HORIZONTAL_SPACING]: 'Distribute horizontal spacing',

  [I18N_KEYS.TEMPLATE_GALLERY.TITLE]: 'Choose a workflow to start with',
  [I18N_KEYS.TEMPLATE_GALLERY.CLOSE_ARIA]: 'Close template gallery',
  [I18N_KEYS.TEMPLATE_GALLERY.SELECT_TEMPLATE_ARIA]: 'Start with {{name}}',
  [I18N_KEYS.TEMPLATE_GALLERY.ONBOARDING_CREDITS_TOAST]: 'You have {{amount}} credits to try this workflow',
  [I18N_KEYS.TEMPLATE_GALLERY.TEMPLATES.MODEL_COMPARISON.NAME]: 'Compare models',
  [I18N_KEYS.TEMPLATE_GALLERY.TEMPLATES.MODEL_COMPARISON.DESCRIPTION]: 'Compare the same prompt across image models',
  [I18N_KEYS.TEMPLATE_GALLERY.TEMPLATES.SCALING_CONTENT.NAME]: 'Scale your content',
  [I18N_KEYS.TEMPLATE_GALLERY.TEMPLATES.SCALING_CONTENT.DESCRIPTION]:
    'Easily turn one idea into multiple versions, formats, or languages',
  [I18N_KEYS.TEMPLATE_GALLERY.TEMPLATES.FRAME_TO_VIDEO.NAME]: 'Turn images into videos',
  [I18N_KEYS.TEMPLATE_GALLERY.TEMPLATES.FRAME_TO_VIDEO.DESCRIPTION]:
    'Transform any still image into a dynamic video clip',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.PANEL_TITLE]: 'Version history',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.PANEL_TOOLTIP]:
    'History updates on a schedule. Weave periodically checks your workflow for changes and saves a new version if any are found.',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.CURRENT_VERSION]: 'Current version',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.EMPTY_STATE]: 'No previous versions yet.',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.LOAD_ERROR]: 'Could not load versions.',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.RETRY]: 'Retry',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.FORK_NAME_TEMPLATE]: '{{name}} (copy)',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.BANNER.TITLE]: "You're viewing a previous version",
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.BANNER.TITLE_CURRENT]: "You're viewing the current version",
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.BANNER.RESTORE]: 'Restore',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.BANNER.SAVE_AS_NEW]: 'Duplicate',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.RESTORE_DIALOG.TITLE]: 'Restore this version?',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.RESTORE_DIALOG.MESSAGE]:
    'Your current workflow will be replaced with this version. Before we replace it, we will save your current work as a new version, so you can restore it later if needed.',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.RESTORE_DIALOG.CONFIRM]: 'Restore',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.RESTORE_DIALOG.CANCEL]: 'Cancel',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.RESTORE_SUCCESS]: 'Version restored',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.RESTORE_ERROR]: 'Could not restore this version.',
  [I18N_KEYS.RECIPE_MAIN.VERSION_HISTORY.SAVE_AS_NEW_ERROR]: 'Could not save as new workflow.',

  [I18N_KEYS.SETTINGS.DELETE_ACCOUNT]: 'Delete Account',
  [I18N_KEYS.SETTINGS.BACK_TO_HOME_ARIA]: 'Back to home',
  [I18N_KEYS.SETTINGS.MENU.MEMBERS]: 'Members',
  [I18N_KEYS.SETTINGS.MENU.API_KEYS]: 'Provider API Keys',
  [I18N_KEYS.SETTINGS.MENU.WEAVE_API_KEYS]: 'API Tokens',
  [I18N_KEYS.SETTINGS.MENU.MODEL_MANAGEMENT]: 'Model Management',
  [I18N_KEYS.SETTINGS.MENU.FONTS]: 'Fonts',
  [I18N_KEYS.SETTINGS.MENU.PROFILE]: 'Profile',
  [I18N_KEYS.SETTINGS.MENU.SIGNOUT]: 'Sign out',
  [I18N_KEYS.SETTINGS.MENU.WORKSPACE_SETTINGS]: 'Settings & Billing',

  [I18N_KEYS.SETTINGS.FONTS.TITLE]: 'Manage fonts',
  [I18N_KEYS.SETTINGS.FONTS.DESCRIPTION]:
    'Add custom fonts to use in your projects. Figma Weave supports TTF and OTF files.',
  [I18N_KEYS.SETTINGS.FONTS.ADD]: 'Add',
  [I18N_KEYS.SETTINGS.FONTS.EMPTY]: 'Add a font to use in Weave.',
  [I18N_KEYS.SETTINGS.FONTS.LOAD_FAILED]: 'Could not load fonts. Try again later.',
  [I18N_KEYS.SETTINGS.FONTS.RETRY]: 'Retry',
  [`${I18N_KEYS.SETTINGS.FONTS.STYLE_SUMMARY}_one`]: '{{count}} style: {{styles}}',
  [`${I18N_KEYS.SETTINGS.FONTS.STYLE_SUMMARY}_other`]: '{{count}} styles: {{styles}}',
  [I18N_KEYS.SETTINGS.FONTS.DELETE_ARIA]: 'Delete {{name}}',
  [I18N_KEYS.SETTINGS.FONTS.MANAGED_BY_WEAVE]: 'Manually added by Weave team',
  [I18N_KEYS.SETTINGS.FONTS.ADD_DIALOG.TITLE]: 'Add a font',
  [I18N_KEYS.SETTINGS.FONTS.ADD_DIALOG.OWNERSHIP_INDIVIDUAL]:
    'By checking this box and uploading the font(s), I represent that I have all necessary rights to upload and authorize storage and use of the uploaded font(s) on the Figma Weave platform.',
  [I18N_KEYS.SETTINGS.FONTS.ADD_DIALOG.OWNERSHIP_TEAM]:
    'By checking this box and uploading the font(s), I represent that I have all necessary rights to upload and authorize storage, use, and sharing of the uploaded font(s) on the Figma Weave platform.',
  [I18N_KEYS.SETTINGS.FONTS.ADD_DIALOG.UPLOAD]: 'Add',
  [I18N_KEYS.SETTINGS.FONTS.DELETE_DIALOG.TITLE]: 'Delete {{name}}?',
  [I18N_KEYS.SETTINGS.FONTS.DELETE_DIALOG.MESSAGE]: 'This may impact workflows that use this font.',
  [I18N_KEYS.SETTINGS.FONTS.DELETE_DIALOG.CONFIRM]: 'Delete',
  [I18N_KEYS.SETTINGS.FONTS.SNACKBAR.ADDING]: 'Adding {{name}} to your fonts...',
  [I18N_KEYS.SETTINGS.FONTS.SNACKBAR.ADDED]: '{{name}} added to fonts',
  [I18N_KEYS.SETTINGS.FONTS.SNACKBAR.UNSUPPORTED_TYPE]: 'Use a TTF or OTF file',
  [I18N_KEYS.SETTINGS.FONTS.SNACKBAR.DUPLICATE]: '{{name}} already exists',
  [I18N_KEYS.SETTINGS.FONTS.SNACKBAR.UPLOAD_FAILED]: 'Could not upload {{name}}',
  [I18N_KEYS.SETTINGS.FONTS.SNACKBAR.REQUEST_FAILED]: 'Could not upload fonts. Try again later.',
  [I18N_KEYS.SETTINGS.FONTS.SNACKBAR.DELETE_FAILED]: 'Could not delete fonts. Try again later.',
  [I18N_KEYS.SETTINGS.FONTS.SNACKBAR.DELETING]: 'Deleting fonts...',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TITLE]: 'Models management',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.DESCRIPTION_SHORT]:
    'Figma Weave offers both verified and unverified models to give you flexibility in your creative process.',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.READ_MORE]: 'Read more',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.READ_LESS]: 'Read less',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.AUTO_APPROVE_VERIFIED.LABEL]: 'Auto-approve verified models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.AUTO_APPROVE_VERIFIED.DESCRIPTION]:
    "New verified models are added to your team automatically. You'll be notified by email.",
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.AUTO_APPROVE_VERIFIED.ERROR]: 'Error updating auto-approve setting',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.AUTO_APPROVE_VERIFIED.ARIA]: 'auto-approve verified models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.SETTINGS_PANEL.SETTINGS]: 'Settings',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.SETTINGS_PANEL.AUTO_APPROVE_LABEL]: 'Auto-approve new verified models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.SETTINGS_PANEL.AUTO_APPROVE_DESCRIPTION]:
    'Automatically enable new verified models for your workspace. Get an email when one is added.',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.NOTIFY_VERIFIED.LABEL]: 'Notify about new verified models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.NOTIFY_VERIFIED.DESCRIPTION]:
    'Get an email when a model has been verified by Figma.',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.NOTIFY_VERIFIED.ERROR]: 'Error updating verified model notifications',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.NOTIFY_VERIFIED.ARIA]: 'notify about new verified models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.ENABLE_IMPORTING.LABEL]: 'Enable importing models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.ENABLE_IMPORTING.DESCRIPTION]:
    'Members will be able to request admin approval to import custom models.',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.ENABLE_IMPORTING.ERROR]: 'Error updating model importing setting',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.ENABLE_IMPORTING.ARIA]: 'enable importing models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.SUBTITLE_VERIFIED]: 'Verified models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TEXT_VERIFIED]:
    "Covered by Figma's terms and privacy policies. We have contractual relationships with these providers, which include requirements for how these models protect or use your data (such as prohibiting them from training on your data).",
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.SUBTITLE_UNVERIFIED]: 'Unverified models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TEXT_UNVERIFIED]:
    'Models provided by independent third-parties, which are not controlled by Figma Weave. These models control the data you send them under their own terms, including how they protect or use your data. By approving a model you agree to the model’s own terms and policies provided in the below table.',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.HEADER_NAME]: 'Name',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.HEADER_APPROVED]: 'Approved',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.STATUS]: 'Status',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.ALLOW_MODEL_ARIA]: 'allow model {{name}}',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.TERMS]: 'Terms',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.HEADER_DATE_ADDED]: 'Date added',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.SEARCH_PLACEHOLDER]: 'Search models by name',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.NO_MODELS_FOUND]: 'No models found',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.LINKS.TERMS]: 'Terms',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.LINKS.ADDITIONAL_TERMS]: 'API terms',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.LINKS.PRIVACY]: 'Privacy policy',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.LINKS.MODEL_ORIGIN]: 'Model origin',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.ERROR_UPDATING_APPROVED]: 'Error updating approved list',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.ALL]: 'All',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.ADMIN_APPROVAL.LABEL]: 'Admin approval',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.ADMIN_APPROVAL.APPROVED]: 'Approved',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.ADMIN_APPROVAL.NOT_APPROVED]: 'Blocked',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.STATUS.LABEL]: 'Verified by Figma',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.STATUS.VERIFIED]: 'Verified',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.STATUS.NOT_VERIFIED]: 'Unverified',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.APPROVAL_STATUS.LABEL]: 'Status',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.APPROVAL_STATUS.VERIFIED]: 'Verified by Figma',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.APPROVAL_STATUS.NOT_VERIFIED]: 'Unverified',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.TYPE.LABEL]: 'Type',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.TYPE.USER_REQUESTED]: 'User requested',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.TYPE.SYSTEM_MODELS]: 'System models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.TOGGLE_TOOLTIP_APPROVED]: 'Approved on {{date}} by {{name}}',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.TOGGLE_TOOLTIP_REJECTED]: 'Rejected on {{date}} by {{name}}',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.USER_REQUESTED_TAG]: 'User Requested',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.PENDING_REQUESTS.COUNT_SINGULAR]: '1 model request',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.PENDING_REQUESTS.COUNT_PLURAL]: '{{count}} model requests',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.PENDING_REQUESTS.APPROVE]: 'Approve',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.PENDING_REQUESTS.REJECT]: 'Reject',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.PENDING_REQUESTS.REQUESTED_BY]: 'Requested by',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.PENDING_REQUESTS.REQUESTED_AGO]: 'Requested {{timeAgo}}',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.PENDING_REQUESTS.REQUEST_INTRO]:
    'A member requested to import <bold>{{modelId}}</bold>',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.PENDING_REQUESTS.REVIEW_ERROR]:
    'Failed to update model status. Please try again.',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.IMPORT_MODEL_NOTICE_MODAL.TITLE]: 'Import model notice',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.IMPORT_MODEL_NOTICE_MODAL.BODY_INTRO]:
    "Heads up - you're about to approve importing <bold>{{modelName}}</bold> from outside Figma Weave.",
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.IMPORT_MODEL_NOTICE_MODAL.BODY_DESCRIPTION]:
    'By continuing and clicking "Accept," you take full responsibility for the use of it, including that you are allowed to use it and that it fits your needs.',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.IMPORT_MODEL_NOTICE_MODAL.CANCEL]: 'Cancel',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.IMPORT_MODEL_NOTICE_MODAL.CONFIRM]: 'Accept',

  [I18N_KEYS.SETTINGS.TEAM.ACTIONS_MENU.COPY_INVITE_LINK]: 'Copy Invite Link',
  [I18N_KEYS.SETTINGS.TEAM.ACTIONS_MENU.DELETE]: 'Remove',
  [I18N_KEYS.SETTINGS.TEAM.ACTIONS_MENU.RESEND_INVITE]: 'Resend Invite',
  [I18N_KEYS.SETTINGS.TEAM.ACTIONS_MENU.EDIT_LIMIT]: 'Edit Credits Limit',
  [I18N_KEYS.SETTINGS.TEAM.ACTIVATION_PAGE.ERROR_SUBTITLE]: 'Please contact your team admin.',
  [I18N_KEYS.SETTINGS.TEAM.ACTIVATION_PAGE.ERROR_TITLE]: 'Looks like the activation URL is not valid.',
  [I18N_KEYS.SETTINGS.TEAM.ACTIVATION_PAGE.SUBTITLE]: 'Sign in or sign up with {{email_placeholder}} to join',
  [I18N_KEYS.SETTINGS.TEAM.ACTIVATION_PAGE.TITLE]: 'Join {{workspace_placeholder}} on Figma Weave!',
  [I18N_KEYS.SETTINGS.TEAM.CONFIRM_DELETE.CONFIRM]: 'Remove member',
  [I18N_KEYS.SETTINGS.TEAM.CONFIRM_DELETE.TITLE]: 'Remove member',
  [I18N_KEYS.SETTINGS.TEAM.EMPTY_STATE.CTA]: 'Add Your First Member',
  [I18N_KEYS.SETTINGS.TEAM.EMPTY_STATE.TITLE]: 'No one to weave with yet...',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.ENTERPRISE_SEAT_LIMIT_EXCEEDED]:
    'You have exceeded the number of seats in your plan. A Figma Weave representative will contact you in order to manage the plan according to your needs.',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SEATS + '_one']: '1 available seat',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SEATS + '_other']: '{{count}} available seats',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SEATS + '_zero']: '0 available seats, but you can add more.',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SEATS_ZERO_SUBTITLE]:
    'New invites increase your seat count automatically.',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SUCCESS_MESSAGE + '_one']: 'Member added successfully',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SUCCESS_MESSAGE + '_other']: 'Members added successfully',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TEAM_SEAT_LIMIT_EXCEEDED_PART_1 + '_one']:
    'You have exceeded the number of seats in your plan. Adding an extra member\nwill cost',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TEAM_SEAT_LIMIT_EXCEEDED_PART_1 + '_other']:
    'You have exceeded the number of seats in your plan. Adding {{count}} extra members\nwill cost',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TEAM_SEAT_LIMIT_EXCEEDED_PART_2_MONTHLY]:
    ' ${{costPerSeat}} per seat/month.\n',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TEAM_SEAT_LIMIT_EXCEEDED_PART_2_YEARLY]:
    ' ${{costPerSeat}} per seat/year.\n',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TEAM_SEAT_LIMIT_EXCEEDED_PART_3]:
    "You'll be charged only for the days left in this billing period, and the full amount\nwill apply on your next bill.",
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TITLE]: 'Invite Team Members',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SUCCESS_MESSAGE]: 'Invitation resent successfully',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.INVITE_ERROR]: 'Error sending invite to {{emails}}',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.PENDING_INVITATION_ERROR + '_one']:
    '{{emails}} already has a pending invite',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.PENDING_INVITATION_ERROR + '_other']:
    '{{emails}} already have pending invites',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.ALREADY_MEMBER_ERROR + '_one']:
    '{{emails}} already has access to this workspace',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.ALREADY_MEMBER_ERROR + '_other']:
    '{{emails}} already have access to this workspace',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.PARTIAL_SUCCESS + '_one']: '{{count}} invite sent successfully',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.PARTIAL_SUCCESS + '_other']: '{{count}} invites sent successfully',
  [I18N_KEYS.SETTINGS.TEAM.JOIN_TEAM_SUCCESS]: "You've successfully joined the team!",
  [I18N_KEYS.SETTINGS.TEAM.REMOVE_MEMBER_DIALOG.CONTENT]:
    'Are you sure you want to remove {{email}} from this workspace?\nThey will lose access to all projects and resources in this workspace immediately.\nTheir folders and files will be transferred to you.',
  [I18N_KEYS.SETTINGS.TEAM.REMOVE_MEMBER_DIALOG.INVITED_CONTENT]:
    'Are you sure you want to cancel the invitation for {{email}}?\nThey will no longer be able to join this workspace.',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.ADD_MEMBERS_BUTTON]: 'Invite new members',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.DOWNLOAD_MEMBERS_USAGE_BUTTON]: 'Download members usage',
  [I18N_KEYS.SETTINGS.TEAM.MEMBERS_REPORT_MODAL.TITLE]: 'Download members usage',
  [I18N_KEYS.SETTINGS.TEAM.MEMBERS_REPORT_MODAL.TIME_PERIOD_LABEL]: 'Select time period',
  [I18N_KEYS.SETTINGS.TEAM.MEMBERS_REPORT_MODAL.DATE_RANGE_CURRENT_CYCLE]: 'Current billing cycle',
  [I18N_KEYS.SETTINGS.TEAM.MEMBERS_REPORT_MODAL.DATE_RANGE_LAST_30_DAYS]: 'Last 30 days',
  [I18N_KEYS.SETTINGS.TEAM.MEMBERS_REPORT_MODAL.DATE_RANGE_LAST_90_DAYS]: 'Last 90 days',
  [I18N_KEYS.SETTINGS.TEAM.MEMBERS_REPORT_MODAL.CANCEL_BUTTON]: 'Cancel',
  [I18N_KEYS.SETTINGS.TEAM.MEMBERS_REPORT_MODAL.DOWNLOAD_BUTTON]: 'Download',
  [I18N_KEYS.SETTINGS.TEAM.MEMBERS_REPORT_MODAL.ERROR_MESSAGE]: 'Failed to download members usage report',
  [I18N_KEYS.SETTINGS.TEAM.MEMBERS_REPORT_MODAL.LAST_ACTIVE_INFO_BANNER]:
    'Last active data available starting June 28, 2026',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.SELECT_ALL_MEMBERS_ARIA]: 'select all members',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.HEADER_NAME]: 'Name',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.HEADER_ROLE]: 'Role',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.HEADER_STATUS]: 'Status',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.HEADER_LAST_ACTIVE]: 'Last active',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.INVITATION_EXPIRED]: 'Invitation expired',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.LAST_ACTIVE_TOOLTIP]: 'Data available starting June 28, 2026',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.HEADER_CREDITS]: 'Credits',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.HEADER_USAGE]: 'Monthly usage',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.TABLE_TITLE_SUFFIX]: 'Members',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.EDIT_LIMIT_MODAL.TITLE]: 'Edit monthly credit allocation',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.EDIT_LIMIT_MODAL.SUBTITLE]:
    'Set the amount of credits allocated to these members every month.',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.SELECTED_MEMBERS_COUNT]: '{{count}} selected',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.ALLOCATED_CREDITS]: 'Edit credits limit',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.RESET_TO_DEFAULT]: 'Reset to default credits limit',
  [I18N_KEYS.SETTINGS.TEAM.ROLES.ADMIN]: 'Admin',
  [I18N_KEYS.SETTINGS.TEAM.ROLES.MEMBER]: 'Member',
  [I18N_KEYS.SETTINGS.TEAM.UPGRADE.TEXT]:
    "Your current plan is a personal plan and doesn't support adding additional members. In order to create together, upgrade your plan.",
  [I18N_KEYS.SETTINGS.TEAM.UPGRADE.TITLE]: 'Upgrade required for team features',
  [I18N_KEYS.SETTINGS.TEAM.USER_STATUS.ACTIVE]: 'Active',
  [I18N_KEYS.SETTINGS.TEAM.USER_STATUS.INVITED]: 'Invited',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_CREDITS]: 'Credits:',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_CREDITS_CTA]: 'Get more',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_MEMBERS_CAN_SEE_CREDITS]: 'Members can see credits',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_NAME]: 'Workspace Name:',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_NAME_CHANGE]: 'Change Name',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_NAME_PLACEHOLDER]: 'Workspace Name',
  [I18N_KEYS.SETTINGS.TEAM.YOU]: 'You',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS.UPGRADE_CTA]: 'Get more credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS.UPGRADE_CTA_FREE_TOOLTIP]:
    'Upgrade plan to purchase additional credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.PAGE_TITLE]: 'Provider API Keys',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.PAGE_DESCRIPTION]:
    'To use your own accounts to run models in Weave, connect API keys from your providers.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.COLUMN_PROVIDER]: 'Provider',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.COLUMN_CREDENTIALS]: 'Credentials',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.COLUMN_STATUS]: 'Status',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.EDIT]: 'Edit',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_KEY_ARIA]: 'Delete API key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.ADD_KEY_ARIA]: 'Add API key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.ADD_TOOLTIP]: 'Add',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_TOOLTIP]: 'Delete',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.ENABLE_TOOLTIP]: 'Enable',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISABLE_TOOLTIP]: 'Disable',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.INPUT_LABEL]: 'API Key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.KEY_LABEL]: 'Enter API key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.SAVE]: 'Save',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.CANCEL]: 'Cancel',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.LOAD_FAILED]: 'Could not load API key settings. Try again later.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.OPERATION_FAILED]:
    'Something went wrong. Check your permissions and try again.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.TITLE]: 'Delete this API key?',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.BODY]:
    'This will result in the provider’s models running on Weave’s native connections instead of your own.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.CANCEL]: 'Cancel',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.CONFIRM]: 'Delete',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.TITLE]: 'Heads up — your provider’s terms apply',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.HEADS_UP]:
    "You're about to add your own provider API key.",
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.BODY]:
    "By clicking <bold>Continue</bold> and adding your own key, you agree that Figma's model verification and data use protections do not apply and that your agreement with the provider governs your use of their models.",
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.CONTINUE]: 'Continue',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.API_KEY_LABEL]: 'API Key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_SERVICE_EMAIL_LABEL]: 'Service Email',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_SERVICE_EMAIL_PLACEHOLDER]:
    'service-account@project.iam.gserviceaccount.com',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_PROJECT_ID_LABEL]: 'Project ID',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_PROJECT_ID_PLACEHOLDER]: 'my-google-project',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_PRIVATE_KEY_LABEL]: 'Private Key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_PRIVATE_KEY_PLACEHOLDER]: '-----BEGIN PRIVATE KEY-----',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.PROVIDERS.GOOGLE]: 'Google',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.PROVIDERS.FAL]: 'Fal',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.PROVIDERS.OPENAI]: 'OpenAI',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.PAGE_TITLE]: 'API Tokens',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.PAGE_DESCRIPTION]:
    'Issue API tokens for calling api.weavy.ai. Each token is scoped to this workspace and tied to the Figma plan it was created under.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.PAGE_DESCRIPTION_DOCS]:
    'Learn what you can build with our API documentation <docsLink>here</docsLink>.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.BETA]: 'Beta',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.OPERATION_FAILED]: 'Something went wrong. Please try again.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TABLE_EMPTY]: 'No tokens yet',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TABLE_NAME]: 'Name',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TABLE_SUFFIX]: 'Suffix',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TABLE_OWNER]: 'Owner',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TABLE_CREATED_AT]: 'Created',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TABLE_LAST_USED]: 'Last used',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.REVOKE]: 'Revoke',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.SEARCH_PLACEHOLDER]: 'Search token',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.SEARCH_NO_MATCH]: 'No tokens match your search.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.EXPIRES_IN_DAYS + '_one']: 'Expires in {{count}} day',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.EXPIRES_IN_DAYS + '_other']: 'Expires in {{count}} days',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.EXPIRES_IN_MONTHS + '_one']: 'Expires in {{count}} month',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.EXPIRES_IN_MONTHS + '_other']: 'Expires in {{count}} months',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.EXPIRES_IN_YEAR]: 'Expires in 1 year',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.EXPIRED_ON]: 'Expired {{date}}',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.REVOKED_ON]: 'Revoked {{date}}',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.STATUS_ACTIVE]: 'Active',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.STATUS_EXPIRED]: 'Expired',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.STATUS_REVOKED]: 'Revoked',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.REVOKE_CONFIRM.TITLE]: 'Revoke {{name}}',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.REVOKE_CONFIRM.BODY_QUESTION]:
    'Are you sure you want to revoke this API token?',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.REVOKE_CONFIRM.BODY_WARNING]:
    'Any integration using it will stop working immediately. This action cannot be undone.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.REVOKE_CONFIRM.CANCEL]: 'Cancel',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.REVOKE_CONFIRM.CONFIRM]: 'Revoke',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TERMS_MODAL.TITLE]: 'API - Figma Weave Developer Terms',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TERMS_MODAL.BODY_SUBJECT]:
    'Use of this API is subject to the Figma Weave Developer Terms.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TERMS_MODAL.BODY_CONSENT]:
    'By clicking “Accept,” you agree to the <termsLink>Figma Weave Developer Terms</termsLink>.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TERMS_MODAL.CANCEL]: 'Cancel',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TERMS_MODAL.CONFIRM]: 'Accept',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.TERMS_MODAL.FAILED]:
    'Couldn’t record your acceptance. Please try again.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_NEW]: 'Generate API token',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_DISABLED_AT_LIMIT]:
    'You can have up to {{max}} active API tokens at once. Revoke one to generate a new token.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.TITLE]: 'Generate API token',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.NAME_LABEL]: 'Name*',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.NAME_PLACEHOLDER]: 'New token name',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.EXPIRATION_LABEL]: 'Expiration*',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.EXPIRATION_HINT]:
    'This token will expire on {{date}}',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.EXPIRATION_30D]: '30 days',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.EXPIRATION_90D]: '3 months',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.EXPIRATION_365D]: '1 year',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.CREATE]: 'Generate',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.CANCEL]: 'Cancel',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.SHOWN_ONCE_TITLE]: 'Your token has been created',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.SHOWN_ONCE_BODY]:
    'Use this token and its secret to make API calls for your workspace resources. Learn what you can build with our API documentation <docsLink>here</docsLink>.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.SHOWN_ONCE_WARNING_TITLE]:
    'Copy this secret and store it securely',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.SHOWN_ONCE_WARNING_BODY]:
    'You won’t be able to see the secret once you close this window. If you lose it, you’ll need to generate a new secret.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.COPIED]: 'Copied',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.COPY_TOKEN_TOOLTIP]: 'Copy token',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.DONE]: 'Done',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.WEAVE_API_KEYS.CREATE_MODAL.COPY_FAILED]:
    'Couldn’t copy automatically — select the token and copy it manually.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.TITLE]: 'Allocation',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.DEFAULT_ALLOCATION_LABEL]:
    'Default monthly credits allocation',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.UNLIMITED]: 'Unlimited',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.EDIT_DEFAULT_ALLOCATION_CTA]: 'Edit default limit',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.TITLE]:
    'Default monthly credit allocation',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.SUBTITLE]:
    'Set the amount of credits allocated to each member every month.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.CTA_CONFIRM]:
    'Apply changes',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.BUTTON_UNLIMITED_TITLE]:
    'No limit',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.BUTTON_UNLIMITED_SUBTITLE]:
    'Give users unlimited access to credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.BUTTON_LIMIT_TITLE]:
    'Limited credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.BUTTON_LIMIT_SUBTITLE]:
    'Give users a fixed amount of monthly credits.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.CREDITS_ESTIMATION_TEXT]:
    '~ {{estimatedImages}} images or {{estimatedVideos}} seconds of video',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.AMOUNT_LABEL]: 'Amount',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.FORM.NAME]: 'Name',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.FORM.GENERAL]: 'General',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.VOICE_INPUT.TITLE]: 'Voice input',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.VOICE_INPUT.LABEL]: 'Voice transcription',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.VOICE_INPUT.DESCRIPTION]:
    'Allow members to dictate prompts with voice transcription. Transcriptions are powered by OpenAI.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_TITLE]: 'Credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CURRENT_AMOUNT]: 'Current amount',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.REMAINING_MONTHLY_CREDITS_TEXT]: '{{availableMonthlyCredits}} monthly credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.EXTRA_CREDITS_TEXT]: '{{totalExtraCredits}} purchased credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.ROLLOVER_CREDITS_TEXT]: '{{totalRolloverCredits}} rollover credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDIT_THRESHOLD_ALERTS_TITLE]: 'Low credits alerts',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDIT_THRESHOLD_ALERTS_SUBTITLE]:
    'Get notified when workspace credits fall below a set threshold',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDIT_THRESHOLD_ALERTS_ERROR]: 'Failed to update low credits alerts',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.LOW_CREDITS_ALERTS_ARIA]: 'low credits alerts',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.PLAN]: 'Plan',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.SEATS]: 'Seats',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.SEATS_SUFFIX]: 'used',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.RENEWAL_DATE]: 'Renewal date',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.EXPIRATION_DATE]: 'Expiration date',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.DOWNGRADE_TEXT]: 'Plan will change to {{plan}}',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.MONTHLY_CREDITS]: 'Monthly credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.MONTHLY_CREDITS_TOOLTIP_RESET]:
    'Credits are allocated monthly and reset every month.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.MONTHLY_CREDITS_TOOLTIP_ROLLOVER]:
    'Credits are allocated monthly and roll over for up to 3 months.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.UPGRADE]: 'Upgrade plan',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.MANAGE_BILLING]: 'Manage billing',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN]: 'Cancel plan',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN_DIALOG.TITLE]: 'Cancel plan?',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN_DIALOG.MESSAGE + '_rollover']:
    "If you cancel, you'll lose access to your monthly and rolled-over credits when your current plan period ends on {{end_date}}.",
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN_DIALOG.MESSAGE + '_no_rollover']:
    "If you cancel, you'll lose access to your monthly credits when your current plan period ends on {{end_date}}.",

  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN_DIALOG.CONFIRM]: 'Cancel anyway',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN_DIALOG.CANCEL]: 'Keep plan',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.DOWNLOAD_CREDITS_REPORT]: 'Download credits usage history',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.TITLE]: 'Download credits usage history',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.TIME_PERIOD_LABEL]: 'Select time period',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.DATE_RANGE_CURRENT_CYCLE]: 'Current billing cycle',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.DATE_RANGE_LAST_30_DAYS]: 'Last 30 days',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.DATE_RANGE_LAST_90_DAYS]: 'Last 90 days',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.DATE_RANGE_ALL_TIME]: 'All time',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.CANCEL_BUTTON]: 'Cancel',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.DOWNLOAD_BUTTON]: 'Download',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.ERROR_MESSAGE]: 'Failed to download credits usage report',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CONTACT_US_PART_1]: 'Looking for an enterprise solution?',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CONTACT_US_PART_2]: 'Contact us',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CHANGE_PLAN]: 'Change plan',

  [I18N_KEYS.SHARED_DESIGN_APP.ACTIVATION_PAGE.DEFAULT_ERROR]:
    'Invalid or expired link. Please contact the sender for a new link.',
  [I18N_KEYS.SHARED_DESIGN_APP.ACTIVATION_PAGE.TITLE]: 'Activating recipe, please wait...',
  [I18N_KEYS.SHARED_DESIGN_APP.EDIT_DESIGN_APP_BUTTON]: 'Keep Editing',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.DEFAULTS_COMMENT]: 'Set the default values for all users:',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.HEADER.ADD_DESCRIPTION]: '+ Add a description',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.HEADER.ADD_DESCRIPTION_PLAIN]: 'Add a description',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.HEADER.DESCRIPTION_PLACEHOLDER]: 'A meaningful description of this input',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.HEADER.DISABLED]: 'Disabled',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.HEADER.ENABLED]: 'Enabled',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.PARAMS_DRAWER.SET_AS_INPUT]: 'Set as input',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.PROMPT.PLACEHOLDER]: 'Give a prompt example',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.ARRAY_HELPER]: 'Use comma for multiple entries',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.REQUIRED_ERROR]: 'This field is required',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.REQUIRED_ERROR_FILE]: 'File is required',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.REQUIRED_ERROR_LORA]: 'Please select a LoRA',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.REQUIRED_ERROR_TEXT_ITERATOR]: 'At least one option is required',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.REQUIRED_ERROR_MEDIA_ITERATOR]: 'At least one file is required',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.SET_AS_PARAMETER]: 'Set as parameter',
  [I18N_KEYS.SHARED_DESIGN_APP.MODAL.BUTTON_CTA]: 'Generate one-time link',
  [I18N_KEYS.SHARED_DESIGN_APP.MODAL.DEFAULT_ERROR]: 'Failed to generate share link. Please try again.',
  [I18N_KEYS.SHARED_DESIGN_APP.MODAL.LINK_COPIED]: 'Link Copied!',
  [I18N_KEYS.SHARED_DESIGN_APP.MODAL.TITLE]: 'Share Design Tool',
  [I18N_KEYS.SHARED_DESIGN_APP.NO_INPUTS.TIP]: 'Connect the Output node to your workflow',
  [I18N_KEYS.SHARED_DESIGN_APP.NO_INPUTS.TITLE]: 'No inputs found',
  [I18N_KEYS.SHARED_DESIGN_APP.CREATE_TOOL_MODAL.TITLE]: 'Create tool',
  [I18N_KEYS.SHARED_DESIGN_APP.CREATE_TOOL_MODAL.THUMBNAIL]: 'Thumbnail',
  [I18N_KEYS.SHARED_DESIGN_APP.CREATE_TOOL_MODAL.NAME]: 'Name',
  [I18N_KEYS.SHARED_DESIGN_APP.CREATE_TOOL_MODAL.DESCRIPTION]: 'Description',
  [I18N_KEYS.SHARED_DESIGN_APP.CREATE_TOOL_MODAL.DESCRIPTION_PLACEHOLDER]: 'What does this tool do?',
  [I18N_KEYS.SHARED_DESIGN_APP.CREATE_TOOL_MODAL.SUBMIT]: 'Create',
  [I18N_KEYS.SHARED_DESIGN_APP.CREATE_TOOL_MODAL.REQUIRED_ERROR]: 'Required',
  [I18N_KEYS.SHARED_DESIGN_APP.CREATE_TOOL_MODAL.THUMBNAIL_UPLOAD_FAILED]: "Couldn't upload the thumbnail. Try again.",
  [I18N_KEYS.SHARED_DESIGN_APP.PREVIEW_DESIGN_APP_BUTTON]: 'Preview',
  [I18N_KEYS.SHARED_DESIGN_APP.PUBLISH_DESIGN_APP_BUTTON]: 'Create tool',
  [I18N_KEYS.SHARED_DESIGN_APP.UPDATE_TOOL_BUTTON]: 'Update tool',
  [I18N_KEYS.SHARED_DESIGN_APP.PUBLISH_DESIGN_APP_FAILED]: 'Tool creation failed!',
  [I18N_KEYS.SHARED_DESIGN_APP.PUBLISH_DESIGN_APP_SUCCESS]: 'Tool created!',
  [I18N_KEYS.SHARED_DESIGN_APP.UPDATE_TOOL_SUCCESS]: 'Tool updated!',
  [I18N_KEYS.SHARED_DESIGN_APP.UPDATE_TOOL_FAILED]: 'Tool update failed!',
  [I18N_KEYS.SHARED_DESIGN_APP.TOOLBAR.CURRENT_VERSION]: 'Current',
  [I18N_KEYS.SHARED_DESIGN_APP.TOOLBAR.LAST_PUBLISHED_AT]: 'Last Published At',
  [I18N_KEYS.SHARED_DESIGN_APP.TOOLBAR.LATEST_VERSION]: 'Latest Version',
  [I18N_KEYS.SHARED_DESIGN_APP.TOOLBAR.NO_VERSIONS]: 'Ready to release?',
  [I18N_KEYS.SHARED_DESIGN_APP.TOOLBAR.VIEW_VERSION]: 'View',
  [I18N_KEYS.SHARED_DESIGN_APP.NUMBER_OF_RUNS]: 'Number of Results',

  [I18N_KEYS.SHARED_ASSET_VIEW.GO_TO_WORKFLOW]: 'Go to workflow',
  [I18N_KEYS.SHARED_ASSET_VIEW.SHARED]: 'shared',
  [I18N_KEYS.SHARED_ASSET_VIEW.DASHBOARD_ARIA]: 'Dashboard',
  [I18N_KEYS.SHARED_ASSET_VIEW.LOADING]: 'Loading…',
  [I18N_KEYS.SHARED_ASSET_VIEW.UNAVAILABLE]: 'This asset is unavailable.',

  // [I18N_KEYS.SHARE_WORKFLOW_MODAL.EMAIL_LABEL]: 'Email Address',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.EMAIL_PLACEHOLDER]: 'example@email.com',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.INPUTS.PROMPT_PLACEHOLDER]: 'Describe your image',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.LINK.ANYONE]: 'Anyone with a link can view',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.LINK.RESTRICTED]: 'Only invited people can view',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.LINK.TEAM]: 'Anyone in your workspace can view',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ROW_LABEL]: 'Publish to Figma Community',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ROW_LABEL_PUBLISHED]: 'Publish changes to Figma Community',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ROW_UNPUBLISH_BUTTON]: 'Unpublish',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ROW_TOOLTIP_CUSTOM_FONTS]:
    'Replace custom fonts before publishing: {{fonts}}.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ROW_TOOLTIP_FIGMA_NODE]:
    'Remove Figma nodes before publishing to Figma Community.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ROW_TOOLTIP_UNVERIFIED_MODELS]:
    'Remove unverified models to publish: {{models}}',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ROW_TOOLTIP_ENTERPRISE]:
    'Enterprise users can’t publish to Figma Community',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ROW_TOOLTIP_BANNED]:
    'Moderation-banned users can’t publish to community',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ROW_TOOLTIP_ORG_MEMBER]:
    'Users in Figma orgs aren’t allowed to publish to Community',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UPGRADE_UPSELL.MESSAGE]:
    'Upgrade to Starter to publish to Figma Community',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UPGRADE_UPSELL.CTA]: 'Upgrade',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.ROW_LABEL_PUBLISHED]:
    'Published to {{orgName}}',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.ROW_LABEL]: 'Publish to {{orgName}}',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.ROW_LABEL_ORG_UNKNOWN]:
    'Publish to your organization',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.ROW_LABEL_UNLINKED]: 'Publish to Figma',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.ACCESS_MODAL_BODY]:
    "Only invited people can currently view this tool. When you publish to {{orgName}}, we'll update access to <bold>anyone in your Weave workspace</bold>.",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.PICKER_LABEL]: 'Organization',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.FOOTER_INFO]:
    'The published version of this tool will be shared with {{orgName}}.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.SUCCESS_SUBHEADER]:
    'You did it—thanks for putting your work out there, and sharing your talents with {{orgName}}.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.PUBLISHING_STATUS]:
    'Publishing to {{orgName}}...',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.OPEN_IN_FIGMA]: 'Open in Figma Design',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.LOOKUP_FAILED_TOOLTIP]:
    'Couldn’t load your Figma organizations. Close Share and try again.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.ROW_TOOLTIP_FIGMA_NODE]:
    'Remove Figma nodes before publishing to {{orgName}}.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.ROW_TOOLTIP_FIGMA_NODE_ORG_UNKNOWN]:
    'Remove Figma nodes before publishing to your organization.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.DESCRIPTION_PLACEHOLDER]:
    "What's this tool for? Get specific so people in {{orgName}} know what it can do.",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ORG_DESTINATION.ACCESS_LOCKED_TOOLTIP]:
    'Unpublish this tool from your organization before limiting access to invited people.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ACCESS_LOCKED_TOOLTIP]:
    'Unpublish to update access settings',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ACCESS_MODAL.TITLE]: 'Update access and publish?',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ACCESS_MODAL.BODY]:
    "Only invited people can currently view this file. When you publish to Figma Community, we'll update access to <bold>Anyone</bold>.",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ACCESS_MODAL.BODY_WORKSPACE]:
    "Only your workspace can currently view this file. When you publish to Figma Community, we'll update access to <bold>Anyone</bold>.",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ACCESS_MODAL.CONFIRM]: 'Publish',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.TITLE_PUBLISH]: 'Publish workflow',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.TITLE_PUBLISH_TOOL]: 'Publish tool',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.STEPS.DESCRIPTION]: 'Write a description',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.STEPS.IMAGES]: 'Choose some images',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.STEPS.DETAILS]: 'Add the final details',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DESCRIPTION_STEP.NAME_LABEL]: 'Name',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DESCRIPTION_STEP.DESCRIPTION_LABEL]: 'Description',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DESCRIPTION_STEP.DESCRIPTION_PLACEHOLDER]:
    "What's this workflow for? Get specific so the Figma Community knows what it can do.",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DESCRIPTION_STEP.DESCRIPTION_PLACEHOLDER_TOOL]:
    "What's this tool for? Get specific so the Figma Community knows what it can do.",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DESCRIPTION_STEP.CATEGORY_LABEL]: 'Subcategory',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DESCRIPTION_STEP.CATEGORY_PLACEHOLDER]:
    'Select a subcategory',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DESCRIPTION_STEP.TAGS_LABEL]: 'Select up to 5 tags',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.THUMBNAIL_LABEL]:
    'Choose an image for your workflow',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.THUMBNAIL_LABEL_TOOL]:
    'Choose an image for your tool',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.ICON_LABEL]:
    'Choose an icon for your tool',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.ICON_RECOMMENDED_SIZE]:
    'Recommended size: 128 x 128px',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.GALLERY_LABEL]:
    'Choose up to 9 images to display below the thumbnail',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.RECOMMENDED_SIZE]:
    'Recommended size: 1920 x 1080px',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.UPLOAD]: 'Upload',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.UPLOAD_IMAGE]: 'Upload image',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.EMAIL_LABEL]: 'Email for support',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.PROFILE_LABEL]:
    'Community profile (Share as)',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.HANDLE_SECTION_LABEL]:
    'Create a handle for your new Community profile',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.HANDLE_SECTION_DESCRIPTION_PREFIX]:
    'You can use up to 15 characters, including letters, numbers, and underscores. Learn more about handles at our ',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.HANDLE_SECTION_GUIDELINES_LINK]:
    'Community guidelines',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.HANDLE_SECTION_DESCRIPTION_SUFFIX]: '.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.HANDLE_AVAILABLE]:
    "'{{handle}}' is available",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.HANDLE_TAKEN]:
    "'{{handle}}' is taken. Try again",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.HANDLE_INVALID_FORMAT]:
    'Use up to 15 letters, numbers, or underscores',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.HANDLE_CHECK_FAILED]:
    "Couldn't check handle availability. Try again.",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.TERMS_LABEL]: 'Terms and Agreement',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.TERMS_AGREE_PREFIX]: 'I agree to the',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.TERMS_LINK]: 'Creator Agreement',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.TERMS_REMINDER]:
    'Publishing on Community is subject to the <agreement>Creator Agreement</agreement>.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.COMMENTS_LABEL]: 'Comments',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.COMMENTS_TOGGLE]:
    'Allow comments from Community members',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.COMPATIBILITY_LABEL]: 'Compatibility',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.COMPATIBILITY_FIGMA_WEAVE]:
    'Figma Weave',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.DETAILS_STEP.COMPATIBILITY_FIGMA_DESIGN]:
    'Figma Design',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.FOOTER.INFO]:
    'Everything on the canvas will be published, including past outputs.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.FOOTER.INFO_TOOL]:
    'The published version of this tool will be shared with the Community.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.FOOTER.BACK]: 'Back',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.FOOTER.NEXT]: 'Next',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.FOOTER.PUBLISH]: 'Publish',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.FOOTER.COPY_LINK]: 'Copy link',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.FOOTER.GO_TO_COMMUNITY]: 'Go to Figma Community',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.FOOTER.GO_BACK]: 'Go back',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.ERRORS.NAME_REQUIRED]: 'Add a name',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.ERRORS.DESCRIPTION_REQUIRED]: 'Add a description',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.ERRORS.CATEGORY_REQUIRED]: 'Select a subcategory',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.ERRORS.IMAGE_REQUIRED]: 'Add a thumbnail image',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.ERRORS.ICON_REQUIRED]: 'Add an icon',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.ERRORS.HANDLE_REQUIRED]:
    'Choose an available Community handle',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.ERRORS.HANDLE_CREATE_FAILED]:
    'We couldn’t create your Community profile. Try again, or reach out to Figma support.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.ERRORS.TERMS_REQUIRED]: 'Agree to the terms',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.TERMINAL.PUBLISHING_STATUSES.PREPARING]:
    'Preparing your workflow...',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.TERMINAL.PUBLISHING_STATUSES.PREPARING_TOOL]:
    'Preparing your tool...',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.TERMINAL.PUBLISHING_STATUSES.UPLOADING]:
    'Uploading images...',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.TERMINAL.PUBLISHING_STATUSES.PUBLISHING]:
    'Publishing to Community...',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.TERMINAL.SUCCESS_HEADER]: "And you're live!",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.TERMINAL.SUCCESS_SUBHEADER]:
    'You did it—thanks for putting your work out there, and sharing your talents with the Figma Community.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.TERMINAL.FAILURE_HEADER]: 'Something went wrong',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.TERMINAL.FAILURE_SUBHEADER]:
    'Try again, or reach out to Figma support.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.TERMINAL.BY_AUTHOR]: 'by {{name}}',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.SNACKBAR.ACCESS_UPDATE_FAILURE]:
    'Failed to update file access. Please try again.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.SNACKBAR.ACCESS_LOCKED_WHILE_PUBLISHED]:
    'Unpublish this workflow from Figma Community before changing access settings.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.SNACKBAR.LINK_SUCCESS]: 'Figma account linked',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.SNACKBAR.LINK_FAILURE]: 'Failed to link Figma account',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.SNACKBAR.LINK_COPIED]: 'Link copied',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.SNACKBAR.MANAGE_IN_SETTINGS]: 'Manage in Settings',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UNPUBLISH.CONFIRM_TITLE]: 'Unpublish workflow?',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UNPUBLISH.CONFIRM_BODY]:
    '{{workflowName}} will be removed from Figma Community. It will stay in your Weave workspace.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UNPUBLISH.CONFIRM_TITLE_TOOL]: 'Unpublish tool?',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UNPUBLISH.CONFIRM_BODY_TOOL]:
    '{{toolName}} will be removed from Figma Community. It will stay in your Weave workspace.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UNPUBLISH.CONFIRM_BODY_TOOL_ORG]:
    '{{toolName}} will be removed from {{orgName}}. It will stay in your Weave workspace.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UNPUBLISH.CONFIRM_ACTION]: 'Unpublish',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UNPUBLISH.SUCCESS_SNACKBAR]:
    'Workflow unpublished from Figma Community',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UNPUBLISH.SUCCESS_SNACKBAR_TOOL]:
    'Tool unpublished from Figma Community',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UNPUBLISH.SUCCESS_SNACKBAR_TOOL_ORG]:
    'Tool unpublished from {{orgName}}',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.UNPUBLISH.FAILURE_SNACKBAR]:
    'Failed to unpublish. Please try again.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.COPY_LINK]: 'Copy link',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.VIEW_IN_COMMUNITY]: 'View in Figma Community',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.UNPUBLISH_MENU_ITEM]:
    'Unpublish from Figma Community',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.UNPUBLISH_MENU_ITEM_ORG]:
    'Unpublish from {{orgName}}',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.PUBLISHED.TITLE]: 'Workflow published.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.PUBLISHED.SUBTITLE]:
    'This file is live in Figma Community.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.PUBLISHED.TITLE_TOOL]: 'Tool published.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.PUBLISHED.SUBTITLE_TOOL]:
    'This is live in Figma Community.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.PUBLISHED.SUBTITLE_TOOL_ORG]:
    'This is live in {{orgName}}.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.PENDING.TITLE]: 'This workflow is under review.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.PENDING.SUBTITLE]:
    "It'll publish to Figma Community if it's approved.",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.PENDING.TITLE_TOOL]: 'This tool is under review.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.PENDING.SUBTITLE_TOOL]:
    "It'll publish to Figma Community if it's approved.",
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.UPDATES_AVAILABLE.TITLE]:
    'This workflow has changed.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.UPDATES_AVAILABLE.SUBTITLE]:
    'Publish your changes to update in Figma Community.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.UPDATES_AVAILABLE.PUBLISH_CHANGES]:
    'Publish changes',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.BANNER.UPDATES_AVAILABLE.RELINK_FIGMA_ACCOUNT]:
    'Reconnect your Figma account to publish updates to Community.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.SHARE_BUTTON]: 'Invite',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.SHARE_BUTTON_LOADING]: 'Sending...',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.SUCCESS_MESSAGE]: 'File shared successfully',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.TITLE]: 'Invite others',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.OWNER]: 'Owner',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.ACCESS_TITLE]: 'Who has access',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.REMOVE]: 'Remove',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_TOOLTIP]: 'Sharing is only available on paid plans',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_PAYWALL.TITLE]: 'Want to share this file?',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_PAYWALL.SEE_ALL_PLANS]: 'See all plans',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_PAYWALL.LOOKING_FOR_MORE]: 'Looking for more?',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_PAYWALL.CURRENT_PLAN.FEATURES.VIDEO_MODELS]: 'No access to video AI models',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_PAYWALL.CURRENT_PLAN.FEATURES.EDITING_TOOLS]:
    'Professional-grade editing tools',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_PAYWALL.CURRENT_PLAN.FEATURES.WORKFLOWS]: '5 workflows',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_PAYWALL.CURRENT_PLAN.FEATURES.HISTORY]: 'No workflow history',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_PAYWALL.TARGET_PLAN.FEATURES.VIDEO_MODELS]:
    'Full access to all AI models, including video generation',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_PAYWALL.TARGET_PLAN.FEATURES.WORKFLOWS]: 'Unlimited workflows',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_PAYWALL.TARGET_PLAN.FEATURES.TOP_UP]: 'Top up at $10 / 1,000 credits',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.TOOL_SCOPE_NOTE]: 'Shares the workflow only.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.TOOL_SCOPE_NOTE_ACTION]: 'For the tool, use Share on the tool itself.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.TOOL_EXPOSED_NOTE]: 'This workflow is exposed by its tool.',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.TOOL_EXPOSED_NOTE_DETAIL]: 'Make sure workflow access rights are suitable.',

  [I18N_KEYS.SIGN_IN_PAGE.CANT_SIGN_IN_MESSAGE]: "Can't sign in? <url>Contact us</url>",
  [I18N_KEYS.SIGN_IN_PAGE.GOOGLE_SIGN_IN_BUTTON]: 'Log in with Google',
  [I18N_KEYS.SIGN_IN_PAGE.MICROSOFT_SIGN_IN_BUTTON]: 'Log in with Microsoft',
  [I18N_KEYS.SIGN_IN_PAGE.FIGMA_SIGN_IN_BUTTON]: 'Log in with Figma',
  [I18N_KEYS.SIGN_IN_PAGE.OR]: 'or',
  [I18N_KEYS.SIGN_IN_PAGE.TITLE]: 'Welcome to Figma Weave',
  [I18N_KEYS.SIGN_IN_PAGE.SUBTITLE]: 'Start building your design machine',
  [I18N_KEYS.SIGN_IN_PAGE.TERMS_TEXT]: 'By clicking "Log in with Google, Figma, or Microsoft", you agree to',
  [I18N_KEYS.SIGN_IN_PAGE.TERMS_OF_SERVICE_LINK]: 'Figma Weave Terms of Service',
  [I18N_KEYS.SIGN_IN_PAGE.PRIVACY_POLICY_LINK]: 'Privacy Policy',
  [I18N_KEYS.SIGN_IN_PAGE.TERMS_MESSAGE]:
    "By clicking “Log in with Google, Figma, or Microsoft”, you agree to <terms>Figma Weave's Terms of Service</terms> and <privacy>Privacy Policy</privacy>.",
  [I18N_KEYS.SIGN_IN_PAGE.SIGN_IN_BLOCKED]: "We couldn't sign you in. Please contact support for help.",
  [I18N_KEYS.SIGN_IN_PAGE.EMAIL_PASSWORD_LOGIN_NOT_ALLOWED]:
    "Email/password login isn't available. Please sign in with Google or Microsoft.",
  [I18N_KEYS.SIGN_IN_PAGE.TURNSTILE_RETRY]: 'Security verification failed. Please try again.',
  [I18N_KEYS.SIGN_IN_PAGE.TURNSTILE_SLOW]:
    'Verification is taking longer than usual. Slow connections can cause this; you can reload the page to try again.',
  [I18N_KEYS.SIGN_IN_PAGE.TURNSTILE_UNAVAILABLE]:
    'The security check can’t run right now. Reload the page to try again.',
  [I18N_KEYS.SIGN_IN_PAGE.SIGNUP_RATE_LIMITED]: "We couldn't create your account right now. Please try again later.",
  [I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_TITLE]: 'Log in with Figma',
  [I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_BODY]: 'By clicking "Continue," you agree to the',
  [I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_ACCEPT_BUTTON]: 'Continue',

  [I18N_KEYS.UPGRADE_MODAL.CTA]: 'Learn more...',
  [I18N_KEYS.UPGRADE_MODAL.TITLE]: 'Buy more credits for our premium models',

  [I18N_KEYS.UPLOAD_LORA_NODE.DEFAULT_WEIGHT]: 'Default Weight',
  [I18N_KEYS.UPLOAD_LORA_NODE.TRIGGER]: 'Trigger',
  [I18N_KEYS.UPLOAD_LORA_NODE.UPLOADING]: 'Uploading...',
  [I18N_KEYS.UPLOAD_LORA_NODE.UPLOAD_ANOTHER_BUTTON_TEXT_FILE]: 'Click to Upload another file',
  [I18N_KEYS.UPLOAD_LORA_NODE.UPLOAD_BUTTON_TEXT]: 'Click to Upload',
  [I18N_KEYS.UPLOAD_LORA_NODE.UPLOAD_TITLE]: 'Upload LoRA',
  [I18N_KEYS.UPLOAD_LORA_NODE.EDIT_TITLE]: 'Edit LoRA',

  [I18N_KEYS.WEAVY_MARKETING.CARDS.SOFT_LAUNCH_INVITE.SUBTITLE]:
    'Give the best creators you know access to Figma Weave.',
  [I18N_KEYS.WEAVY_MARKETING.CARDS.SOFT_LAUNCH_INVITE.TITLE]: 'Invite new Weavers',
  [I18N_KEYS.WEAVY_MARKETING.DASHBOARD_BANNER.SOFT_LAUNCH_INVITE.SUBTITLE]:
    'Bring your creative friends to Figma Weave',
  [I18N_KEYS.WEAVY_MARKETING.DASHBOARD_BANNER.SOFT_LAUNCH_INVITE.TITLE]: 'Invite new Weavers',
  [I18N_KEYS.WEAVY_MARKETING.APP_BANNER.HOLIDAY_PROMO.TITLE]: '5,000 bonus credits with any annual plan*.',
  [I18N_KEYS.WEAVY_MARKETING.APP_BANNER.HOLIDAY_PROMO.SUBTITLE]: 'Go too far. That is what the credits are for.',
  [I18N_KEYS.WEAVY_MARKETING.APP_BANNER.HOLIDAY_PROMO.DISCLAIMER]:
    '* Bonus credits are added on a one time basis, are not part of annual plan, and may only be added once per eligible annual plan purchase or upgrade during the campaign period. Enterprise plans are excluded from the offer. Credits have no cash value and do not apply to past purchases. Team plans receive 5,000 credits per active member added during the offer. The offer ends Nov 30 at 12:00am ET. Figma Weave may adjust or end the offer at any time.',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.CONSENT.TITLE]: 'Get Figma Weave news',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.CONSENT.BODY]:
    'I wish to receive product, service, and event updates from Figma. Unsubscribe anytime.',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.CONSENT.DECLINE]: 'No, thanks',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.CONSENT.ACCEPT]: 'Yes, please',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.CONTENT_BOTTOM]:
    'Grant access to 3 fellow designers and artists who value creativity and mastery as much as you do.',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.CONTENT_TOP]:
    "As one of our first Weavers, you're part of the community shaping the future of creative expression.",
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.ERROR_EMAIL_ALREADY_INVITED]: 'Email already invited',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.INVITE_BUTTON]: 'Invite',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.PLACEHOLDER]: 'name@example.com',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.SENT]: 'Sent',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.TITLE]: 'Invite new Weavers!',

  [I18N_KEYS.VIDEO_PREVIEW.CHANGE_TO_TIMECODE]: 'Change to timecode',
  [I18N_KEYS.VIDEO_PREVIEW.CHANGE_TO_FRAMES]: 'Change to frames',
  [I18N_KEYS.VIDEO_PREVIEW.FRAMES]: 'frames',
  [I18N_KEYS.TASK_MANAGER.TITLE]: 'Task manager',
  [I18N_KEYS.TASK_MANAGER.BATCH_NAME]: 'Batch',
  [I18N_KEYS.TASK_MANAGER.RUNNING_TEXT]: '{{count}} Running',
  [I18N_KEYS.TASK_MANAGER.DONE]: 'Done',
  [I18N_KEYS.TASK_MANAGER.CANCELLED_TEXT]: 'Cancelled',
  [I18N_KEYS.TASK_MANAGER.FAILED_TEXT + '_one']: '{{count}} run failed · refunded',
  [I18N_KEYS.TASK_MANAGER.FAILED_TEXT + '_other']: '{{count}} runs failed · refunded',
  [I18N_KEYS.TASK_MANAGER.FAILED_TEXT_NO_REFUND + '_one']: '{{count}} run failed',
  [I18N_KEYS.TASK_MANAGER.FAILED_TEXT_NO_REFUND + '_other']: '{{count}} runs failed',
  [I18N_KEYS.TASK_MANAGER.FAILED_STILL_RUNNING]: '{{running}} running, {{failed}} failed, {{completed}} done',
  // Legacy (flag-off) copy — verbatim from pre-migration; the flag-off path must render this exactly.
  [I18N_KEYS.TASK_MANAGER.FAILED_TEXT_LEGACY]: '{{failed}} runs failed - Credits refunded',
  [I18N_KEYS.TASK_MANAGER.FAILED_TEXT_NO_REFUND_LEGACY]: '{{failed}} runs failed',
  [I18N_KEYS.TASK_MANAGER.FAILED_STILL_RUNNING_LEGACY]:
    '{{failed}} failed, {{running}} running, {{completed}} completed',
  [I18N_KEYS.TASK_MANAGER.EMPTY_STATE]: 'No active runs',
  [I18N_KEYS.TASK_MANAGER.CLEAR_ALL]: 'Clear all',
  [I18N_KEYS.TASK_MANAGER.NO_ACTIVE_RUNS]: 'No active runs',
  [I18N_KEYS.TASK_MANAGER.TASKS]: 'Tasks',
  [I18N_KEYS.TASK_MANAGER.INITIALIZING]: 'Starting',
  [I18N_KEYS.TASK_MANAGER.UPLOADING]: 'Uploading',
  [I18N_KEYS.TASK_MANAGER.BATCH_COMPLETED]: '{{completed}} / {{total}} Completed',
  [I18N_KEYS.TASK_MANAGER.QUEUED]: 'Queued',

  [I18N_KEYS.SHORTCUTS.PANEL_TITLE]: 'Shortcuts',
  [I18N_KEYS.SHORTCUTS.OR]: 'or',
  [I18N_KEYS.SHORTCUTS.SEARCH_PLACEHOLDER]: 'Search shortcuts',
  [I18N_KEYS.SHORTCUTS.SEARCH_RESULTS]: 'Shortcut search results',
  [I18N_KEYS.SHORTCUTS.SEARCH_NO_RESULTS]: 'No shortcuts match "{{query}}"',
  [I18N_KEYS.SHORTCUTS.SCROLL_TABS_BACK]: 'Show previous tabs',
  [I18N_KEYS.SHORTCUTS.SCROLL_TABS_FORWARD]: 'Show more tabs',
  [I18N_KEYS.SHORTCUTS.RESIZE_PANEL]: 'Resize shortcuts panel',
  [I18N_KEYS.SHORTCUTS.CONTEXTS.WITH_NODES_SELECTED]: 'With nodes selected...',
  [I18N_KEYS.SHORTCUTS.CONTEXTS.WITH_GROUPS_SELECTED]: 'With groups selected...',
  [I18N_KEYS.SHORTCUTS.CONTEXTS.WITH_LAYERS_SELECTED]: 'With layers selected...',
  [I18N_KEYS.SHORTCUTS.CONTEXTS.AFTER_MARKING_SECTIONS]: 'After marking sections...',
  [I18N_KEYS.SHORTCUTS.CONTEXTS.IN_APP_VIEW]: 'In tool view...',
  [I18N_KEYS.SHORTCUTS.CONTEXTS.IN_TIMELINE]: 'In the timeline...',
  [I18N_KEYS.SHORTCUTS.CONTEXTS.WHEN_HOVERING_A_NODE]: 'When hovering a model node...',
  [I18N_KEYS.SHORTCUTS.CONTEXTS.IN_GALLERY]: 'In the gallery...',
  [I18N_KEYS.SHORTCUTS.CONTEXTS.IN_PROMPT]: 'In a prompt...',
  [I18N_KEYS.SHORTCUTS.SECTIONS.VIEW_AND_ZOOM]: 'View and zoom',
  [I18N_KEYS.SHORTCUTS.SECTIONS.NAVIGATION]: 'Navigation',
  [I18N_KEYS.SHORTCUTS.SECTIONS.NODE_ACTIONS]: 'Node actions',
  [I18N_KEYS.SHORTCUTS.SECTIONS.SELECTION]: 'Selection',
  [I18N_KEYS.SHORTCUTS.SECTIONS.CREATION]: 'Creation',
  [I18N_KEYS.SHORTCUTS.SECTIONS.EDITING]: 'Editing',
  [I18N_KEYS.SHORTCUTS.SECTIONS.TIMELINE]: 'Timeline',
  [I18N_KEYS.SHORTCUTS.SECTIONS.COMPOSITOR]: 'Compositor',
  [I18N_KEYS.SHORTCUTS.ZOOM_IN]: 'Zoom in',
  [I18N_KEYS.SHORTCUTS.ZOOM_OUT]: 'Zoom out',
  [I18N_KEYS.SHORTCUTS.ZOOM_100]: 'Zoom to 100%',
  [I18N_KEYS.SHORTCUTS.ZOOM_TO_FIT]: 'Zoom to fit',
  [I18N_KEYS.SHORTCUTS.NAVIGATION_MARK_NODES]: 'Mark section',
  [I18N_KEYS.SHORTCUTS.NAVIGATION_NAVIGATE_TO_NODES]: 'Navigate to section',
  [I18N_KEYS.SHORTCUTS.SELECT_ALL_NODES]: 'Select all nodes',
  [I18N_KEYS.SHORTCUTS.CLEAR_SELECTION]: 'Clear selection',
  [I18N_KEYS.SHORTCUTS.RUN_MODEL]: 'Run next model',
  [I18N_KEYS.SHORTCUTS.GROUP_SELECTION]: 'Group selection',
  [I18N_KEYS.SHORTCUTS.RESIZE_GROUP_TO_FIT]: 'Resize group to fit',
  [I18N_KEYS.SHORTCUTS.MOVE]: 'Move',
  [I18N_KEYS.SHORTCUTS.PAN]: 'Pan',
  [I18N_KEYS.SHORTCUTS.COMMENT_MODE]: 'Comments',
  [I18N_KEYS.SHORTCUTS.TOGGLE_COMMENTS]: 'Show or hide comments',
  [I18N_KEYS.SHORTCUTS.UNDO]: 'Undo',
  [I18N_KEYS.SHORTCUTS.REDO]: 'Redo',
  [I18N_KEYS.SHORTCUTS.SAVE_WORKFLOW]: 'Save',
  [I18N_KEYS.SHORTCUTS.COPY_NODES]: 'Copy nodes',
  [I18N_KEYS.SHORTCUTS.CUT_NODES]: 'Cut nodes',
  [I18N_KEYS.SHORTCUTS.PASTE_NODES]: 'Paste nodes',
  [I18N_KEYS.SHORTCUTS.OPEN_NODE]: 'Open gallery',
  [I18N_KEYS.SHORTCUTS.DUPLICATE_NODES]: 'Duplicate nodes',
  [I18N_KEYS.SHORTCUTS.DUPLICATE_NODES_PRESERVING_INPUTS]: 'Duplicate nodes and preserve inputs',
  [I18N_KEYS.SHORTCUTS.DELETE_SELECTION]: 'Delete selection',
  [I18N_KEYS.SHORTCUTS.DELETE_SELECTION_PRESERVING_CONNECTIONS]: 'Delete and preserve connections',
  [I18N_KEYS.SHORTCUTS.NUDGE_SELECTION]: 'Nudge selection',
  [I18N_KEYS.SHORTCUTS.NUDGE_SELECTION_FAST]: 'Nudge selection faster',
  [I18N_KEYS.SHORTCUTS.OPEN_FLOAT_MENU]: 'Open node menu',
  [I18N_KEYS.SHORTCUTS.OPEN_SHORTCUTS_PANEL]: 'Open keyboard shortcuts',
  [I18N_KEYS.SHORTCUTS.CREATE_IMPORT_NODE]: 'Create import node',
  [I18N_KEYS.SHORTCUTS.CREATE_PROMPT_NODE]: 'Create prompt node',
  [I18N_KEYS.SHORTCUTS.RECTANGLE]: 'Create rectangle',
  [I18N_KEYS.SHORTCUTS.ELLIPSE]: 'Create ellipse',
  [I18N_KEYS.SHORTCUTS.TEXT]: 'Create text',
  [I18N_KEYS.SHORTCUTS.TIMELINE_MOVE_LAYER_START_TO_PLAYHEAD]: 'Move layer start to playhead',
  [I18N_KEYS.SHORTCUTS.TIMELINE_MOVE_LAYER_END_TO_PLAYHEAD]: 'Move layer end to playhead',
  [I18N_KEYS.SHORTCUTS.TIMELINE_MOVE_PLAYHEAD_ONE_FRAME]: 'Move playhead 1 frame',
  [I18N_KEYS.SHORTCUTS.TIMELINE_MOVE_PLAYHEAD_TEN_FRAMES]: 'Move playhead 10 frames',
  [I18N_KEYS.SHORTCUTS.TIMELINE_JUMP_TO_START_END]: 'Jump to start/end of timeline',
  [I18N_KEYS.SHORTCUTS.TIMELINE_PLAY_PAUSE]: 'Play or pause',
  [I18N_KEYS.SHORTCUTS.GROUP_LAYERS]: 'Group selection',
  [I18N_KEYS.SHORTCUTS.UNGROUP_LAYERS]: 'Ungroup selection',
  [I18N_KEYS.SHORTCUTS.DELETE_LAYERS]: 'Delete selection',
  [I18N_KEYS.SHORTCUTS.EXIT_APP_MODE]: 'Back to canvas',
  [I18N_KEYS.SHORTCUTS.PAN_WHILE_DRAGGING]: 'Pan while dragging',
  [I18N_KEYS.SHORTCUTS.ZOOM_WITH_SCROLL]: 'Zoom while scrolling',
  [I18N_KEYS.SHORTCUTS.ZOOM_TOOL_IN]: 'Zoom in where you click',
  [I18N_KEYS.SHORTCUTS.ZOOM_TOOL_OUT]: 'Zoom out where you click',
  [I18N_KEYS.SHORTCUTS.ZOOM_TOOL_AREA]: 'Zoom to the area you drag',
  [I18N_KEYS.SHORTCUTS.GALLERY_PREVIOUS_NEXT]: 'Previous or next item',
  [I18N_KEYS.SHORTCUTS.GALLERY_CLOSE]: 'Close gallery',
  [I18N_KEYS.SHORTCUTS.DUPLICATE_BY_DRAGGING]: 'Duplicate while dragging',
  [I18N_KEYS.SHORTCUTS.CONNECT_BY_PROXIMITY]: 'Connect nearby nodes while dragging',
  [I18N_KEYS.SHORTCUTS.DELETE_CONNECTIONS_BY_DRAGGING]: 'Delete the connections you drag across',
  [I18N_KEYS.SHORTCUTS.REMOVE_FROM_GROUP_BY_DRAGGING]: 'Drag a node out of its group',
  [I18N_KEYS.SHORTCUTS.ADD_TO_SELECTION]: 'Add to or remove from selection',
  [I18N_KEYS.SHORTCUTS.PROMPT_MENTION_INPUT]: 'Reference an input',
  [I18N_KEYS.SHORTCUTS.PROMPT_ACCEPT_SUGGESTION]: 'Accept the suggested prompt',
  [I18N_KEYS.SHORTCUTS.VECTOR_TOOL]: 'Pen tool',
  [I18N_KEYS.SHORTCUTS.TOGGLE_PAN_MODE]: 'Switch between move and pan',
  [I18N_KEYS.SHORTCUTS.SELECT_ALL_LAYERS]: 'Select all layers',
  [I18N_KEYS.SHORTCUTS.PASTE_LAYERS]: 'Paste layers',
  [I18N_KEYS.SHORTCUTS.CLOSE_COMPOSITOR]: 'Close compositor',
  [I18N_KEYS.SHORTCUTS.COPY_LAYERS]: 'Copy selection',
  [I18N_KEYS.SHORTCUTS.DUPLICATE_LAYERS]: 'Duplicate selection',
  [I18N_KEYS.NODES.MODELS.DYNAMIC_HANDLES.IMAGE_URLS.KEY]: 'image_1',
  [I18N_KEYS.NODES.MODELS.DYNAMIC_HANDLES.IMAGE_URLS.DESCRIPTION]: 'Image to edit',

  [I18N_KEYS.CSV_COLUMN_DIALOG.TITLE]: 'Import CSV',
  [I18N_KEYS.CSV_COLUMN_DIALOG.DESCRIPTION]: 'Select columns to use as input values',
  [I18N_KEYS.CSV_COLUMN_DIALOG.COLUMN_LABEL]: 'Columns',
  [I18N_KEYS.CSV_COLUMN_DIALOG.COLUMN_ARIA_LABEL]: 'Select columns',
  [I18N_KEYS.CSV_COLUMN_DIALOG.COLUMN_PLACEHOLDER]: 'Select columns',
  [I18N_KEYS.CSV_COLUMN_DIALOG.CANCEL]: 'Cancel',
  [I18N_KEYS.CSV_COLUMN_DIALOG.CONFIRM]: 'Import',
  [I18N_KEYS.CSV_COLUMN_DIALOG.ERROR_EMPTY]: 'CSV file is empty or has no columns',
  [I18N_KEYS.CSV_COLUMN_DIALOG.ERROR_PARSE]: 'Failed to read CSV file',
  [I18N_KEYS.CSV_COLUMN_DIALOG.WARNING_TRUNCATED]: 'Values limited to {{max}} per column',
  [I18N_KEYS.TOOL_VIEW.RECOVERY.NO_ACCESS_TITLE]: 'You don’t have access to this tool',
  [I18N_KEYS.TOOL_VIEW.RECOVERY.NO_ACCESS_BODY]:
    'The owner hasn’t shared this tool with you. Ask them to share it, or return to your dashboard to open another tool.',
  [I18N_KEYS.TOOL_VIEW.RECOVERY.NOT_FOUND_TITLE]: 'This tool can’t be found',
  [I18N_KEYS.TOOL_VIEW.RECOVERY.NOT_FOUND_BODY]:
    'This link doesn’t lead to an available tool. Check the link with the person who shared it, or open another tool from your dashboard.',
  [I18N_KEYS.TOOL_VIEW.RECOVERY.LOAD_ERROR_TITLE]: 'We couldn’t load this tool',
  [I18N_KEYS.TOOL_VIEW.RECOVERY.LOAD_ERROR_BODY]:
    'Try loading the tool again. If it still won’t open, return to your dashboard and try again later.',
  [I18N_KEYS.TOOL_VIEW.RECOVERY.UNAVAILABLE_TITLE]: 'This tool isn’t running anymore',
  [I18N_KEYS.TOOL_VIEW.RECOVERY.UNAVAILABLE_BODY]:
    'The workflow behind this tool was deleted. If you own this tool, create a new tool from an available workflow. Otherwise, ask the owner for a new tool link.',
  [I18N_KEYS.TOOL_VIEW.RECOVERY.RUN_LOAD_ERROR_BODY]:
    'The run details aren’t available right now.\nTry loading them again.',
  [I18N_KEYS.TOOL_VIEW.RECOVERY.BACK_TO_DASHBOARD]: 'Back to dashboard',
  [I18N_KEYS.TOOL_VIEW.RECOVERY.RETRY]: 'Retry',
  [I18N_KEYS.TOOL_VIEW.REQUIRED_FIELDS + '_one']: 'Complete the {{count}} required field to run',
  [I18N_KEYS.TOOL_VIEW.REQUIRED_FIELDS + '_other']: 'Complete the {{count}} required fields to run',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.UPLOAD_ERROR_HELP]:
    'Try uploading the file again, or choose another file.',
  [I18N_KEYS.TOOL_VIEW.NOT_FOUND]: 'Tool not found.',
  [I18N_KEYS.TOOL_VIEW.LOAD_ERROR]: 'Something went wrong loading this tool.',
  [I18N_KEYS.TOOL_VIEW.COULDNT_LOAD]: 'Couldn’t load this tool.',
  [I18N_KEYS.TOOL_VIEW.UNAVAILABLE_TITLE]: 'This tool is unavailable',
  [I18N_KEYS.TOOL_VIEW.UNAVAILABLE_BODY]: 'Its underlying workflow was deleted.',
  [I18N_KEYS.TOOL_VIEW.UNTITLED]: 'Untitled tool',
  [I18N_KEYS.TOOL_VIEW.RUN]: 'Run',
  [I18N_KEYS.TOOL_VIEW.RE_RUN]: 'Re-run',
  [I18N_KEYS.TOOL_VIEW.SIGN_IN_TO_RUN]: 'Sign in to run',
  [I18N_KEYS.TOOL_VIEW.PREVIEW_NOTICE]: 'You’re previewing this tool',
  [I18N_KEYS.TOOL_VIEW.PREVIEW_OUTPUTS_NOT_SAVED]: 'Preview outputs won’t be saved.',
  [I18N_KEYS.TOOL_VIEW.LAST_PUBLISHED]: 'Last published {{date}}',
  [I18N_KEYS.TOOL_VIEW.PREVIEW_PUBLISH]: 'Tool published!',
  [I18N_KEYS.TOOL_VIEW.BACK_TO_EDITING]: 'Back to editing',
  [I18N_KEYS.TOOL_VIEW.OPEN_WORKFLOW]: 'Go to workflow',
  [I18N_KEYS.TOOL_VIEW.HIDE_SIDEBAR]: 'Hide sidebar',
  [I18N_KEYS.TOOL_VIEW.SHOW_SIDEBAR]: 'Show sidebar',
  [I18N_KEYS.TOOL_VIEW.VIEW_TOOL]: 'Go to tool',
  [I18N_KEYS.TOOL_VIEW.BY_AUTHOR]: 'By <author>{{author}}</author>',
  [I18N_KEYS.TOOL_VIEW.EMPTY_TITLE]: 'Create your first generation',
  [I18N_KEYS.TOOL_VIEW.EMPTY_SUBTITLE]: 'Add the required inputs, then select Run.',
  [I18N_KEYS.TOOL_VIEW.EXAMPLE_OUTPUTS]: 'Example outputs',
  [I18N_KEYS.TOOL_VIEW.SHOW_ALL_EXAMPLES]: 'Show all',
  [I18N_KEYS.TOOL_VIEW.OPEN_EXAMPLE]: 'Open example {{number}}',
  [I18N_KEYS.TOOL_SHARE.TITLE]: 'Share tool',
  [I18N_KEYS.TOOL_SHARE.ACCESS_TITLE]: 'Who can access',
  [I18N_KEYS.TOOL_SHARE.EMAIL_PLACEHOLDER]: 'Add emails, name, or user groups',
  [I18N_KEYS.TOOL_SHARE.SUCCESS_MESSAGE]: 'Tool shared successfully',
  // The workflow toolbar button that opens the share modal.
  [I18N_KEYS.TOOL_SHARE.SHARE_BUTTON]: 'Share tool',
  // The modal's own submit button - it grants people access, it does not publish anything.
  [I18N_KEYS.TOOL_SHARE.INVITE_BUTTON]: 'Invite',
  [I18N_KEYS.TOOL_SHARE.PUBLISH_FIRST]: 'Create this tool to share it',
  [I18N_KEYS.TOOL_SHARE.ERROR_MESSAGE]: 'Something went wrong while sharing. Please try again.',
  [I18N_KEYS.TOOL_SHARE.WORKFLOW_SCOPE_NOTE]: 'Shares the tool only.',
  [I18N_KEYS.TOOL_SHARE.WORKFLOW_SCOPE_NOTE_ACTION]: 'To share the workflow, use Share in the canvas instead.',
  [I18N_KEYS.TOOL_SHARE.WORKFLOW_EXPOSED_NOTE]: 'This tool exposes the underlying workflow to viewers.',
  [I18N_KEYS.TOOL_SHARE.WORKFLOW_EXPOSED_NOTE_DETAIL]: 'Make sure workflow access rights are suitable.',
  [I18N_KEYS.COMMUNITY_EMBED_TOOL.MISSING_TOOL_ID]: 'Missing tool id.',
  [I18N_KEYS.COMMUNITY_EMBED_TOOL.SIGN_IN_REQUIRED]: 'Sign in to preview this tool.',
  [I18N_KEYS.COMMUNITY_EMBED_WORKFLOW.MISSING_WORKFLOW_ID]: 'Missing workflow id.',
  [I18N_KEYS.COMMUNITY_EMBED_WORKFLOW.SIGN_IN_REQUIRED]: 'Sign in to preview this workflow.',
  [I18N_KEYS.SECURITY_CHALLENGE.TITLE]: 'Confirm you’re human',
  [I18N_KEYS.SECURITY_CHALLENGE.BODY]: 'Complete the quick security check to continue.',
  [I18N_KEYS.SECURITY_CHALLENGE.SLOW_NOTICE_TITLE]: 'Verification is taking longer than usual',
  [I18N_KEYS.SECURITY_CHALLENGE.SLOW_NOTICE_BODY]:
    'Slow connections can cause this. This message closes on its own if the check finishes, or you can reload the page to try again.',
  [I18N_KEYS.SECURITY_CHALLENGE.FAILURE_ERROR_TITLE]: 'Verification failed',
  [I18N_KEYS.SECURITY_CHALLENGE.FAILURE_ERROR_BODY]:
    'We couldn’t complete the security check. Reload the page to try again.',
  [I18N_KEYS.SECURITY_CHALLENGE.FAILURE_UNAVAILABLE_TITLE]: 'Verification is unavailable',
  [I18N_KEYS.SECURITY_CHALLENGE.FAILURE_UNAVAILABLE_BODY]:
    'The security check can’t run right now. Reload the page to try again.',
  [I18N_KEYS.SECURITY_CHALLENGE.FAILURE_EXHAUSTED_TITLE]: 'Couldn’t complete verification',
  [I18N_KEYS.SECURITY_CHALLENGE.FAILURE_EXHAUSTED_BODY]:
    'We couldn’t verify you after several tries. Reload the page to try again.',
  [I18N_KEYS.SECURITY_CHALLENGE.FAILURE_CIRCUIT_OPEN_TITLE]: 'Verification is temporarily unavailable',
  [I18N_KEYS.SECURITY_CHALLENGE.FAILURE_CIRCUIT_OPEN_BODY]:
    'We’re having trouble completing verification right now. Reload the page to try again in a moment.',
  [I18N_KEYS.SECURITY_CHALLENGE.FAILURE_BROWSER_HELP]: 'Still stuck? Learn how to configure your browser.',
  [I18N_KEYS.SECURITY_CHALLENGE.RELOAD]: 'Reload',
  [I18N_KEYS.SECURITY_CHALLENGE.INTERACTIVE_HELP]: 'Having trouble? Reload the page to try again.',
  [I18N_KEYS.TOOLKIT.BANNER_TITLE]: 'Find your next way to create',
  [I18N_KEYS.TOOLKIT.BANNER_SUBTITLE]:
    'Discover tools and AI models to generate images, create videos, and edit your work',
  [I18N_KEYS.TOOLKIT.SEARCH_PLACEHOLDER]: 'Search tools',
  [I18N_KEYS.TOOLKIT.USE_TOOL]: 'Use tool',
  [I18N_KEYS.TOOLKIT.SHOW_ALL]: 'Show all',
  [I18N_KEYS.TOOLKIT.SHOW_LESS]: 'Show less',
  [I18N_KEYS.TOOLKIT.PREVIOUS_IN_ROW]: 'Previous {{row}} tools',
  [I18N_KEYS.TOOLKIT.NEXT_IN_ROW]: 'Next {{row}} tools',
  [I18N_KEYS.TOOLKIT.NO_RESULTS_TITLE]: 'No tools found',
  [I18N_KEYS.TOOLKIT.NO_RESULTS]: 'No tools match “{{searchTerm}}”.',
  [I18N_KEYS.TOOLKIT.EXPLORE_ALL]: 'Explore all tools',
  [I18N_KEYS.TOOLKIT.LOAD_FAILED]: 'Explore could not load',
  [I18N_KEYS.TOOLKIT.TOOL_NOT_FOUND]: 'Tool not found',
  [I18N_KEYS.TOOLKIT.GENERATOR_TITLE]: 'Create with leading AI models',
  [I18N_KEYS.TOOLKIT.GENERATOR_SUBTITLE]: 'Browse image and video models in one place to bring your ideas to life',
  [I18N_KEYS.TOOLKIT.GENERATOR_IMAGES_TITLE]: 'Images',
  [I18N_KEYS.TOOLKIT.GENERATOR_IMAGES_DESCRIPTION]: 'Generate images from text and explore new visual directions',
  [I18N_KEYS.TOOLKIT.GENERATOR_IMAGES_ACTION]: 'Generate images',
  [I18N_KEYS.TOOLKIT.GENERATOR_VIDEOS_TITLE]: 'Videos',
  [I18N_KEYS.TOOLKIT.GENERATOR_VIDEOS_DESCRIPTION]: 'Generate video from text or animate an existing image',
  [I18N_KEYS.TOOLKIT.GENERATOR_VIDEOS_ACTION]: 'Generate videos',
  [I18N_KEYS.GENERATE_PAGE.HOME]: 'Weavy home',
  [I18N_KEYS.GENERATE_PAGE.BACK]: 'Back',
  [I18N_KEYS.GENERATE_PAGE.BACK_TO]: 'Back to {{page}}',
  [I18N_KEYS.GENERATE_PAGE.TITLE]: 'What would you like to create?',
  [I18N_KEYS.GENERATE_PAGE.SUBTITLE]:
    'Start with a template or write a prompt. Choose from leading image and video models',
  [I18N_KEYS.GENERATE_PAGE.LOADING]: 'Loading',
  [I18N_KEYS.GENERATE_PAGE.LOAD_ERROR]: 'Could not load this page.',
  [I18N_KEYS.GENERATE_PAGE.RUN_ERROR_TITLE]: 'Generation failed',
  [I18N_KEYS.GENERATE_PAGE.RUN_ERROR_RETRY]: 'Try again.',
  [I18N_KEYS.GENERATE_PAGE.RUN_ERROR_SOME]: '{{failed}} of {{total}} outputs couldn’t be generated.',
  [I18N_KEYS.GENERATE_PAGE.HISTORY_ERROR_TITLE]: 'Couldn’t load your earlier results',
  [I18N_KEYS.GENERATE_PAGE.CANCEL_ERROR_TITLE]: 'Couldn’t cancel',
  [I18N_KEYS.GENERATE_PAGE.LOAD_MORE]: 'Load more',
  [I18N_KEYS.GENERATE_PAGE.PROMPT_BLOCKED_TITLE]: 'Prompt blocked by a safety filter.',
  [I18N_KEYS.GENERATE_PAGE.PROMPT_BLOCKED_MESSAGE]: 'Edit it and try again.',
  [I18N_KEYS.GENERATE_PAGE.NOT_ENOUGH_CREDITS_TITLE]: 'Not enough credits to run this model.',
  [I18N_KEYS.GENERATE_PAGE.UPGRADE_LINK]: 'upgrade',
  [I18N_KEYS.GENERATE_PAGE.MODEL_NOT_FOUND]: 'This model is not available.',
  [I18N_KEYS.GENERATE_PAGE.PROMPT_LABEL]: 'Prompt',
  [I18N_KEYS.GENERATE_PAGE.PROMPT_PLACEHOLDER]: 'Describe your idea. Attach a design to guide the result',
  [I18N_KEYS.GENERATE_PAGE.OUTPUT_TYPE]: 'Output type',
  [I18N_KEYS.GENERATE_PAGE.IMAGE]: 'Image',
  [I18N_KEYS.GENERATE_PAGE.VIDEO]: 'Video',
  [I18N_KEYS.GENERATE_PAGE.IMAGE_OUTPUT]: 'Image output',
  [I18N_KEYS.GENERATE_PAGE.VIDEO_OUTPUT]: 'Video output',
  [I18N_KEYS.GENERATE_PAGE.MODEL]: 'Model',
  [I18N_KEYS.GENERATE_PAGE.MODEL_SELECTION]: 'Model selection',
  [I18N_KEYS.GENERATE_PAGE.SELECT_MODEL]: 'Select a model',
  [I18N_KEYS.GENERATE_PAGE.ATTACH]: 'Add reference',
  [I18N_KEYS.GENERATE_PAGE.REMOVE_ATTACHMENT]: 'Remove {{name}}',
  [I18N_KEYS.GENERATE_PAGE.REFERENCE_SLOT]: 'Reference',
  [I18N_KEYS.GENERATE_PAGE.REFERENCE_NAME]: 'Reference {{index}}',
  [I18N_KEYS.GENERATE_PAGE.RESULT_NAME]: 'Result {{index}}',
  [I18N_KEYS.GENERATE_PAGE.FIRST_FRAME]: 'First frame',
  [I18N_KEYS.GENERATE_PAGE.LAST_FRAME]: 'Last frame',
  [I18N_KEYS.GENERATE_PAGE.ADD_FIRST_FRAME]: 'Add first frame',
  [I18N_KEYS.GENERATE_PAGE.ADD_LAST_FRAME]: 'Add last frame',
  [I18N_KEYS.GENERATE_PAGE.FROM_GALLERY]: 'From this gallery',
  [I18N_KEYS.GENERATE_PAGE.UPLOAD_FILE]: 'Upload a file',
  [I18N_KEYS.GENERATE_PAGE.CONFIRM]: 'Confirm',
  [I18N_KEYS.GENERATE_PAGE.MAX_IMAGES_REACHED]: 'Max of {{max}} images reached',
  [I18N_KEYS.GENERATE_PAGE.MAX_REFERENCES_REACHED]: 'Max of {{max}} references reached',
  [I18N_KEYS.GENERATE_PAGE.PANEL_MAX_IMAGES]: '{{max}} images max',
  [I18N_KEYS.GENERATE_PAGE.PANEL_MAX_REFERENCES]: '{{max}} references max',
  [I18N_KEYS.GENERATE_PAGE.PANEL_MAX_VIDEOS]: '{{max}} videos max',
  [I18N_KEYS.GENERATE_PAGE.IMAGE_MAX_REACHED]: 'Reference image max reached',
  [I18N_KEYS.GENERATE_PAGE.REFERENCE_MAX_REACHED]: 'Reference max reached',
  [I18N_KEYS.GENERATE_PAGE.VIDEO_MAX_REACHED]: 'Video max reached',
  [I18N_KEYS.GENERATE_PAGE.UP_TO_IMAGES]: 'It is possible to add up to {{max}} images',
  [I18N_KEYS.GENERATE_PAGE.UP_TO_REFERENCES]: 'It is possible to add up to {{max}} references',
  [I18N_KEYS.GENERATE_PAGE.UP_TO_VIDEOS]: 'It is possible to add up to {{max}} videos',
  [I18N_KEYS.GENERATE_PAGE.MAX_UPLOAD_REACHED]: 'Max upload reached',
  [I18N_KEYS.GENERATE_PAGE.TRY_FEWER_IMAGES]: 'Try {{max}} images or less',
  [I18N_KEYS.GENERATE_PAGE.TRY_FEWER_FILES]: 'Try {{max}} files or less',
  [I18N_KEYS.GENERATE_PAGE.TRY_FEWER_VIDEOS]: 'Try {{max}} videos or less',
  [I18N_KEYS.GENERATE_PAGE.WRONG_TYPE + '_one']:
    '{{count}} file was not added. Only {{types}} are allowed for this model.',
  [I18N_KEYS.GENERATE_PAGE.WRONG_TYPE + '_other']:
    '{{count}} files were not added. Only {{types}} are allowed for this model.',
  [I18N_KEYS.GENERATE_PAGE.WRONG_IMAGE_FORMAT + '_one']:
    '{{count}} file was not added. Only JPEG, PNG, WebP and HEIC images are supported.',
  [I18N_KEYS.GENERATE_PAGE.WRONG_IMAGE_FORMAT + '_other']:
    '{{count}} files were not added. Only JPEG, PNG, WebP and HEIC images are supported.',
  [I18N_KEYS.GENERATE_PAGE.FRAME_TAKES_ONE + '_one']: '{{count}} file was not added. Each frame takes one image.',
  [I18N_KEYS.GENERATE_PAGE.FRAME_TAKES_ONE + '_other']: '{{count}} files were not added. Each frame takes one image.',
  [I18N_KEYS.GENERATE_PAGE.TYPES_IMAGES]: 'images',
  [I18N_KEYS.GENERATE_PAGE.TYPES_IMAGES_AND_VIDEOS]: 'images and videos',
  [I18N_KEYS.GENERATE_PAGE.TYPES_MEDIA]: 'images, videos and audio',
  [I18N_KEYS.GENERATE_PAGE.INPUTS_REMOVED]: 'Some inputs were removed',
  [I18N_KEYS.GENERATE_PAGE.MODEL_DOESNT_TAKE]: '{{model}} doesn’t take them.',
  [I18N_KEYS.GENERATE_PAGE.FIRST_FRAME_NEEDED]: 'First frame needed',
  [I18N_KEYS.GENERATE_PAGE.ADD_FIRST_FRAME_FIRST]: 'Add a first frame to use a last frame',
  [I18N_KEYS.GENERATE_PAGE.PARAM_VALUE]: '{{title}}, {{value}}',
  [I18N_KEYS.GENERATE_PAGE.ON]: 'On',
  [I18N_KEYS.GENERATE_PAGE.OFF]: 'Off',
  [I18N_KEYS.GENERATE_PAGE.SECONDS_VALUE]: '{{value}}s',
  [I18N_KEYS.GENERATE_PAGE.SECONDS_UNIT]: 'Sec',
  [I18N_KEYS.GENERATE_PAGE.MORE_SETTINGS]: 'More settings',
  [I18N_KEYS.GENERATE_PAGE.ENABLE]: 'Enable',
  [I18N_KEYS.GENERATE_PAGE.DISABLE]: 'Disable',
  [I18N_KEYS.GENERATE_PAGE.RANDOM_SEED]: 'Random',
  [I18N_KEYS.GENERATE_PAGE.AUTO_DURATION]: 'Auto duration',
  [I18N_KEYS.GENERATE_PAGE.AUTO_VALUE]: 'Auto',
  [I18N_KEYS.GENERATE_PAGE.UPGRADE_TAG]: 'Upgrade',
  [I18N_KEYS.GENERATE_PAGE.NEW_TAG]: 'New',
  [I18N_KEYS.GENERATE_PAGE.PAID_PLANS_ONLY]: 'Available on paid plans',
  [I18N_KEYS.GENERATE_PAGE.COUNT]: 'Number of results',
  [I18N_KEYS.GENERATE_PAGE.DECREASE_COUNT]: 'Decrease number of results',
  [I18N_KEYS.GENERATE_PAGE.INCREASE_COUNT]: 'Increase number of results',
  [I18N_KEYS.GENERATE_PAGE.GENERATE]: 'Generate',
  [I18N_KEYS.GENERATE_PAGE.SIGN_IN_TO_RUN]: 'Sign in to run',
};

export default EN_TEXT;
